/*!
 * jquery.min.js
 *
 * jQuery v3.6.0 | (c) jQuery Foundation | jquery.org/license/*!
 * jquery.min.js
 *
 * jQuery v3.6.0 | (c) jQuery Foundation | jquery.org/license
 */
/*! jQuery v3.6.0 | (c) OpenJS Foundation and other contributors | jquery.org/license */ ! function(t, e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function(t) {
        if (!t.document) throw Error("jQuery requires a window with a document");
        return e(t)
    } : e(t)
}("undefined" != typeof window ? window : this, function(t, e) {
    "use strict";
    var i = [],
        n = Object.getPrototypeOf,
        o = i.slice,
        s = i.flat ? function(t) {
            return i.flat.call(t)
        } : function(t) {
            return i.concat.apply([], t)
        },
        r = i.push,
        a = i.indexOf,
        l = {},
        c = l.toString,
        u = l.hasOwnProperty,
        d = u.toString,
        p = d.call(Object),
        h = {},
        f = function(t) {
            return "function" == typeof t && "number" != typeof t.nodeType && "function" != typeof t.item
        },
        g = function(t) {
            return null != t && t === t.window
        },
        v = t.document,
        m = {
            type: !0,
            src: !0,
            nonce: !0,
            noModule: !0
        };

    function y(t, e, i) {
        var n, o, s = (i = i || v).createElement("script");
        if (s.text = t, e)
            for (n in m)(o = e[n] || e.getAttribute && e.getAttribute(n)) && s.setAttribute(n, o);
        i.head.appendChild(s).parentNode.removeChild(s)
    }

    function $(t) {
        return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? l[c.call(t)] || "object" : typeof t
    }
    var b = "3.6.0",
        x = function(t, e) {
            return new x.fn.init(t, e)
        };

    function T(t) {
        var e = !!t && "length" in t && t.length,
            i = $(t);
        return !f(t) && !g(t) && ("array" === i || 0 === e || "number" == typeof e && 0 < e && e - 1 in t)
    }
    x.fn = x.prototype = {
        jquery: b,
        constructor: x,
        length: 0,
        toArray: function() {
            return o.call(this)
        },
        get: function(t) {
            return null == t ? o.call(this) : t < 0 ? this[t + this.length] : this[t]
        },
        pushStack: function(t) {
            var e = x.merge(this.constructor(), t);
            return e.prevObject = this, e
        },
        each: function(t) {
            return x.each(this, t)
        },
        map: function(t) {
            return this.pushStack(x.map(this, function(e, i) {
                return t.call(e, i, e)
            }))
        },
        slice: function() {
            return this.pushStack(o.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        even: function() {
            return this.pushStack(x.grep(this, function(t, e) {
                return (e + 1) % 2
            }))
        },
        odd: function() {
            return this.pushStack(x.grep(this, function(t, e) {
                return e % 2
            }))
        },
        eq: function(t) {
            var e = this.length,
                i = +t + (t < 0 ? e : 0);
            return this.pushStack(0 <= i && i < e ? [this[i]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: r,
        sort: i.sort,
        splice: i.splice
    }, x.extend = x.fn.extend = function() {
        var t, e, i, n, o, s, r = arguments[0] || {},
            a = 1,
            l = arguments.length,
            c = !1;
        for ("boolean" == typeof r && (c = r, r = arguments[a] || {}, a++), "object" == typeof r || f(r) || (r = {}), a === l && (r = this, a--); a < l; a++)
            if (null != (t = arguments[a]))
                for (e in t) n = t[e], "__proto__" !== e && r !== n && (c && n && (x.isPlainObject(n) || (o = Array.isArray(n))) ? (i = r[e], s = o && !Array.isArray(i) ? [] : o || x.isPlainObject(i) ? i : {}, o = !1, r[e] = x.extend(c, s, n)) : void 0 !== n && (r[e] = n));
        return r
    }, x.extend({
        expando: "jQuery" + (b + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw Error(t)
        },
        noop: function() {},
        isPlainObject: function(t) {
            var e, i;
            return !(!t || "[object Object]" !== c.call(t)) && (!(e = n(t)) || "function" == typeof(i = u.call(e, "constructor") && e.constructor) && d.call(i) === p)
        },
        isEmptyObject: function(t) {
            var e;
            for (e in t) return !1;
            return !0
        },
        globalEval: function(t, e, i) {
            y(t, {
                nonce: e && e.nonce
            }, i)
        },
        each: function(t, e) {
            var i, n = 0;
            if (T(t))
                for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++);
            else
                for (n in t)
                    if (!1 === e.call(t[n], n, t[n])) break;
            return t
        },
        makeArray: function(t, e) {
            var i = e || [];
            return null != t && (T(Object(t)) ? x.merge(i, "string" == typeof t ? [t] : t) : r.call(i, t)), i
        },
        inArray: function(t, e, i) {
            return null == e ? -1 : a.call(e, t, i)
        },
        merge: function(t, e) {
            for (var i = +e.length, n = 0, o = t.length; n < i; n++) t[o++] = e[n];
            return t.length = o, t
        },
        grep: function(t, e, i) {
            for (var n = [], o = 0, s = t.length, r = !i; o < s; o++) !e(t[o], o) !== r && n.push(t[o]);
            return n
        },
        map: function(t, e, i) {
            var n, o, r = 0,
                a = [];
            if (T(t))
                for (n = t.length; r < n; r++) null != (o = e(t[r], r, i)) && a.push(o);
            else
                for (r in t) null != (o = e(t[r], r, i)) && a.push(o);
            return s(a)
        },
        guid: 1,
        support: h
    }), "function" == typeof Symbol && (x.fn[Symbol.iterator] = i[Symbol.iterator]), x.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
        l["[object " + e + "]"] = e.toLowerCase()
    });
    var _ = function(t) {
        var e, i, n, o, s, r, a, l, c, u, d, p, h, f, g, v, m, y, $, b = "sizzle" + 1 * new Date,
            x = t.document,
            T = 0,
            _ = 0,
            w = tc(),
            k = tc(),
            S = tc(),
            C = tc(),
            E = function(t, e) {
                return t === e && (d = !0), 0
            },
            A = {}.hasOwnProperty,
            L = [],
            j = L.pop,
            D = L.push,
            O = L.push,
            H = L.slice,
            z = function(t, e) {
                for (var i = 0, n = t.length; i < n; i++)
                    if (t[i] === e) return i;
                return -1
            },
            P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            N = "[\\x20\\t\\r\\n\\f]",
            I = "(?:\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            q = "\\[" + N + "*(" + I + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + N + "*\\]",
            W = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + q + ")*)|.*)\\)|)",
            R = RegExp(N + "+", "g"),
            M = RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g"),
            B = RegExp("^" + N + "*," + N + "*"),
            F = RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"),
            U = RegExp(N + "|>"),
            X = RegExp(W),
            Y = RegExp("^" + I + "$"),
            G = {
                ID: RegExp("^#(" + I + ")"),
                CLASS: RegExp("^\\.(" + I + ")"),
                TAG: RegExp("^(" + I + "|[*])"),
                ATTR: RegExp("^" + q),
                PSEUDO: RegExp("^" + W),
                CHILD: RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)", "i"),
                bool: RegExp("^(?:" + P + ")$", "i"),
                needsContext: RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)", "i")
            },
            Q = /HTML$/i,
            V = /^(?:input|select|textarea|button)$/i,
            K = /^h\d$/i,
            J = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            tt = /[+~]/,
            te = RegExp("\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\([^\\r\\n\\f])", "g"),
            ti = function(t, e) {
                var i = "0x" + t.slice(1) - 65536;
                return e || (i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320))
            },
            tn = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            to = function(t, e) {
                return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
            },
            ts = function() {
                p()
            },
            tr = tx(function(t) {
                return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase()
            }, {
                dir: "parentNode",
                next: "legend"
            });
        try {
            O.apply(L = H.call(x.childNodes), x.childNodes), L[x.childNodes.length].nodeType
        } catch (ta) {
            O = {
                apply: L.length ? function(t, e) {
                    D.apply(t, H.call(e))
                } : function(t, e) {
                    for (var i = t.length, n = 0; t[i++] = e[n++];);
                    t.length = i - 1
                }
            }
        }

        function tl(t, e, n, o) {
            var s, a, c, u, d, f, m, y = e && e.ownerDocument,
                x = e ? e.nodeType : 9;
            if (n = n || [], "string" != typeof t || !t || 1 !== x && 9 !== x && 11 !== x) return n;
            if (!o && (p(e), e = e || h, g)) {
                if (11 !== x && (d = Z.exec(t))) {
                    if (s = d[1]) {
                        if (9 === x) {
                            if (!(c = e.getElementById(s))) return n;
                            if (c.id === s) return n.push(c), n
                        } else if (y && (c = y.getElementById(s)) && $(e, c) && c.id === s) return n.push(c), n
                    } else {
                        if (d[2]) return O.apply(n, e.getElementsByTagName(t)), n;
                        if ((s = d[3]) && i.getElementsByClassName && e.getElementsByClassName) return O.apply(n, e.getElementsByClassName(s)), n
                    }
                }
                if (i.qsa && !C[t + " "] && (!v || !v.test(t)) && (1 !== x || "object" !== e.nodeName.toLowerCase())) {
                    if (m = t, y = e, 1 === x && (U.test(t) || F.test(t))) {
                        for ((y = tt.test(t) && ty(e.parentNode) || e) === e && i.scope || ((u = e.getAttribute("id")) ? u = u.replace(tn, to) : e.setAttribute("id", u = b)), a = (f = r(t)).length; a--;) f[a] = (u ? "#" + u : ":scope") + " " + tb(f[a]);
                        m = f.join(",")
                    }
                    try {
                        return O.apply(n, y.querySelectorAll(m)), n
                    } catch (T) {
                        C(t, !0)
                    } finally {
                        u === b && e.removeAttribute("id")
                    }
                }
            }
            return l(t.replace(M, "$1"), e, n, o)
        }

        function tc() {
            var t = [];
            return function e(i, o) {
                return t.push(i + " ") > n.cacheLength && delete e[t.shift()], e[i + " "] = o
            }
        }

        function tu(t) {
            return t[b] = !0, t
        }

        function td(t) {
            var e = h.createElement("fieldset");
            try {
                return !!t(e)
            } catch (i) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e), e = null
            }
        }

        function tp(t, e) {
            for (var i = t.split("|"), o = i.length; o--;) n.attrHandle[i[o]] = e
        }

        function th(t, e) {
            var i = e && t,
                n = i && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
            if (n) return n;
            if (i) {
                for (; i = i.nextSibling;)
                    if (i === e) return -1
            }
            return t ? 1 : -1
        }

        function tf(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }

        function tg(t) {
            return function(e) {
                var i = e.nodeName.toLowerCase();
                return ("input" === i || "button" === i) && e.type === t
            }
        }

        function tv(t) {
            return function(e) {
                return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || !t !== e.isDisabled && tr(e) === t : e.disabled === t : "label" in e && e.disabled === t
            }
        }

        function tm(t) {
            return tu(function(e) {
                return e = +e, tu(function(i, n) {
                    for (var o, s = t([], i.length, e), r = s.length; r--;) i[o = s[r]] && (i[o] = !(n[o] = i[o]))
                })
            })
        }

        function ty(t) {
            return t && void 0 !== t.getElementsByTagName && t
        }
        for (e in i = tl.support = {}, s = tl.isXML = function(t) {
                var e = t && t.namespaceURI,
                    i = t && (t.ownerDocument || t).documentElement;
                return !Q.test(e || i && i.nodeName || "HTML")
            }, p = tl.setDocument = function(t) {
                var e, o, r = t ? t.ownerDocument || t : x;
                return r != h && 9 === r.nodeType && r.documentElement && (f = (h = r).documentElement, g = !s(h), x != h && (o = h.defaultView) && o.top !== o && (o.addEventListener ? o.addEventListener("unload", ts, !1) : o.attachEvent && o.attachEvent("onunload", ts)), i.scope = td(function(t) {
                    return f.appendChild(t).appendChild(h.createElement("div")), void 0 !== t.querySelectorAll && !t.querySelectorAll(":scope fieldset div").length
                }), i.attributes = td(function(t) {
                    return t.className = "i", !t.getAttribute("className")
                }), i.getElementsByTagName = td(function(t) {
                    return t.appendChild(h.createComment("")), !t.getElementsByTagName("*").length
                }), i.getElementsByClassName = J.test(h.getElementsByClassName), i.getById = td(function(t) {
                    return f.appendChild(t).id = b, !h.getElementsByName || !h.getElementsByName(b).length
                }), i.getById ? (n.filter.ID = function(t) {
                    var e = t.replace(te, ti);
                    return function(t) {
                        return t.getAttribute("id") === e
                    }
                }, n.find.ID = function(t, e) {
                    if (void 0 !== e.getElementById && g) {
                        var i = e.getElementById(t);
                        return i ? [i] : []
                    }
                }) : (n.filter.ID = function(t) {
                    var e = t.replace(te, ti);
                    return function(t) {
                        var i = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                        return i && i.value === e
                    }
                }, n.find.ID = function(t, e) {
                    if (void 0 !== e.getElementById && g) {
                        var i, n, o, s = e.getElementById(t);
                        if (s) {
                            if ((i = s.getAttributeNode("id")) && i.value === t) return [s];
                            for (o = e.getElementsByName(t), n = 0; s = o[n++];)
                                if ((i = s.getAttributeNode("id")) && i.value === t) return [s]
                        }
                        return []
                    }
                }), n.find.TAG = i.getElementsByTagName ? function(t, e) {
                    return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : i.qsa ? e.querySelectorAll(t) : void 0
                } : function(t, e) {
                    var i, n = [],
                        o = 0,
                        s = e.getElementsByTagName(t);
                    if ("*" === t) {
                        for (; i = s[o++];) 1 === i.nodeType && n.push(i);
                        return n
                    }
                    return s
                }, n.find.CLASS = i.getElementsByClassName && function(t, e) {
                    if (void 0 !== e.getElementsByClassName && g) return e.getElementsByClassName(t)
                }, m = [], v = [], (i.qsa = J.test(h.querySelectorAll)) && (td(function(t) {
                    var e;
                    f.appendChild(t).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + N + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || v.push("\\[" + N + "*(?:value|" + P + ")"), t.querySelectorAll("[id~=" + b + "-]").length || v.push("~="), (e = h.createElement("input")).setAttribute("name", ""), t.appendChild(e), t.querySelectorAll("[name='']").length || v.push("\\[" + N + "*name" + N + "*=" + N + "*(?:''|\"\")"), t.querySelectorAll(":checked").length || v.push(":checked"), t.querySelectorAll("a#" + b + "+*").length || v.push(".#.+[+~]"), t.querySelectorAll("\\\f"), v.push("[\\r\\n\\f]")
                }), td(function(t) {
                    t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    var e = h.createElement("input");
                    e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && v.push("name" + N + "*[*^$|!~]?="), 2 !== t.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"), f.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), v.push(",.*:")
                })), (i.matchesSelector = J.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && td(function(t) {
                    i.disconnectedMatch = y.call(t, "*"), y.call(t, "[s!='']:x"), m.push("!=", W)
                }), v = v.length && RegExp(v.join("|")), m = m.length && RegExp(m.join("|")), $ = (e = J.test(f.compareDocumentPosition)) || J.test(f.contains) ? function(t, e) {
                    var i = 9 === t.nodeType ? t.documentElement : t,
                        n = e && e.parentNode;
                    return t === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n)))
                } : function(t, e) {
                    if (e) {
                        for (; e = e.parentNode;)
                            if (e === t) return !0
                    }
                    return !1
                }, E = e ? function(t, e) {
                    if (t === e) return d = !0, 0;
                    var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                    return n || (1 & (n = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !i.sortDetached && e.compareDocumentPosition(t) === n ? t == h || t.ownerDocument == x && $(x, t) ? -1 : e == h || e.ownerDocument == x && $(x, e) ? 1 : u ? z(u, t) - z(u, e) : 0 : 4 & n ? -1 : 1)
                } : function(t, e) {
                    if (t === e) return d = !0, 0;
                    var i, n = 0,
                        o = t.parentNode,
                        s = e.parentNode,
                        r = [t],
                        a = [e];
                    if (!o || !s) return t == h ? -1 : e == h ? 1 : o ? -1 : s ? 1 : u ? z(u, t) - z(u, e) : 0;
                    if (o === s) return th(t, e);
                    for (i = t; i = i.parentNode;) r.unshift(i);
                    for (i = e; i = i.parentNode;) a.unshift(i);
                    for (; r[n] === a[n];) n++;
                    return n ? th(r[n], a[n]) : r[n] == x ? -1 : a[n] == x ? 1 : 0
                }), h
            }, tl.matches = function(t, e) {
                return tl(t, null, null, e)
            }, tl.matchesSelector = function(t, e) {
                if (p(t), i.matchesSelector && g && !C[e + " "] && (!m || !m.test(e)) && (!v || !v.test(e))) try {
                    var n = y.call(t, e);
                    if (n || i.disconnectedMatch || t.document && 11 !== t.document.nodeType) return n
                } catch (o) {
                    C(e, !0)
                }
                return 0 < tl(e, h, null, [t]).length
            }, tl.contains = function(t, e) {
                return (t.ownerDocument || t) != h && p(t), $(t, e)
            }, tl.attr = function(t, e) {
                (t.ownerDocument || t) != h && p(t);
                var o = n.attrHandle[e.toLowerCase()],
                    s = o && A.call(n.attrHandle, e.toLowerCase()) ? o(t, e, !g) : void 0;
                return void 0 !== s ? s : i.attributes || !g ? t.getAttribute(e) : (s = t.getAttributeNode(e)) && s.specified ? s.value : null
            }, tl.escape = function(t) {
                return (t + "").replace(tn, to)
            }, tl.error = function(t) {
                throw Error("Syntax error, unrecognized expression: " + t)
            }, tl.uniqueSort = function(t) {
                var e, n = [],
                    o = 0,
                    s = 0;
                if (d = !i.detectDuplicates, u = !i.sortStable && t.slice(0), t.sort(E), d) {
                    for (; e = t[s++];) e === t[s] && (o = n.push(s));
                    for (; o--;) t.splice(n[o], 1)
                }
                return u = null, t
            }, o = tl.getText = function(t) {
                var e, i = "",
                    n = 0,
                    s = t.nodeType;
                if (s) {
                    if (1 === s || 9 === s || 11 === s) {
                        if ("string" == typeof t.textContent) return t.textContent;
                        for (t = t.firstChild; t; t = t.nextSibling) i += o(t)
                    } else if (3 === s || 4 === s) return t.nodeValue
                } else
                    for (; e = t[n++];) i += o(e);
                return i
            }, (n = tl.selectors = {
                cacheLength: 50,
                createPseudo: tu,
                match: G,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(t) {
                        return t[1] = t[1].replace(te, ti), t[3] = (t[3] || t[4] || t[5] || "").replace(te, ti), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                    },
                    CHILD: function(t) {
                        return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || tl.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && tl.error(t[0]), t
                    },
                    PSEUDO: function(t) {
                        var e, i = !t[6] && t[2];
                        return G.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : i && X.test(i) && (e = r(i, !0)) && (e = i.indexOf(")", i.length - e) - i.length) && (t[0] = t[0].slice(0, e), t[2] = i.slice(0, e)), t.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(t) {
                        var e = t.replace(te, ti).toLowerCase();
                        return "*" === t ? function() {
                            return !0
                        } : function(t) {
                            return t.nodeName && t.nodeName.toLowerCase() === e
                        }
                    },
                    CLASS: function(t) {
                        var e = w[t + " "];
                        return e || (e = RegExp("(^|" + N + ")" + t + "(" + N + "|$)"), w(t, function(t) {
                            return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                        }))
                    },
                    ATTR: function(t, e, i) {
                        return function(n) {
                            var o = tl.attr(n, t);
                            return null == o ? "!=" === e : !e || (o += "", "=" === e ? o === i : "!=" === e ? o !== i : "^=" === e ? i && 0 === o.indexOf(i) : "*=" === e ? i && -1 < o.indexOf(i) : "$=" === e ? i && o.slice(-i.length) === i : "~=" === e ? -1 < (" " + o.replace(R, " ") + " ").indexOf(i) : "|=" === e && (o === i || o.slice(0, i.length + 1) === i + "-"))
                        }
                    },
                    CHILD: function(t, e, i, n, o) {
                        var s = "nth" !== t.slice(0, 3),
                            r = "last" !== t.slice(-4),
                            a = "of-type" === e;
                        return 1 === n && 0 === o ? function(t) {
                            return !!t.parentNode
                        } : function(e, i, l) {
                            var c, u, d, p, h, f, g = s !== r ? "nextSibling" : "previousSibling",
                                v = e.parentNode,
                                m = a && e.nodeName.toLowerCase(),
                                y = !l && !a,
                                $ = !1;
                            if (v) {
                                if (s) {
                                    for (; g;) {
                                        for (p = e; p = p[g];)
                                            if (a ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) return !1;
                                        f = g = "only" === t && !f && "nextSibling"
                                    }
                                    return !0
                                }
                                if (f = [r ? v.firstChild : v.lastChild], r && y) {
                                    for ($ = (h = (c = (u = (d = (p = v)[b] || (p[b] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === T && c[1]) && c[2], p = h && v.childNodes[h]; p = ++h && p && p[g] || ($ = h = 0) || f.pop();)
                                        if (1 === p.nodeType && ++$ && p === e) {
                                            u[t] = [T, h, $];
                                            break
                                        }
                                } else if (y && ($ = h = (c = (u = (d = (p = e)[b] || (p[b] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === T && c[1]), !1 === $)
                                    for (;
                                        (p = ++h && p && p[g] || ($ = h = 0) || f.pop()) && (!((a ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) && ++$) || (y && ((u = (d = p[b] || (p[b] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] = [T, $]), p !== e)););
                                return ($ -= o) === n || $ % n == 0 && 0 <= $ / n
                            }
                        }
                    },
                    PSEUDO: function(t, e) {
                        var i, o = n.pseudos[t] || n.setFilters[t.toLowerCase()] || tl.error("unsupported pseudo: " + t);
                        return o[b] ? o(e) : 1 < o.length ? (i = [t, t, "", e], n.setFilters.hasOwnProperty(t.toLowerCase()) ? tu(function(t, i) {
                            for (var n, s = o(t, e), r = s.length; r--;) t[n = z(t, s[r])] = !(i[n] = s[r])
                        }) : function(t) {
                            return o(t, 0, i)
                        }) : o
                    }
                },
                pseudos: {
                    not: tu(function(t) {
                        var e = [],
                            i = [],
                            n = a(t.replace(M, "$1"));
                        return n[b] ? tu(function(t, e, i, o) {
                            for (var s, r = n(t, null, o, []), a = t.length; a--;)(s = r[a]) && (t[a] = !(e[a] = s))
                        }) : function(t, o, s) {
                            return e[0] = t, n(e, null, s, i), e[0] = null, !i.pop()
                        }
                    }),
                    has: tu(function(t) {
                        return function(e) {
                            return 0 < tl(t, e).length
                        }
                    }),
                    contains: tu(function(t) {
                        return t = t.replace(te, ti),
                            function(e) {
                                return -1 < (e.textContent || o(e)).indexOf(t)
                            }
                    }),
                    lang: tu(function(t) {
                        return Y.test(t || "") || tl.error("unsupported lang: " + t), t = t.replace(te, ti).toLowerCase(),
                            function(e) {
                                var i;
                                do
                                    if (i = g ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (i = i.toLowerCase()) === t || 0 === i.indexOf(t + "-"); while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1
                            }
                    }),
                    target: function(e) {
                        var i = t.location && t.location.hash;
                        return i && i.slice(1) === e.id
                    },
                    root: function(t) {
                        return t === f
                    },
                    focus: function(t) {
                        return t === h.activeElement && (!h.hasFocus || h.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                    },
                    enabled: tv(!1),
                    disabled: tv(!0),
                    checked: function(t) {
                        var e = t.nodeName.toLowerCase();
                        return "input" === e && !!t.checked || "option" === e && !!t.selected
                    },
                    selected: function(t) {
                        return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                    },
                    empty: function(t) {
                        for (t = t.firstChild; t; t = t.nextSibling)
                            if (t.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(t) {
                        return !n.pseudos.empty(t)
                    },
                    header: function(t) {
                        return K.test(t.nodeName)
                    },
                    input: function(t) {
                        return V.test(t.nodeName)
                    },
                    button: function(t) {
                        var e = t.nodeName.toLowerCase();
                        return "input" === e && "button" === t.type || "button" === e
                    },
                    text: function(t) {
                        var e;
                        return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                    },
                    first: tm(function() {
                        return [0]
                    }),
                    last: tm(function(t, e) {
                        return [e - 1]
                    }),
                    eq: tm(function(t, e, i) {
                        return [i < 0 ? i + e : i]
                    }),
                    even: tm(function(t, e) {
                        for (var i = 0; i < e; i += 2) t.push(i);
                        return t
                    }),
                    odd: tm(function(t, e) {
                        for (var i = 1; i < e; i += 2) t.push(i);
                        return t
                    }),
                    lt: tm(function(t, e, i) {
                        for (var n = i < 0 ? i + e : e < i ? e : i; 0 <= --n;) t.push(n);
                        return t
                    }),
                    gt: tm(function(t, e, i) {
                        for (var n = i < 0 ? i + e : i; ++n < e;) t.push(n);
                        return t
                    })
                }
            }).pseudos.nth = n.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) n.pseudos[e] = tf(e);
        for (e in {
                submit: !0,
                reset: !0
            }) n.pseudos[e] = tg(e);

        function t$() {}

        function tb(t) {
            for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
            return n
        }

        function tx(t, e, i) {
            var n = e.dir,
                o = e.next,
                s = o || n,
                r = i && "parentNode" === s,
                a = _++;
            return e.first ? function(e, i, o) {
                for (; e = e[n];)
                    if (1 === e.nodeType || r) return t(e, i, o);
                return !1
            } : function(e, i, l) {
                var c, u, d, p = [T, a];
                if (l) {
                    for (; e = e[n];)
                        if ((1 === e.nodeType || r) && t(e, i, l)) return !0
                } else
                    for (; e = e[n];)
                        if (1 === e.nodeType || r) {
                            if (u = (d = e[b] || (e[b] = {}))[e.uniqueID] || (d[e.uniqueID] = {}), o && o === e.nodeName.toLowerCase()) e = e[n] || e;
                            else {
                                if ((c = u[s]) && c[0] === T && c[1] === a) return p[2] = c[2];
                                if ((u[s] = p)[2] = t(e, i, l)) return !0
                            }
                        } return !1
            }
        }

        function tT(t) {
            return 1 < t.length ? function(e, i, n) {
                for (var o = t.length; o--;)
                    if (!t[o](e, i, n)) return !1;
                return !0
            } : t[0]
        }

        function t_(t, e, i, n, o) {
            for (var s, r = [], a = 0, l = t.length, c = null != e; a < l; a++)(s = t[a]) && (i && !i(s, n, o) || (r.push(s), c && e.push(a)));
            return r
        }

        function tw(t, e, i, n, o, s) {
            return n && !n[b] && (n = tw(n)), o && !o[b] && (o = tw(o, s)), tu(function(s, r, a, l) {
                var c, u, d, p = [],
                    h = [],
                    f = r.length,
                    g = s || function(t, e, i) {
                        for (var n = 0, o = e.length; n < o; n++) tl(t, e[n], i);
                        return i
                    }(e || "*", a.nodeType ? [a] : a, []),
                    v = t && (s || !e) ? t_(g, p, t, a, l) : g,
                    m = i ? o || (s ? t : f || n) ? [] : r : v;
                if (i && i(v, m, a, l), n)
                    for (c = t_(m, h), n(c, [], a, l), u = c.length; u--;)(d = c[u]) && (m[h[u]] = !(v[h[u]] = d));
                if (s) {
                    if (o || t) {
                        if (o) {
                            for (c = [], u = m.length; u--;)(d = m[u]) && c.push(v[u] = d);
                            o(null, m = [], c, l)
                        }
                        for (u = m.length; u--;)(d = m[u]) && -1 < (c = o ? z(s, d) : p[u]) && (s[c] = !(r[c] = d))
                    }
                } else m = t_(m === r ? m.splice(f, m.length) : m), o ? o(null, r, m, l) : O.apply(r, m)
            })
        }

        function tk(t) {
            for (var e, i, o, s = t.length, r = n.relative[t[0].type], a = r || n.relative[" "], l = r ? 1 : 0, u = tx(function(t) {
                    return t === e
                }, a, !0), d = tx(function(t) {
                    return -1 < z(e, t)
                }, a, !0), p = [function(t, i, n) {
                    var o = !r && (n || i !== c) || ((e = i).nodeType ? u(t, i, n) : d(t, i, n));
                    return e = null, o
                }]; l < s; l++)
                if (i = n.relative[t[l].type]) p = [tx(tT(p), i)];
                else {
                    if ((i = n.filter[t[l].type].apply(null, t[l].matches))[b]) {
                        for (o = ++l; o < s && !n.relative[t[o].type]; o++);
                        return tw(1 < l && tT(p), 1 < l && tb(t.slice(0, l - 1).concat({
                            value: " " === t[l - 2].type ? "*" : ""
                        })).replace(M, "$1"), i, l < o && tk(t.slice(l, o)), o < s && tk(t = t.slice(o)), o < s && tb(t))
                    }
                    p.push(i)
                }
            return tT(p)
        }
        return t$.prototype = n.filters = n.pseudos, n.setFilters = new t$, r = tl.tokenize = function(t, e) {
            var i, o, s, r, a, l, c, u = k[t + " "];
            if (u) return e ? 0 : u.slice(0);
            for (a = t, l = [], c = n.preFilter; a;) {
                for (r in (!i || (o = B.exec(a))) && (o && (a = a.slice(o[0].length) || a), l.push(s = [])), i = !1, (o = F.exec(a)) && (i = o.shift(), s.push({
                        value: i,
                        type: o[0].replace(M, " ")
                    }), a = a.slice(i.length)), n.filter)(o = G[r].exec(a)) && (!c[r] || (o = c[r](o))) && (i = o.shift(), s.push({
                    value: i,
                    type: r,
                    matches: o
                }), a = a.slice(i.length));
                if (!i) break
            }
            return e ? a.length : a ? tl.error(t) : k(t, l).slice(0)
        }, a = tl.compile = function(t, e) {
            var i, o, s, a, l, u, d = [],
                f = [],
                v = S[t + " "];
            if (!v) {
                for (e || (e = r(t)), i = e.length; i--;)(v = tk(e[i]))[b] ? d.push(v) : f.push(v);
                (v = S(t, (o = f, a = 0 < (s = d).length, l = 0 < o.length, u = function(t, e, i, r, u) {
                    var d, f, v, m = 0,
                        y = "0",
                        $ = t && [],
                        b = [],
                        x = c,
                        _ = t || l && n.find.TAG("*", u),
                        w = T += null == x ? 1 : Math.random() || .1,
                        k = _.length;
                    for (u && (c = e == h || e || u); y !== k && null != (d = _[y]); y++) {
                        if (l && d) {
                            for (f = 0, e || d.ownerDocument == h || (p(d), i = !g); v = o[f++];)
                                if (v(d, e || h, i)) {
                                    r.push(d);
                                    break
                                }
                            u && (T = w)
                        }
                        a && ((d = !v && d) && m--, t && $.push(d))
                    }
                    if (m += y, a && y !== m) {
                        for (f = 0; v = s[f++];) v($, b, e, i);
                        if (t) {
                            if (0 < m)
                                for (; y--;) $[y] || b[y] || (b[y] = j.call(r));
                            b = t_(b)
                        }
                        O.apply(r, b), u && !t && 0 < b.length && 1 < m + s.length && tl.uniqueSort(r)
                    }
                    return u && (T = w, c = x), $
                }, a ? tu(u) : u))).selector = t
            }
            return v
        }, l = tl.select = function(t, e, i, o) {
            var s, l, c, u, d, p = "function" == typeof t && t,
                h = !o && r(t = p.selector || t);
            if (i = i || [], 1 === h.length) {
                if (2 < (l = h[0] = h[0].slice(0)).length && "ID" === (c = l[0]).type && 9 === e.nodeType && g && n.relative[l[1].type]) {
                    if (!(e = (n.find.ID(c.matches[0].replace(te, ti), e) || [])[0])) return i;
                    p && (e = e.parentNode), t = t.slice(l.shift().value.length)
                }
                for (s = G.needsContext.test(t) ? 0 : l.length; s-- && (c = l[s], !n.relative[u = c.type]);)
                    if ((d = n.find[u]) && (o = d(c.matches[0].replace(te, ti), tt.test(l[0].type) && ty(e.parentNode) || e))) {
                        if (l.splice(s, 1), !(t = o.length && tb(l))) return O.apply(i, o), i;
                        break
                    }
            }
            return (p || a(t, h))(o, e, !g, i, !e || tt.test(t) && ty(e.parentNode) || e), i
        }, i.sortStable = b.split("").sort(E).join("") === b, i.detectDuplicates = !!d, p(), i.sortDetached = td(function(t) {
            return 1 & t.compareDocumentPosition(h.createElement("fieldset"))
        }), td(function(t) {
            return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
        }) || tp("type|href|height|width", function(t, e, i) {
            if (!i) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }), i.attributes && td(function(t) {
            return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
        }) || tp("value", function(t, e, i) {
            if (!i && "input" === t.nodeName.toLowerCase()) return t.defaultValue
        }), td(function(t) {
            return null == t.getAttribute("disabled")
        }) || tp(P, function(t, e, i) {
            var n;
            if (!i) return !0 === t[e] ? e.toLowerCase() : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
        }), tl
    }(t);
    x.find = _, x.expr = _.selectors, x.expr[":"] = x.expr.pseudos, x.uniqueSort = x.unique = _.uniqueSort, x.text = _.getText, x.isXMLDoc = _.isXML, x.contains = _.contains, x.escapeSelector = _.escape;
    var w = function(t, e, i) {
            for (var n = [], o = void 0 !== i;
                (t = t[e]) && 9 !== t.nodeType;)
                if (1 === t.nodeType) {
                    if (o && x(t).is(i)) break;
                    n.push(t)
                }
            return n
        },
        k = function(t, e) {
            for (var i = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && i.push(t);
            return i
        },
        S = x.expr.match.needsContext;

    function C(t, e) {
        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
    }
    var E = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function A(t, e, i) {
        return f(e) ? x.grep(t, function(t, n) {
            return !!e.call(t, n, t) !== i
        }) : e.nodeType ? x.grep(t, function(t) {
            return t === e !== i
        }) : "string" != typeof e ? x.grep(t, function(t) {
            return -1 < a.call(e, t) !== i
        }) : x.filter(e, t, i)
    }
    x.filter = function(t, e, i) {
        var n = e[0];
        return i && (t = ":not(" + t + ")"), 1 === e.length && 1 === n.nodeType ? x.find.matchesSelector(n, t) ? [n] : [] : x.find.matches(t, x.grep(e, function(t) {
            return 1 === t.nodeType
        }))
    }, x.fn.extend({
        find: function(t) {
            var e, i, n = this.length,
                o = this;
            if ("string" != typeof t) return this.pushStack(x(t).filter(function() {
                for (e = 0; e < n; e++)
                    if (x.contains(o[e], this)) return !0
            }));
            for (i = this.pushStack([]), e = 0; e < n; e++) x.find(t, o[e], i);
            return 1 < n ? x.uniqueSort(i) : i
        },
        filter: function(t) {
            return this.pushStack(A(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(A(this, t || [], !0))
        },
        is: function(t) {
            return !!A(this, "string" == typeof t && S.test(t) ? x(t) : t || [], !1).length
        }
    });
    var L, j = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (x.fn.init = function(t, e, i) {
        var n, o;
        if (!t) return this;
        if (i = i || L, "string" == typeof t) {
            if (!(n = "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length ? [null, t, null] : j.exec(t)) || !n[1] && e) return !e || e.jquery ? (e || i).find(t) : this.constructor(e).find(t);
            if (n[1]) {
                if (e = e instanceof x ? e[0] : e, x.merge(this, x.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : v, !0)), E.test(n[1]) && x.isPlainObject(e))
                    for (n in e) f(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                return this
            }
            return (o = v.getElementById(n[2])) && (this[0] = o, this.length = 1), this
        }
        return t.nodeType ? (this[0] = t, this.length = 1, this) : f(t) ? void 0 !== i.ready ? i.ready(t) : t(x) : x.makeArray(t, this)
    }).prototype = x.fn, L = x(v);
    var D = /^(?:parents|prev(?:Until|All))/,
        O = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };

    function H(t, e) {
        for (;
            (t = t[e]) && 1 !== t.nodeType;);
        return t
    }
    x.fn.extend({
        has: function(t) {
            var e = x(t, this),
                i = e.length;
            return this.filter(function() {
                for (var t = 0; t < i; t++)
                    if (x.contains(this, e[t])) return !0
            })
        },
        closest: function(t, e) {
            var i, n = 0,
                o = this.length,
                s = [],
                r = "string" != typeof t && x(t);
            if (!S.test(t)) {
                for (; n < o; n++)
                    for (i = this[n]; i && i !== e; i = i.parentNode)
                        if (i.nodeType < 11 && (r ? -1 < r.index(i) : 1 === i.nodeType && x.find.matchesSelector(i, t))) {
                            s.push(i);
                            break
                        }
            }
            return this.pushStack(1 < s.length ? x.uniqueSort(s) : s)
        },
        index: function(t) {
            return t ? "string" == typeof t ? a.call(x(t), this[0]) : a.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, e) {
            return this.pushStack(x.uniqueSort(x.merge(this.get(), x(t, e))))
        },
        addBack: function(t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }), x.each({
        parent: function(t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null
        },
        parents: function(t) {
            return w(t, "parentNode")
        },
        parentsUntil: function(t, e, i) {
            return w(t, "parentNode", i)
        },
        next: function(t) {
            return H(t, "nextSibling")
        },
        prev: function(t) {
            return H(t, "previousSibling")
        },
        nextAll: function(t) {
            return w(t, "nextSibling")
        },
        prevAll: function(t) {
            return w(t, "previousSibling")
        },
        nextUntil: function(t, e, i) {
            return w(t, "nextSibling", i)
        },
        prevUntil: function(t, e, i) {
            return w(t, "previousSibling", i)
        },
        siblings: function(t) {
            return k((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return k(t.firstChild)
        },
        contents: function(t) {
            return null != t.contentDocument && n(t.contentDocument) ? t.contentDocument : (C(t, "template") && (t = t.content || t), x.merge([], t.childNodes))
        }
    }, function(t, e) {
        x.fn[t] = function(i, n) {
            var o = x.map(this, e, i);
            return "Until" !== t.slice(-5) && (n = i), n && "string" == typeof n && (o = x.filter(n, o)), 1 < this.length && (O[t] || x.uniqueSort(o), D.test(t) && o.reverse()), this.pushStack(o)
        }
    });
    var z = /[^\x20\t\r\n\f]+/g;

    function P(t) {
        return t
    }

    function N(t) {
        throw t
    }

    function I(t, e, i, n) {
        var o;
        try {
            t && f(o = t.promise) ? o.call(t).done(e).fail(i) : t && f(o = t.then) ? o.call(t, e, i) : e.apply(void 0, [t].slice(n))
        } catch (s) {
            i.apply(void 0, [s])
        }
    }
    x.Callbacks = function(t) {
        t = "string" == typeof t ? (e = t, i = {}, x.each(e.match(z) || [], function(t, e) {
            i[e] = !0
        }), i) : x.extend({}, t);
        var e, i, n, o, s, r, a = [],
            l = [],
            c = -1,
            u = function() {
                for (r = r || t.once, s = n = !0; l.length; c = -1)
                    for (o = l.shift(); ++c < a.length;) !1 === a[c].apply(o[0], o[1]) && t.stopOnFalse && (c = a.length, o = !1);
                t.memory || (o = !1), n = !1, r && (a = o ? [] : "")
            },
            d = {
                add: function() {
                    return a && (o && !n && (c = a.length - 1, l.push(o)), function e(i) {
                        x.each(i, function(i, n) {
                            f(n) ? t.unique && d.has(n) || a.push(n) : n && n.length && "string" !== $(n) && e(n)
                        })
                    }(arguments), o && !n && u()), this
                },
                remove: function() {
                    return x.each(arguments, function(t, e) {
                        for (var i; - 1 < (i = x.inArray(e, a, i));) a.splice(i, 1), i <= c && c--
                    }), this
                },
                has: function(t) {
                    return t ? -1 < x.inArray(t, a) : 0 < a.length
                },
                empty: function() {
                    return a && (a = []), this
                },
                disable: function() {
                    return r = l = [], a = o = "", this
                },
                disabled: function() {
                    return !a
                },
                lock: function() {
                    return r = l = [], o || n || (a = o = ""), this
                },
                locked: function() {
                    return !!r
                },
                fireWith: function(t, e) {
                    return r || (e = [t, (e = e || []).slice ? e.slice() : e], l.push(e), n || u()), this
                },
                fire: function() {
                    return d.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!s
                }
            };
        return d
    }, x.extend({
        Deferred: function(e) {
            var i = [
                    ["notify", "progress", x.Callbacks("memory"), x.Callbacks("memory"), 2],
                    ["resolve", "done", x.Callbacks("once memory"), x.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", x.Callbacks("once memory"), x.Callbacks("once memory"), 1, "rejected"]
                ],
                n = "pending",
                o = {
                    state: function() {
                        return n
                    },
                    always: function() {
                        return s.done(arguments).fail(arguments), this
                    },
                    catch: function(t) {
                        return o.then(null, t)
                    },
                    pipe: function() {
                        var t = arguments;
                        return x.Deferred(function(e) {
                            x.each(i, function(i, n) {
                                var o = f(t[n[4]]) && t[n[4]];
                                s[n[1]](function() {
                                    var t = o && o.apply(this, arguments);
                                    t && f(t.promise) ? t.promise().progress(e.notify).done(e.resolve).fail(e.reject) : e[n[0] + "With"](this, o ? [t] : arguments)
                                })
                            }), t = null
                        }).promise()
                    },
                    then: function(e, n, o) {
                        var s = 0;

                        function r(e, i, n, o) {
                            return function() {
                                var a = this,
                                    l = arguments,
                                    c = function() {
                                        var t, c;
                                        if (!(e < s)) {
                                            if ((t = n.apply(a, l)) === i.promise()) throw TypeError("Thenable self-resolution");
                                            f(c = t && ("object" == typeof t || "function" == typeof t) && t.then) ? o ? c.call(t, r(s, i, P, o), r(s, i, N, o)) : (s++, c.call(t, r(s, i, P, o), r(s, i, N, o), r(s, i, P, i.notifyWith))) : (n !== P && (a = void 0, l = [t]), (o || i.resolveWith)(a, l))
                                        }
                                    },
                                    u = o ? c : function() {
                                        try {
                                            c()
                                        } catch (t) {
                                            x.Deferred.exceptionHook && x.Deferred.exceptionHook(t, u.stackTrace), s <= e + 1 && (n !== N && (a = void 0, l = [t]), i.rejectWith(a, l))
                                        }
                                    };
                                e ? u() : (x.Deferred.getStackHook && (u.stackTrace = x.Deferred.getStackHook()), t.setTimeout(u))
                            }
                        }
                        return x.Deferred(function(t) {
                            i[0][3].add(r(0, t, f(o) ? o : P, t.notifyWith)), i[1][3].add(r(0, t, f(e) ? e : P)), i[2][3].add(r(0, t, f(n) ? n : N))
                        }).promise()
                    },
                    promise: function(t) {
                        return null != t ? x.extend(t, o) : o
                    }
                },
                s = {};
            return x.each(i, function(t, e) {
                var r = e[2],
                    a = e[5];
                o[e[1]] = r.add, a && r.add(function() {
                    n = a
                }, i[3 - t][2].disable, i[3 - t][3].disable, i[0][2].lock, i[0][3].lock), r.add(e[3].fire), s[e[0]] = function() {
                    return s[e[0] + "With"](this === s ? void 0 : this, arguments), this
                }, s[e[0] + "With"] = r.fireWith
            }), o.promise(s), e && e.call(s, s), s
        },
        when: function(t) {
            var e = arguments.length,
                i = e,
                n = Array(i),
                s = o.call(arguments),
                r = x.Deferred(),
                a = function(t) {
                    return function(i) {
                        n[t] = this, s[t] = 1 < arguments.length ? o.call(arguments) : i, --e || r.resolveWith(n, s)
                    }
                };
            if (e <= 1 && (I(t, r.done(a(i)).resolve, r.reject, !e), "pending" === r.state() || f(s[i] && s[i].then))) return r.then();
            for (; i--;) I(s[i], a(i), r.reject);
            return r.promise()
        }
    });
    var q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    x.Deferred.exceptionHook = function(e, i) {
        t.console && t.console.warn && e && q.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, i)
    }, x.readyException = function(e) {
        t.setTimeout(function() {
            throw e
        })
    };
    var W = x.Deferred();

    function R() {
        v.removeEventListener("DOMContentLoaded", R), t.removeEventListener("load", R), x.ready()
    }
    x.fn.ready = function(t) {
        return W.then(t).catch(function(t) {
            x.readyException(t)
        }), this
    }, x.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(t) {
            (!0 === t ? --x.readyWait : x.isReady) || (x.isReady = !0) !== t && 0 < --x.readyWait || W.resolveWith(v, [x])
        }
    }), x.ready.then = W.then, "complete" !== v.readyState && ("loading" === v.readyState || v.documentElement.doScroll) ? (v.addEventListener("DOMContentLoaded", R), t.addEventListener("load", R)) : t.setTimeout(x.ready);
    var M = function(t, e, i, n, o, s, r) {
            var a = 0,
                l = t.length,
                c = null == i;
            if ("object" === $(i))
                for (a in o = !0, i) M(t, e, a, i[a], !0, s, r);
            else if (void 0 !== n && (o = !0, f(n) || (r = !0), c && (r ? (e.call(t, n), e = null) : (c = e, e = function(t, e, i) {
                    return c.call(x(t), i)
                })), e))
                for (; a < l; a++) e(t[a], i, r ? n : n.call(t[a], a, e(t[a], i)));
            return o ? t : c ? e.call(t) : l ? e(t[0], i) : s
        },
        B = /^-ms-/,
        F = /-([a-z])/g;

    function U(t, e) {
        return e.toUpperCase()
    }

    function X(t) {
        return t.replace(B, "ms-").replace(F, U)
    }
    var Y = function(t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
    };

    function G() {
        this.expando = x.expando + G.uid++
    }
    G.uid = 1, G.prototype = {
        cache: function(t) {
            var e = t[this.expando];
            return e || (e = {}, Y(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))), e
        },
        set: function(t, e, i) {
            var n, o = this.cache(t);
            if ("string" == typeof e) o[X(e)] = i;
            else
                for (n in e) o[X(n)] = e[n];
            return o
        },
        get: function(t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][X(e)]
        },
        access: function(t, e, i) {
            return void 0 === e || e && "string" == typeof e && void 0 === i ? this.get(t, e) : (this.set(t, e, i), void 0 !== i ? i : e)
        },
        remove: function(t, e) {
            var i, n = t[this.expando];
            if (void 0 !== n) {
                if (void 0 !== e)
                    for (i = (e = Array.isArray(e) ? e.map(X) : ((e = X(e)) in n) ? [e] : e.match(z) || []).length; i--;) delete n[e[i]];
                (void 0 === e || x.isEmptyObject(n)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var e = t[this.expando];
            return void 0 !== e && !x.isEmptyObject(e)
        }
    };
    var Q = new G,
        V = new G,
        K = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        J = /[A-Z]/g;

    function Z(t, e, i) {
        var n, o;
        if (void 0 === i && 1 === t.nodeType) {
            if (n = "data-" + e.replace(J, "-$&").toLowerCase(), "string" == typeof(i = t.getAttribute(n))) {
                try {
                    i = "true" === (o = i) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : K.test(o) ? JSON.parse(o) : o)
                } catch (s) {}
                V.set(t, e, i)
            } else i = void 0
        }
        return i
    }
    x.extend({
        hasData: function(t) {
            return V.hasData(t) || Q.hasData(t)
        },
        data: function(t, e, i) {
            return V.access(t, e, i)
        },
        removeData: function(t, e) {
            V.remove(t, e)
        },
        _data: function(t, e, i) {
            return Q.access(t, e, i)
        },
        _removeData: function(t, e) {
            Q.remove(t, e)
        }
    }), x.fn.extend({
        data: function(t, e) {
            var i, n, o, s = this[0],
                r = s && s.attributes;
            if (void 0 === t) {
                if (this.length && (o = V.get(s), 1 === s.nodeType && !Q.get(s, "hasDataAttrs"))) {
                    for (i = r.length; i--;) r[i] && 0 === (n = r[i].name).indexOf("data-") && Z(s, n = X(n.slice(5)), o[n]);
                    Q.set(s, "hasDataAttrs", !0)
                }
                return o
            }
            return "object" == typeof t ? this.each(function() {
                V.set(this, t)
            }) : M(this, function(e) {
                var i;
                if (s && void 0 === e) return void 0 !== (i = V.get(s, t)) ? i : void 0 !== (i = Z(s, t)) ? i : void 0;
                this.each(function() {
                    V.set(this, t, e)
                })
            }, null, e, 1 < arguments.length, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                V.remove(this, t)
            })
        }
    }), x.extend({
        queue: function(t, e, i) {
            var n;
            if (t) return e = (e || "fx") + "queue", n = Q.get(t, e), i && (!n || Array.isArray(i) ? n = Q.access(t, e, x.makeArray(i)) : n.push(i)), n || []
        },
        dequeue: function(t, e) {
            e = e || "fx";
            var i = x.queue(t, e),
                n = i.length,
                o = i.shift(),
                s = x._queueHooks(t, e);
            "inprogress" === o && (o = i.shift(), n--), o && ("fx" === e && i.unshift("inprogress"), delete s.stop, o.call(t, function() {
                x.dequeue(t, e)
            }, s)), !n && s && s.empty.fire()
        },
        _queueHooks: function(t, e) {
            var i = e + "queueHooks";
            return Q.get(t, i) || Q.access(t, i, {
                empty: x.Callbacks("once memory").add(function() {
                    Q.remove(t, [e + "queue", i])
                })
            })
        }
    }), x.fn.extend({
        queue: function(t, e) {
            var i = 2;
            return "string" != typeof t && (e = t, t = "fx", i--), arguments.length < i ? x.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                var i = x.queue(this, t, e);
                x._queueHooks(this, t), "fx" === t && "inprogress" !== i[0] && x.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                x.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, e) {
            var i, n = 1,
                o = x.Deferred(),
                s = this,
                r = this.length,
                a = function() {
                    --n || o.resolveWith(s, [s])
                };
            for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; r--;)(i = Q.get(s[r], t + "queueHooks")) && i.empty && (n++, i.empty.add(a));
            return a(), o.promise(e)
        }
    });
    var tt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = RegExp("^(?:([+-])=|)(" + tt + ")([a-z%]*)$", "i"),
        ti = ["Top", "Right", "Bottom", "Left"],
        tn = v.documentElement,
        to = function(t) {
            return x.contains(t.ownerDocument, t)
        },
        ts = {
            composed: !0
        };
    tn.getRootNode && (to = function(t) {
        return x.contains(t.ownerDocument, t) || t.getRootNode(ts) === t.ownerDocument
    });
    var tr = function(t, e) {
        return "none" === (t = e || t).style.display || "" === t.style.display && to(t) && "none" === x.css(t, "display")
    };

    function ta(t, e, i, n) {
        var o, s, r = 20,
            a = n ? function() {
                return n.cur()
            } : function() {
                return x.css(t, e, "")
            },
            l = a(),
            c = i && i[3] || (x.cssNumber[e] ? "" : "px"),
            u = t.nodeType && (x.cssNumber[e] || "px" !== c && +l) && te.exec(x.css(t, e));
        if (u && u[3] !== c) {
            for (l /= 2, c = c || u[3], u = +l || 1; r--;) x.style(t, e, u + c), (1 - s) * (1 - (s = a() / l || .5)) <= 0 && (r = 0), u /= s;
            u *= 2, x.style(t, e, u + c), i = i || []
        }
        return i && (u = +u || +l || 0, o = i[1] ? u + (i[1] + 1) * i[2] : +i[2], n && (n.unit = c, n.start = u, n.end = o)), o
    }
    var tl = {};

    function tc(t, e) {
        for (var i, n, o, s, r, a, l, c = [], u = 0, d = t.length; u < d; u++)(n = t[u]).style && (i = n.style.display, e ? ("none" === i && (c[u] = Q.get(n, "display") || null, c[u] || (n.style.display = "")), "" === n.style.display && tr(n) && (c[u] = (l = r = s = void 0, r = (o = n).ownerDocument, (l = tl[a = o.nodeName]) || (s = r.body.appendChild(r.createElement(a)), l = x.css(s, "display"), s.parentNode.removeChild(s), "none" === l && (l = "block"), tl[a] = l)))) : "none" !== i && (c[u] = "none", Q.set(n, "display", i)));
        for (u = 0; u < d; u++) null != c[u] && (t[u].style.display = c[u]);
        return t
    }
    x.fn.extend({
        show: function() {
            return tc(this, !0)
        },
        hide: function() {
            return tc(this)
        },
        toggle: function(t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                tr(this) ? x(this).show() : x(this).hide()
            })
        }
    });
    var tu, td, tp = /^(?:checkbox|radio)$/i,
        th = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        tf = /^$|^module$|\/(?:java|ecma)script/i;
    tu = v.createDocumentFragment().appendChild(v.createElement("div")), (td = v.createElement("input")).setAttribute("type", "radio"), td.setAttribute("checked", "checked"), td.setAttribute("name", "t"), tu.appendChild(td), h.checkClone = tu.cloneNode(!0).cloneNode(!0).lastChild.checked, tu.innerHTML = "<textarea>x</textarea>", h.noCloneChecked = !!tu.cloneNode(!0).lastChild.defaultValue, tu.innerHTML = "<option></option>", h.option = !!tu.lastChild;
    var tg = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };

    function tv(t, e) {
        var i;
        return i = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [], void 0 === e || e && C(t, e) ? x.merge([t], i) : i
    }

    function tm(t, e) {
        for (var i = 0, n = t.length; i < n; i++) Q.set(t[i], "globalEval", !e || Q.get(e[i], "globalEval"))
    }
    tg.tbody = tg.tfoot = tg.colgroup = tg.caption = tg.thead, tg.th = tg.td, h.option || (tg.optgroup = tg.option = [1, "<select multiple='multiple'>", "</select>"]);
    var ty = /<|&#?\w+;/;

    function t$(t, e, i, n, o) {
        for (var s, r, a, l, c, u, d = e.createDocumentFragment(), p = [], h = 0, f = t.length; h < f; h++)
            if ((s = t[h]) || 0 === s) {
                if ("object" === $(s)) x.merge(p, s.nodeType ? [s] : s);
                else if (ty.test(s)) {
                    for (r = r || d.appendChild(e.createElement("div")), l = tg[a = (th.exec(s) || ["", ""])[1].toLowerCase()] || tg._default, r.innerHTML = l[1] + x.htmlPrefilter(s) + l[2], u = l[0]; u--;) r = r.lastChild;
                    x.merge(p, r.childNodes), (r = d.firstChild).textContent = ""
                } else p.push(e.createTextNode(s))
            }
        for (d.textContent = "", h = 0; s = p[h++];)
            if (n && -1 < x.inArray(s, n)) o && o.push(s);
            else if (c = to(s), r = tv(d.appendChild(s), "script"), c && tm(r), i)
            for (u = 0; s = r[u++];) tf.test(s.type || "") && i.push(s);
        return d
    }
    var tb = /^([^.]*)(?:\.(.+)|)/;

    function tx() {
        return !0
    }

    function tT() {
        return !1
    }

    function t_(t, e) {
        return t === function() {
            try {
                return v.activeElement
            } catch (t) {}
        }() == ("focus" === e)
    }

    function tw(t, e, i, n, o, s) {
        var r, a;
        if ("object" == typeof e) {
            for (a in "string" != typeof i && (n = n || i, i = void 0), e) tw(t, a, i, n, e[a], s);
            return t
        }
        if (null == n && null == o ? (o = i, n = i = void 0) : null == o && ("string" == typeof i ? (o = n, n = void 0) : (o = n, n = i, i = void 0)), !1 === o) o = tT;
        else if (!o) return t;
        return 1 === s && (r = o, (o = function(t) {
            return x().off(t), r.apply(this, arguments)
        }).guid = r.guid || (r.guid = x.guid++)), t.each(function() {
            x.event.add(this, e, o, n, i)
        })
    }

    function tk(t, e, i) {
        i ? (Q.set(t, e, !1), x.event.add(t, e, {
            namespace: !1,
            handler: function(t) {
                var n, s, r = Q.get(this, e);
                if (1 & t.isTrigger && this[e]) {
                    if (r.length)(x.event.special[e] || {}).delegateType && t.stopPropagation();
                    else if (r = o.call(arguments), Q.set(this, e, r), n = i(this, e), this[e](), r !== (s = Q.get(this, e)) || n ? Q.set(this, e, !1) : s = {}, r !== s) return t.stopImmediatePropagation(), t.preventDefault(), s && s.value
                } else r.length && (Q.set(this, e, {
                    value: x.event.trigger(x.extend(r[0], x.Event.prototype), r.slice(1), this)
                }), t.stopImmediatePropagation())
            }
        })) : void 0 === Q.get(t, e) && x.event.add(t, e, tx)
    }
    x.event = {
        global: {},
        add: function(t, e, i, n, o) {
            var s, r, a, l, c, u, d, p, h, f, g, v = Q.get(t);
            if (Y(t))
                for (i.handler && (i = (s = i).handler, o = s.selector), o && x.find.matchesSelector(tn, o), i.guid || (i.guid = x.guid++), (l = v.events) || (l = v.events = Object.create(null)), (r = v.handle) || (r = v.handle = function(e) {
                        return x.event.triggered !== e.type ? x.event.dispatch.apply(t, arguments) : void 0
                    }), c = (e = (e || "").match(z) || [""]).length; c--;) h = g = (a = tb.exec(e[c]) || [])[1], f = (a[2] || "").split(".").sort(), h && (d = x.event.special[h] || {}, h = (o ? d.delegateType : d.bindType) || h, d = x.event.special[h] || {}, u = x.extend({
                    type: h,
                    origType: g,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: o,
                    needsContext: o && x.expr.match.needsContext.test(o),
                    namespace: f.join(".")
                }, s), (p = l[h]) || ((p = l[h] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(t, n, f, r) || t.addEventListener && t.addEventListener(h, r)), d.add && (d.add.call(t, u), u.handler.guid || (u.handler.guid = i.guid)), o ? p.splice(p.delegateCount++, 0, u) : p.push(u), x.event.global[h] = !0)
        },
        remove: function(t, e, i, n, o) {
            var s, r, a, l, c, u, d, p, h, f, g, v = Q.hasData(t) && Q.get(t);
            if (v && (l = v.events)) {
                for (c = (e = (e || "").match(z) || [""]).length; c--;)
                    if (h = g = (a = tb.exec(e[c]) || [])[1], f = (a[2] || "").split(".").sort(), h) {
                        for (d = x.event.special[h] || {}, p = l[h = (n ? d.delegateType : d.bindType) || h] || [], a = a[2] && RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = s = p.length; s--;) u = p[s], !o && g !== u.origType || i && i.guid !== u.guid || a && !a.test(u.namespace) || n && n !== u.selector && ("**" !== n || !u.selector) || (p.splice(s, 1), u.selector && p.delegateCount--, d.remove && d.remove.call(t, u));
                        r && !p.length && (d.teardown && !1 !== d.teardown.call(t, f, v.handle) || x.removeEvent(t, h, v.handle), delete l[h])
                    } else
                        for (h in l) x.event.remove(t, h + e[c], i, n, !0);
                x.isEmptyObject(l) && Q.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            var e, i, n, o, s, r, a = Array(arguments.length),
                l = x.event.fix(t),
                c = (Q.get(this, "events") || Object.create(null))[l.type] || [],
                u = x.event.special[l.type] || {};
            for (a[0] = l, e = 1; e < arguments.length; e++) a[e] = arguments[e];
            if (l.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, l)) {
                for (r = x.event.handlers.call(this, l, c), e = 0;
                    (o = r[e++]) && !l.isPropagationStopped();)
                    for (l.currentTarget = o.elem, i = 0;
                        (s = o.handlers[i++]) && !l.isImmediatePropagationStopped();) l.rnamespace && !1 !== s.namespace && !l.rnamespace.test(s.namespace) || (l.handleObj = s, l.data = s.data, void 0 !== (n = ((x.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, a)) && !1 === (l.result = n) && (l.preventDefault(), l.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, l), l.result
            }
        },
        handlers: function(t, e) {
            var i, n, o, s, r, a = [],
                l = e.delegateCount,
                c = t.target;
            if (l && c.nodeType && !("click" === t.type && 1 <= t.button)) {
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== t.type || !0 !== c.disabled)) {
                        for (s = [], r = {}, i = 0; i < l; i++) void 0 === r[o = (n = e[i]).selector + " "] && (r[o] = n.needsContext ? -1 < x(o, this).index(c) : x.find(o, this, null, [c]).length), r[o] && s.push(n);
                        s.length && a.push({
                            elem: c,
                            handlers: s
                        })
                    }
            }
            return c = this, l < e.length && a.push({
                elem: c,
                handlers: e.slice(l)
            }), a
        },
        addProp: function(t, e) {
            Object.defineProperty(x.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: f(e) ? function() {
                    if (this.originalEvent) return e(this.originalEvent)
                } : function() {
                    if (this.originalEvent) return this.originalEvent[t]
                },
                set: function(e) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: e
                    })
                }
            })
        },
        fix: function(t) {
            return t[x.expando] ? t : new x.Event(t)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(t) {
                    var e = this || t;
                    return tp.test(e.type) && e.click && C(e, "input") && tk(e, "click", tx), !1
                },
                trigger: function(t) {
                    var e = this || t;
                    return tp.test(e.type) && e.click && C(e, "input") && tk(e, "click"), !0
                },
                _default: function(t) {
                    var e = t.target;
                    return tp.test(e.type) && e.click && C(e, "input") && Q.get(e, "click") || C(e, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    }, x.removeEvent = function(t, e, i) {
        t.removeEventListener && t.removeEventListener(e, i)
    }, x.Event = function(t, e) {
        if (!(this instanceof x.Event)) return new x.Event(t, e);
        t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? tx : tT, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && x.extend(this, e), this.timeStamp = t && t.timeStamp || Date.now(), this[x.expando] = !0
    }, x.Event.prototype = {
        constructor: x.Event,
        isDefaultPrevented: tT,
        isPropagationStopped: tT,
        isImmediatePropagationStopped: tT,
        isSimulated: !1,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = tx, t && !this.isSimulated && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = tx, t && !this.isSimulated && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = tx, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
        }
    }, x.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0
    }, x.event.addProp), x.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        x.event.special[t] = {
            setup: function() {
                return tk(this, t, t_), !1
            },
            trigger: function() {
                return tk(this, t), !0
            },
            _default: function() {
                return !0
            },
            delegateType: e
        }
    }), x.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(t, e) {
        x.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function(t) {
                var i, n = t.relatedTarget,
                    o = t.handleObj;
                return n && (n === this || x.contains(this, n)) || (t.type = o.origType, i = o.handler.apply(this, arguments), t.type = e), i
            }
        }
    }), x.fn.extend({
        on: function(t, e, i, n) {
            return tw(this, t, e, i, n)
        },
        one: function(t, e, i, n) {
            return tw(this, t, e, i, n, 1)
        },
        off: function(t, e, i) {
            var n, o;
            if (t && t.preventDefault && t.handleObj) return n = t.handleObj, x(t.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
            if ("object" == typeof t) {
                for (o in t) this.off(o, e, t[o]);
                return this
            }
            return !1 !== e && "function" != typeof e || (i = e, e = void 0), !1 === i && (i = tT), this.each(function() {
                x.event.remove(this, t, i, e)
            })
        }
    });
    var tS = /<script|<style|<link/i,
        tC = /checked\s*(?:[^=]|=\s*.checked.)/i,
        t9 = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function tE(t, e) {
        return C(t, "table") && C(11 !== e.nodeType ? e : e.firstChild, "tr") && x(t).children("tbody")[0] || t
    }

    function tA(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
    }

    function tL(t) {
        return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"), t
    }

    function tj(t, e) {
        var i, n, o, s, r, a;
        if (1 === e.nodeType) {
            if (Q.hasData(t) && (a = Q.get(t).events))
                for (o in Q.remove(e, "handle events"), a)
                    for (i = 0, n = a[o].length; i < n; i++) x.event.add(e, o, a[o][i]);
            V.hasData(t) && (s = V.access(t), r = x.extend({}, s), V.set(e, r))
        }
    }

    function tD(t, e, i, n) {
        e = s(e);
        var o, r, a, l, c, u, d = 0,
            p = t.length,
            g = p - 1,
            v = e[0],
            m = f(v);
        if (m || 1 < p && "string" == typeof v && !h.checkClone && tC.test(v)) return t.each(function(o) {
            var s = t.eq(o);
            m && (e[0] = v.call(this, o, s.html())), tD(s, e, i, n)
        });
        if (p && (r = (o = t$(e, t[0].ownerDocument, !1, t, n)).firstChild, 1 === o.childNodes.length && (o = r), r || n)) {
            for (l = (a = x.map(tv(o, "script"), tA)).length; d < p; d++) c = o, d !== g && (c = x.clone(c, !0, !0), l && x.merge(a, tv(c, "script"))), i.call(t[d], c, d);
            if (l)
                for (u = a[a.length - 1].ownerDocument, x.map(a, tL), d = 0; d < l; d++) c = a[d], tf.test(c.type || "") && !Q.access(c, "globalEval") && x.contains(u, c) && (c.src && "module" !== (c.type || "").toLowerCase() ? x._evalUrl && !c.noModule && x._evalUrl(c.src, {
                    nonce: c.nonce || c.getAttribute("nonce")
                }, u) : y(c.textContent.replace(t9, ""), c, u))
        }
        return t
    }

    function tO(t, e, i) {
        for (var n, o = e ? x.filter(e, t) : t, s = 0; null != (n = o[s]); s++) i || 1 !== n.nodeType || x.cleanData(tv(n)), n.parentNode && (i && to(n) && tm(tv(n, "script")), n.parentNode.removeChild(n));
        return t
    }
    x.extend({
        htmlPrefilter: function(t) {
            return t
        },
        clone: function(t, e, i) {
            var n, o, s, r, a, l, c, u = t.cloneNode(!0),
                d = to(t);
            if (!(h.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || x.isXMLDoc(t)))
                for (r = tv(u), n = 0, o = (s = tv(t)).length; n < o; n++) a = s[n], "input" === (c = (l = r[n]).nodeName.toLowerCase()) && tp.test(a.type) ? l.checked = a.checked : "input" !== c && "textarea" !== c || (l.defaultValue = a.defaultValue);
            if (e) {
                if (i)
                    for (s = s || tv(t), r = r || tv(u), n = 0, o = s.length; n < o; n++) tj(s[n], r[n]);
                else tj(t, u)
            }
            return 0 < (r = tv(u, "script")).length && tm(r, !d && tv(t, "script")), u
        },
        cleanData: function(t) {
            for (var e, i, n, o = x.event.special, s = 0; void 0 !== (i = t[s]); s++)
                if (Y(i)) {
                    if (e = i[Q.expando]) {
                        if (e.events)
                            for (n in e.events) o[n] ? x.event.remove(i, n) : x.removeEvent(i, n, e.handle);
                        i[Q.expando] = void 0
                    }
                    i[V.expando] && (i[V.expando] = void 0)
                }
        }
    }), x.fn.extend({
        detach: function(t) {
            return tO(this, t, !0)
        },
        remove: function(t) {
            return tO(this, t)
        },
        text: function(t) {
            return M(this, function(t) {
                return void 0 === t ? x.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return tD(this, arguments, function(t) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || tE(this, t).appendChild(t)
            })
        },
        prepend: function() {
            return tD(this, arguments, function(t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = tE(this, t);
                    e.insertBefore(t, e.firstChild)
                }
            })
        },
        before: function() {
            return tD(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return tD(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (x.cleanData(tv(t, !1)), t.textContent = "");
            return this
        },
        clone: function(t, e) {
            return t = null != t && t, e = null == e ? t : e, this.map(function() {
                return x.clone(this, t, e)
            })
        },
        html: function(t) {
            return M(this, function(t) {
                var e = this[0] || {},
                    i = 0,
                    n = this.length;
                if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                if ("string" == typeof t && !tS.test(t) && !tg[(th.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = x.htmlPrefilter(t);
                    try {
                        for (; i < n; i++) 1 === (e = this[i] || {}).nodeType && (x.cleanData(tv(e, !1)), e.innerHTML = t);
                        e = 0
                    } catch (o) {}
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return tD(this, arguments, function(e) {
                var i = this.parentNode;
                0 > x.inArray(this, t) && (x.cleanData(tv(this)), i && i.replaceChild(e, this))
            }, t)
        }
    }), x.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(t, e) {
        x.fn[t] = function(t) {
            for (var i, n = [], o = x(t), s = o.length - 1, a = 0; a <= s; a++) i = a === s ? this : this.clone(!0), x(o[a])[e](i), r.apply(n, i.get());
            return this.pushStack(n)
        }
    });
    var tH = RegExp("^(" + tt + ")(?!px)[a-z%]+$", "i"),
        tz = function(e) {
            var i = e.ownerDocument.defaultView;
            return i && i.opener || (i = t), i.getComputedStyle(e)
        },
        tP = function(t, e, i) {
            var n, o, s = {};
            for (o in e) s[o] = t.style[o], t.style[o] = e[o];
            for (o in n = i.call(t), e) t.style[o] = s[o];
            return n
        },
        tN = RegExp(ti.join("|"), "i");

    function tI(t, e, i) {
        var n, o, s, r, a = t.style;
        return (i = i || tz(t)) && ("" !== (r = i.getPropertyValue(e) || i[e]) || to(t) || (r = x.style(t, e)), !h.pixelBoxStyles() && tH.test(r) && tN.test(e) && (n = a.width, o = a.minWidth, s = a.maxWidth, a.minWidth = a.maxWidth = a.width = r, r = i.width, a.width = n, a.minWidth = o, a.maxWidth = s)), void 0 !== r ? r + "" : r
    }

    function tq(t, e) {
        return {
            get: function() {
                if (!t()) return (this.get = e).apply(this, arguments);
                delete this.get
            }
        }
    }! function() {
        function e() {
            if (u) {
                c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", tn.appendChild(c).appendChild(u);
                var e = t.getComputedStyle(u);
                n = "1%" !== e.top, l = 12 === i(e.marginLeft), u.style.right = "60%", r = 36 === i(e.right), o = 36 === i(e.width), u.style.position = "absolute", s = 12 === i(u.offsetWidth / 3), tn.removeChild(c), u = null
            }
        }

        function i(t) {
            return Math.round(parseFloat(t))
        }
        var n, o, s, r, a, l, c = v.createElement("div"),
            u = v.createElement("div");
        u.style && (u.style.backgroundClip = "content-box", u.cloneNode(!0).style.backgroundClip = "", h.clearCloneStyle = "content-box" === u.style.backgroundClip, x.extend(h, {
            boxSizingReliable: function() {
                return e(), o
            },
            pixelBoxStyles: function() {
                return e(), r
            },
            pixelPosition: function() {
                return e(), n
            },
            reliableMarginLeft: function() {
                return e(), l
            },
            scrollboxSize: function() {
                return e(), s
            },
            reliableTrDimensions: function() {
                var e, i, n, o;
                return null == a && (e = v.createElement("table"), i = v.createElement("tr"), n = v.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", i.style.cssText = "border:1px solid", i.style.height = "1px", n.style.height = "9px", n.style.display = "block", tn.appendChild(e).appendChild(i).appendChild(n), a = parseInt((o = t.getComputedStyle(i)).height, 10) + parseInt(o.borderTopWidth, 10) + parseInt(o.borderBottomWidth, 10) === i.offsetHeight, tn.removeChild(e)), a
            }
        }))
    }();
    var tW = ["Webkit", "Moz", "ms"],
        t8 = v.createElement("div").style,
        tR = {};

    function t0(t) {
        return x.cssProps[t] || tR[t] || (t in t8 ? t : tR[t] = function(t) {
            for (var e = t[0].toUpperCase() + t.slice(1), i = tW.length; i--;)
                if ((t = tW[i] + e) in t8) return t
        }(t) || t)
    }
    var tM = /^(none|table(?!-c[ea]).+)/,
        tB = /^--/,
        tF = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        t1 = {
            letterSpacing: "0",
            fontWeight: "400"
        };

    function tU(t, e, i) {
        var n = te.exec(e);
        return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e
    }

    function tX(t, e, i, n, o, s) {
        var r = "width" === e ? 1 : 0,
            a = 0,
            l = 0;
        if (i === (n ? "border" : "content")) return 0;
        for (; r < 4; r += 2) "margin" === i && (l += x.css(t, i + ti[r], !0, o)), n ? ("content" === i && (l -= x.css(t, "padding" + ti[r], !0, o)), "margin" !== i && (l -= x.css(t, "border" + ti[r] + "Width", !0, o))) : (l += x.css(t, "padding" + ti[r], !0, o), "padding" !== i ? l += x.css(t, "border" + ti[r] + "Width", !0, o) : a += x.css(t, "border" + ti[r] + "Width", !0, o));
        return !n && 0 <= s && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - s - l - a - .5)) || 0), l
    }

    function tY(t, e, i) {
        var n = tz(t),
            o = (!h.boxSizingReliable() || i) && "border-box" === x.css(t, "boxSizing", !1, n),
            s = o,
            r = tI(t, e, n),
            a = "offset" + e[0].toUpperCase() + e.slice(1);
        if (tH.test(r)) {
            if (!i) return r;
            r = "auto"
        }
        return (!h.boxSizingReliable() && o || !h.reliableTrDimensions() && C(t, "tr") || "auto" === r || !parseFloat(r) && "inline" === x.css(t, "display", !1, n)) && t.getClientRects().length && (o = "border-box" === x.css(t, "boxSizing", !1, n), (s = a in t) && (r = t[a])), (r = parseFloat(r) || 0) + tX(t, e, i || (o ? "border" : "content"), s, n, r) + "px"
    }

    function t3(t, e, i, n, o) {
        return new t3.prototype.init(t, e, i, n, o)
    }
    x.extend({
        cssHooks: {
            opacity: {
                get: function(t, e) {
                    if (e) {
                        var i = tI(t, "opacity");
                        return "" === i ? "1" : i
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(t, e, i, n) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var o, s, r, a = X(e),
                    l = tB.test(e),
                    c = t.style;
                if (l || (e = t0(a)), r = x.cssHooks[e] || x.cssHooks[a], void 0 === i) return r && "get" in r && void 0 !== (o = r.get(t, !1, n)) ? o : c[e];
                "string" == (s = typeof i) && (o = te.exec(i)) && o[1] && (i = ta(t, e, o), s = "number"), null != i && i == i && ("number" !== s || l || (i += o && o[3] || (x.cssNumber[a] ? "" : "px")), h.clearCloneStyle || "" !== i || 0 !== e.indexOf("background") || (c[e] = "inherit"), r && "set" in r && void 0 === (i = r.set(t, i, n)) || (l ? c.setProperty(e, i) : c[e] = i))
            }
        },
        css: function(t, e, i, n) {
            var o, s, r, a = X(e);
            return tB.test(e) || (e = t0(a)), (r = x.cssHooks[e] || x.cssHooks[a]) && "get" in r && (o = r.get(t, !0, i)), void 0 === o && (o = tI(t, e, n)), "normal" === o && e in t1 && (o = t1[e]), "" === i || i ? (s = parseFloat(o), !0 === i || isFinite(s) ? s || 0 : o) : o
        }
    }), x.each(["height", "width"], function(t, e) {
        x.cssHooks[e] = {
            get: function(t, i, n) {
                if (i) return !tM.test(x.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? tY(t, e, n) : tP(t, tF, function() {
                    return tY(t, e, n)
                })
            },
            set: function(t, i, n) {
                var o, s = tz(t),
                    r = !h.scrollboxSize() && "absolute" === s.position,
                    a = (r || n) && "border-box" === x.css(t, "boxSizing", !1, s),
                    l = n ? tX(t, e, n, a, s) : 0;
                return a && r && (l -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(s[e]) - tX(t, e, "border", !1, s) - .5)), l && (o = te.exec(i)) && "px" !== (o[3] || "px") && (t.style[e] = i, i = x.css(t, e)), tU(0, i, l)
            }
        }
    }), x.cssHooks.marginLeft = tq(h.reliableMarginLeft, function(t, e) {
        if (e) return (parseFloat(tI(t, "marginLeft")) || t.getBoundingClientRect().left - tP(t, {
            marginLeft: 0
        }, function() {
            return t.getBoundingClientRect().left
        })) + "px"
    }), x.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(t, e) {
        x.cssHooks[t + e] = {
            expand: function(i) {
                for (var n = 0, o = {}, s = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++) o[t + ti[n] + e] = s[n] || s[n - 2] || s[0];
                return o
            }
        }, "margin" !== t && (x.cssHooks[t + e].set = tU)
    }), x.fn.extend({
        css: function(t, e) {
            return M(this, function(t, e, i) {
                var n, o, s = {},
                    r = 0;
                if (Array.isArray(e)) {
                    for (n = tz(t), o = e.length; r < o; r++) s[e[r]] = x.css(t, e[r], !1, n);
                    return s
                }
                return void 0 !== i ? x.style(t, e, i) : x.css(t, e)
            }, t, e, 1 < arguments.length)
        }
    }), ((x.Tween = t3).prototype = {
        constructor: t3,
        init: function(t, e, i, n, o, s) {
            this.elem = t, this.prop = i, this.easing = o || x.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = n, this.unit = s || (x.cssNumber[i] ? "" : "px")
        },
        cur: function() {
            var t = t3.propHooks[this.prop];
            return t && t.get ? t.get(this) : t3.propHooks._default.get(this)
        },
        run: function(t) {
            var e, i = t3.propHooks[this.prop];
            return this.options.duration ? this.pos = e = x.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : t3.propHooks._default.set(this), this
        }
    }).init.prototype = t3.prototype, (t3.propHooks = {
        _default: {
            get: function(t) {
                var e;
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = x.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
            },
            set: function(t) {
                x.fx.step[t.prop] ? x.fx.step[t.prop](t) : 1 === t.elem.nodeType && (x.cssHooks[t.prop] || null != t.elem.style[t0(t.prop)]) ? x.style(t.elem, t.prop, t.now + t.unit) : t.elem[t.prop] = t.now
            }
        }
    }).scrollTop = t3.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    }, x.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    }, x.fx = t3.prototype.init, x.fx.step = {};
    var t2, t4, tG, tQ, tV = /^(?:toggle|show|hide)$/,
        t7 = /queueHooks$/;

    function t6() {
        return t.setTimeout(function() {
            t2 = void 0
        }), t2 = Date.now()
    }

    function t5(t, e) {
        var i, n = 0,
            o = {
                height: t
            };
        for (e = e ? 1 : 0; n < 4; n += 2 - e) o["margin" + (i = ti[n])] = o["padding" + i] = t;
        return e && (o.opacity = o.width = t), o
    }

    function tK(t, e, i) {
        for (var n, o = (tJ.tweeners[e] || []).concat(tJ.tweeners["*"]), s = 0, r = o.length; s < r; s++)
            if (n = o[s].call(i, e, t)) return n
    }

    function tJ(t, e, i) {
        var n, o, s = 0,
            r = tJ.prefilters.length,
            a = x.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (o) return !1;
                for (var e = t2 || t6(), i = Math.max(0, c.startTime + c.duration - e), n = 1 - (i / c.duration || 0), s = 0, r = c.tweens.length; s < r; s++) c.tweens[s].run(n);
                return a.notifyWith(t, [c, n, i]), n < 1 && r ? i : (r || a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c]), !1)
            },
            c = a.promise({
                elem: t,
                props: x.extend({}, e),
                opts: x.extend(!0, {
                    specialEasing: {},
                    easing: x.easing._default
                }, i),
                originalProperties: e,
                originalOptions: i,
                startTime: t2 || t6(),
                duration: i.duration,
                tweens: [],
                createTween: function(e, i) {
                    var n = x.Tween(t, c.opts, e, i, c.opts.specialEasing[e] || c.opts.easing);
                    return c.tweens.push(n), n
                },
                stop: function(e) {
                    var i = 0,
                        n = e ? c.tweens.length : 0;
                    if (o) return this;
                    for (o = !0; i < n; i++) c.tweens[i].run(1);
                    return e ? (a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c, e])) : a.rejectWith(t, [c, e]), this
                }
            }),
            u = c.props;
        for (function(t, e) {
                var i, n, o, s, r;
                for (i in t)
                    if (o = e[n = X(i)], Array.isArray(s = t[i]) && (o = s[1], s = t[i] = s[0]), i !== n && (t[n] = s, delete t[i]), (r = x.cssHooks[n]) && ("expand" in r))
                        for (i in s = r.expand(s), delete t[n], s)(i in t) || (t[i] = s[i], e[i] = o);
                    else e[n] = o
            }(u, c.opts.specialEasing); s < r; s++)
            if (n = tJ.prefilters[s].call(c, t, u, c.opts)) return f(n.stop) && (x._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)), n;
        return x.map(u, tK, c), f(c.opts.start) && c.opts.start.call(t, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), x.fx.timer(x.extend(l, {
            elem: t,
            anim: c,
            queue: c.opts.queue
        })), c
    }
    x.Animation = x.extend(tJ, {
        tweeners: {
            "*": [function(t, e) {
                var i = this.createTween(t, e);
                return ta(i.elem, t, te.exec(e), i), i
            }]
        },
        tweener: function(t, e) {
            f(t) ? (e = t, t = ["*"]) : t = t.match(z);
            for (var i, n = 0, o = t.length; n < o; n++) i = t[n], tJ.tweeners[i] = tJ.tweeners[i] || [], tJ.tweeners[i].unshift(e)
        },
        prefilters: [function(t, e, i) {
            var n, o, s, r, a, l, c, u, d = "width" in e || "height" in e,
                p = this,
                h = {},
                f = t.style,
                g = t.nodeType && tr(t),
                v = Q.get(t, "fxshow");
            for (n in i.queue || (null == (r = x._queueHooks(t, "fx")).unqueued && (r.unqueued = 0, a = r.empty.fire, r.empty.fire = function() {
                    r.unqueued || a()
                }), r.unqueued++, p.always(function() {
                    p.always(function() {
                        r.unqueued--, x.queue(t, "fx").length || r.empty.fire()
                    })
                })), e)
                if (o = e[n], tV.test(o)) {
                    if (delete e[n], s = s || "toggle" === o, o === (g ? "hide" : "show")) {
                        if ("show" !== o || !v || void 0 === v[n]) continue;
                        g = !0
                    }
                    h[n] = v && v[n] || x.style(t, n)
                }
            if ((l = !x.isEmptyObject(e)) || !x.isEmptyObject(h))
                for (n in d && 1 === t.nodeType && (i.overflow = [f.overflow, f.overflowX, f.overflowY], null == (c = v && v.display) && (c = Q.get(t, "display")), "none" === (u = x.css(t, "display")) && (c ? u = c : (tc([t], !0), c = t.style.display || c, u = x.css(t, "display"), tc([t]))), ("inline" === u || "inline-block" === u && null != c) && "none" === x.css(t, "float") && (l || (p.done(function() {
                        f.display = c
                    }), null == c && (c = "none" === (u = f.display) ? "" : u)), f.display = "inline-block")), i.overflow && (f.overflow = "hidden", p.always(function() {
                        f.overflow = i.overflow[0], f.overflowX = i.overflow[1], f.overflowY = i.overflow[2]
                    })), l = !1, h) l || (v ? "hidden" in v && (g = v.hidden) : v = Q.access(t, "fxshow", {
                    display: c
                }), s && (v.hidden = !g), g && tc([t], !0), p.done(function() {
                    for (n in g || tc([t]), Q.remove(t, "fxshow"), h) x.style(t, n, h[n])
                })), l = tK(g ? v[n] : 0, n, p), n in v || (v[n] = l.start, g && (l.end = l.start, l.start = 0))
        }],
        prefilter: function(t, e) {
            e ? tJ.prefilters.unshift(t) : tJ.prefilters.push(t)
        }
    }), x.speed = function(t, e, i) {
        var n = t && "object" == typeof t ? x.extend({}, t) : {
            complete: i || !i && e || f(t) && t,
            duration: t,
            easing: i && e || e && !f(e) && e
        };
        return x.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in x.fx.speeds ? n.duration = x.fx.speeds[n.duration] : n.duration = x.fx.speeds._default), null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function() {
            f(n.old) && n.old.call(this), n.queue && x.dequeue(this, n.queue)
        }, n
    }, x.fn.extend({
        fadeTo: function(t, e, i, n) {
            return this.filter(tr).css("opacity", 0).show().end().animate({
                opacity: e
            }, t, i, n)
        },
        animate: function(t, e, i, n) {
            var o = x.isEmptyObject(t),
                s = x.speed(e, i, n),
                r = function() {
                    var e = tJ(this, x.extend({}, t), s);
                    (o || Q.get(this, "finish")) && e.stop(!0)
                };
            return r.finish = r, o || !1 === s.queue ? this.each(r) : this.queue(s.queue, r)
        },
        stop: function(t, e, i) {
            var n = function(t) {
                var e = t.stop;
                delete t.stop, e(i)
            };
            return "string" != typeof t && (i = e, e = t, t = void 0), e && this.queue(t || "fx", []), this.each(function() {
                var e = !0,
                    o = null != t && t + "queueHooks",
                    s = x.timers,
                    r = Q.get(this);
                if (o) r[o] && r[o].stop && n(r[o]);
                else
                    for (o in r) r[o] && r[o].stop && t7.test(o) && n(r[o]);
                for (o = s.length; o--;) s[o].elem !== this || null != t && s[o].queue !== t || (s[o].anim.stop(i), e = !1, s.splice(o, 1));
                !e && i || x.dequeue(this, t)
            })
        },
        finish: function(t) {
            return !1 !== t && (t = t || "fx"), this.each(function() {
                var e, i = Q.get(this),
                    n = i[t + "queue"],
                    o = i[t + "queueHooks"],
                    s = x.timers,
                    r = n ? n.length : 0;
                for (i.finish = !0, x.queue(this, t, []), o && o.stop && o.stop.call(this, !0), e = s.length; e--;) s[e].elem === this && s[e].queue === t && (s[e].anim.stop(!0), s.splice(e, 1));
                for (e = 0; e < r; e++) n[e] && n[e].finish && n[e].finish.call(this);
                delete i.finish
            })
        }
    }), x.each(["toggle", "show", "hide"], function(t, e) {
        var i = x.fn[e];
        x.fn[e] = function(t, n, o) {
            return null == t || "boolean" == typeof t ? i.apply(this, arguments) : this.animate(t5(e, !0), t, n, o)
        }
    }), x.each({
        slideDown: t5("show"),
        slideUp: t5("hide"),
        slideToggle: t5("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(t, e) {
        x.fn[t] = function(t, i, n) {
            return this.animate(e, t, i, n)
        }
    }), x.timers = [], x.fx.tick = function() {
        var t, e = 0,
            i = x.timers;
        for (t2 = Date.now(); e < i.length; e++)(t = i[e])() || i[e] !== t || i.splice(e--, 1);
        i.length || x.fx.stop(), t2 = void 0
    }, x.fx.timer = function(t) {
        x.timers.push(t), x.fx.start()
    }, x.fx.interval = 13, x.fx.start = function() {
        t4 || (t4 = !0, function e() {
            t4 && (!1 === v.hidden && t.requestAnimationFrame ? t.requestAnimationFrame(e) : t.setTimeout(e, x.fx.interval), x.fx.tick())
        }())
    }, x.fx.stop = function() {
        t4 = null
    }, x.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, x.fn.delay = function(e, i) {
        return e = x.fx && x.fx.speeds[e] || e, i = i || "fx", this.queue(i, function(i, n) {
            var o = t.setTimeout(i, e);
            n.stop = function() {
                t.clearTimeout(o)
            }
        })
    }, tG = v.createElement("input"), tQ = v.createElement("select").appendChild(v.createElement("option")), tG.type = "checkbox", h.checkOn = "" !== tG.value, h.optSelected = tQ.selected, (tG = v.createElement("input")).value = "t", tG.type = "radio", h.radioValue = "t" === tG.value;
    var tZ, et = x.expr.attrHandle;
    x.fn.extend({
        attr: function(t, e) {
            return M(this, x.attr, t, e, 1 < arguments.length)
        },
        removeAttr: function(t) {
            return this.each(function() {
                x.removeAttr(this, t)
            })
        }
    }), x.extend({
        attr: function(t, e, i) {
            var n, o, s = t.nodeType;
            if (3 !== s && 8 !== s && 2 !== s) return void 0 === t.getAttribute ? x.prop(t, e, i) : (1 === s && x.isXMLDoc(t) || (o = x.attrHooks[e.toLowerCase()] || (x.expr.match.bool.test(e) ? tZ : void 0)), void 0 !== i ? null === i ? void x.removeAttr(t, e) : o && "set" in o && void 0 !== (n = o.set(t, i, e)) ? n : (t.setAttribute(e, i + ""), i) : o && "get" in o && null !== (n = o.get(t, e)) ? n : null == (n = x.find.attr(t, e)) ? void 0 : n)
        },
        attrHooks: {
            type: {
                set: function(t, e) {
                    if (!h.radioValue && "radio" === e && C(t, "input")) {
                        var i = t.value;
                        return t.setAttribute("type", e), i && (t.value = i), e
                    }
                }
            }
        },
        removeAttr: function(t, e) {
            var i, n = 0,
                o = e && e.match(z);
            if (o && 1 === t.nodeType)
                for (; i = o[n++];) t.removeAttribute(i)
        }
    }), tZ = {
        set: function(t, e, i) {
            return !1 === e ? x.removeAttr(t, i) : t.setAttribute(i, i), i
        }
    }, x.each(x.expr.match.bool.source.match(/\w+/g), function(t, e) {
        var i = et[e] || x.find.attr;
        et[e] = function(t, e, n) {
            var o, s, r = e.toLowerCase();
            return n || (s = et[r], et[r] = o, o = null != i(t, e, n) ? r : null, et[r] = s), o
        }
    });
    var ee = /^(?:input|select|textarea|button)$/i,
        ei = /^(?:a|area)$/i;

    function en(t) {
        return (t.match(z) || []).join(" ")
    }

    function eo(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }

    function es(t) {
        return Array.isArray(t) ? t : "string" == typeof t && t.match(z) || []
    }
    x.fn.extend({
        prop: function(t, e) {
            return M(this, x.prop, t, e, 1 < arguments.length)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[x.propFix[t] || t]
            })
        }
    }), x.extend({
        prop: function(t, e, i) {
            var n, o, s = t.nodeType;
            if (3 !== s && 8 !== s && 2 !== s) return 1 === s && x.isXMLDoc(t) || (e = x.propFix[e] || e, o = x.propHooks[e]), void 0 !== i ? o && "set" in o && void 0 !== (n = o.set(t, i, e)) ? n : t[e] = i : o && "get" in o && null !== (n = o.get(t, e)) ? n : t[e]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var e = x.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : ee.test(t.nodeName) || ei.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), h.optSelected || (x.propHooks.selected = {
        get: function(t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex, null
        },
        set: function(t) {
            var e = t.parentNode;
            e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
        }
    }), x.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        x.propFix[this.toLowerCase()] = this
    }), x.fn.extend({
        addClass: function(t) {
            var e, i, n, o, s, r, a, l = 0;
            if (f(t)) return this.each(function(e) {
                x(this).addClass(t.call(this, e, eo(this)))
            });
            if ((e = es(t)).length) {
                for (; i = this[l++];)
                    if (o = eo(i), n = 1 === i.nodeType && " " + en(o) + " ") {
                        for (r = 0; s = e[r++];) 0 > n.indexOf(" " + s + " ") && (n += s + " ");
                        o !== (a = en(n)) && i.setAttribute("class", a)
                    }
            }
            return this
        },
        removeClass: function(t) {
            var e, i, n, o, s, r, a, l = 0;
            if (f(t)) return this.each(function(e) {
                x(this).removeClass(t.call(this, e, eo(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ((e = es(t)).length) {
                for (; i = this[l++];)
                    if (o = eo(i), n = 1 === i.nodeType && " " + en(o) + " ") {
                        for (r = 0; s = e[r++];)
                            for (; - 1 < n.indexOf(" " + s + " ");) n = n.replace(" " + s + " ", " ");
                        o !== (a = en(n)) && i.setAttribute("class", a)
                    }
            }
            return this
        },
        toggleClass: function(t, e) {
            var i = typeof t,
                n = "string" === i || Array.isArray(t);
            return "boolean" == typeof e && n ? e ? this.addClass(t) : this.removeClass(t) : f(t) ? this.each(function(i) {
                x(this).toggleClass(t.call(this, i, eo(this), e), e)
            }) : this.each(function() {
                var e, o, s, r;
                if (n)
                    for (o = 0, s = x(this), r = es(t); e = r[o++];) s.hasClass(e) ? s.removeClass(e) : s.addClass(e);
                else void 0 !== t && "boolean" !== i || ((e = eo(this)) && Q.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : Q.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var e, i, n = 0;
            for (e = " " + t + " "; i = this[n++];)
                if (1 === i.nodeType && -1 < (" " + en(eo(i)) + " ").indexOf(e)) return !0;
            return !1
        }
    });
    var er = /\r/g;
    x.fn.extend({
        val: function(t) {
            var e, i, n, o = this[0];
            return arguments.length ? (n = f(t), this.each(function(i) {
                var o;
                1 === this.nodeType && (null == (o = n ? t.call(this, i, x(this).val()) : t) ? o = "" : "number" == typeof o ? o += "" : Array.isArray(o) && (o = x.map(o, function(t) {
                    return null == t ? "" : t + ""
                })), (e = x.valHooks[this.type] || x.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, o, "value") || (this.value = o))
            })) : o ? (e = x.valHooks[o.type] || x.valHooks[o.nodeName.toLowerCase()]) && "get" in e && void 0 !== (i = e.get(o, "value")) ? i : "string" == typeof(i = o.value) ? i.replace(er, "") : null == i ? "" : i : void 0
        }
    }), x.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var e = x.find.attr(t, "value");
                    return null != e ? e : en(x.text(t))
                }
            },
            select: {
                get: function(t) {
                    var e, i, n, o = t.options,
                        s = t.selectedIndex,
                        r = "select-one" === t.type,
                        a = r ? null : [],
                        l = r ? s + 1 : o.length;
                    for (n = s < 0 ? l : r ? s : 0; n < l; n++)
                        if (((i = o[n]).selected || n === s) && !i.disabled && (!i.parentNode.disabled || !C(i.parentNode, "optgroup"))) {
                            if (e = x(i).val(), r) return e;
                            a.push(e)
                        }
                    return a
                },
                set: function(t, e) {
                    for (var i, n, o = t.options, s = x.makeArray(e), r = o.length; r--;)((n = o[r]).selected = -1 < x.inArray(x.valHooks.option.get(n), s)) && (i = !0);
                    return i || (t.selectedIndex = -1), s
                }
            }
        }
    }), x.each(["radio", "checkbox"], function() {
        x.valHooks[this] = {
            set: function(t, e) {
                if (Array.isArray(e)) return t.checked = -1 < x.inArray(x(t).val(), e)
            }
        }, h.checkOn || (x.valHooks[this].get = function(t) {
            return null === t.getAttribute("value") ? "on" : t.value
        })
    }), h.focusin = "onfocusin" in t;
    var ea = /^(?:focusinfocus|focusoutblur)$/,
        el = function(t) {
            t.stopPropagation()
        };
    x.extend(x.event, {
        trigger: function(e, i, n, o) {
            var s, r, a, l, c, d, p, h, m = [n || v],
                y = u.call(e, "type") ? e.type : e,
                $ = u.call(e, "namespace") ? e.namespace.split(".") : [];
            if (r = h = a = n = n || v, 3 !== n.nodeType && 8 !== n.nodeType && !ea.test(y + x.event.triggered) && (-1 < y.indexOf(".") && (y = ($ = y.split(".")).shift(), $.sort()), c = 0 > y.indexOf(":") && "on" + y, (e = e[x.expando] ? e : new x.Event(y, "object" == typeof e && e)).isTrigger = o ? 2 : 3, e.namespace = $.join("."), e.rnamespace = e.namespace ? RegExp("(^|\\.)" + $.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), i = null == i ? [e] : x.makeArray(i, [e]), p = x.event.special[y] || {}, o || !p.trigger || !1 !== p.trigger.apply(n, i))) {
                if (!o && !p.noBubble && !g(n)) {
                    for (l = p.delegateType || y, ea.test(l + y) || (r = r.parentNode); r; r = r.parentNode) m.push(r), a = r;
                    a === (n.ownerDocument || v) && m.push(a.defaultView || a.parentWindow || t)
                }
                for (s = 0;
                    (r = m[s++]) && !e.isPropagationStopped();) h = r, e.type = 1 < s ? l : p.bindType || y, (d = (Q.get(r, "events") || Object.create(null))[e.type] && Q.get(r, "handle")) && d.apply(r, i), (d = c && r[c]) && d.apply && Y(r) && (e.result = d.apply(r, i), !1 === e.result && e.preventDefault());
                return e.type = y, o || e.isDefaultPrevented() || p._default && !1 !== p._default.apply(m.pop(), i) || !Y(n) || c && f(n[y]) && !g(n) && ((a = n[c]) && (n[c] = null), x.event.triggered = y, e.isPropagationStopped() && h.addEventListener(y, el), n[y](), e.isPropagationStopped() && h.removeEventListener(y, el), x.event.triggered = void 0, a && (n[c] = a)), e.result
            }
        },
        simulate: function(t, e, i) {
            var n = x.extend(new x.Event, i, {
                type: t,
                isSimulated: !0
            });
            x.event.trigger(n, null, e)
        }
    }), x.fn.extend({
        trigger: function(t, e) {
            return this.each(function() {
                x.event.trigger(t, e, this)
            })
        },
        triggerHandler: function(t, e) {
            var i = this[0];
            if (i) return x.event.trigger(t, e, i, !0)
        }
    }), h.focusin || x.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        var i = function(t) {
            x.event.simulate(e, t.target, x.event.fix(t))
        };
        x.event.special[e] = {
            setup: function() {
                var n = this.ownerDocument || this.document || this,
                    o = Q.access(n, e);
                o || n.addEventListener(t, i, !0), Q.access(n, e, (o || 0) + 1)
            },
            teardown: function() {
                var n = this.ownerDocument || this.document || this,
                    o = Q.access(n, e) - 1;
                o ? Q.access(n, e, o) : (n.removeEventListener(t, i, !0), Q.remove(n, e))
            }
        }
    });
    var ec = t.location,
        eu = {
            guid: Date.now()
        },
        ed = /\?/;
    x.parseXML = function(e) {
        var i, n;
        if (!e || "string" != typeof e) return null;
        try {
            i = (new t.DOMParser).parseFromString(e, "text/xml")
        } catch (o) {}
        return n = i && i.getElementsByTagName("parsererror")[0], i && !n || x.error("Invalid XML: " + (n ? x.map(n.childNodes, function(t) {
            return t.textContent
        }).join("\n") : e)), i
    };
    var ep = /\[\]$/,
        eh = /\r?\n/g,
        ef = /^(?:submit|button|image|reset|file)$/i,
        eg = /^(?:input|select|textarea|keygen)/i;

    function ev(t, e, i, n) {
        var o;
        if (Array.isArray(e)) x.each(e, function(e, o) {
            i || ep.test(t) ? n(t, o) : ev(t + "[" + ("object" == typeof o && null != o ? e : "") + "]", o, i, n)
        });
        else if (i || "object" !== $(e)) n(t, e);
        else
            for (o in e) ev(t + "[" + o + "]", e[o], i, n)
    }
    x.param = function(t, e) {
        var i, n = [],
            o = function(t, e) {
                var i = f(e) ? e() : e;
                n[n.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == i ? "" : i)
            };
        if (null == t) return "";
        if (Array.isArray(t) || t.jquery && !x.isPlainObject(t)) x.each(t, function() {
            o(this.name, this.value)
        });
        else
            for (i in t) ev(i, t[i], e, o);
        return n.join("&")
    }, x.fn.extend({
        serialize: function() {
            return x.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = x.prop(this, "elements");
                return t ? x.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !x(this).is(":disabled") && eg.test(this.nodeName) && !ef.test(t) && (this.checked || !tp.test(t))
            }).map(function(t, e) {
                var i = x(this).val();
                return null == i ? null : Array.isArray(i) ? x.map(i, function(t) {
                    return {
                        name: e.name,
                        value: t.replace(eh, "\r\n")
                    }
                }) : {
                    name: e.name,
                    value: i.replace(eh, "\r\n")
                }
            }).get()
        }
    });
    var em = /%20/g,
        ey = /#.*$/,
        e$ = /([?&])_=[^&]*/,
        eb = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        ex = /^(?:GET|HEAD)$/,
        eT = /^\/\//,
        e_ = {},
        ew = {},
        ek = "*/".concat("*"),
        eS = v.createElement("a");

    function eC(t) {
        return function(e, i) {
            "string" != typeof e && (i = e, e = "*");
            var n, o = 0,
                s = e.toLowerCase().match(z) || [];
            if (f(i))
                for (; n = s[o++];) "+" === n[0] ? (t[n = n.slice(1) || "*"] = t[n] || []).unshift(i) : (t[n] = t[n] || []).push(i)
        }
    }

    function e9(t, e, i, n) {
        var o = {},
            s = t === ew;

        function r(a) {
            var l;
            return o[a] = !0, x.each(t[a] || [], function(t, a) {
                var c = a(e, i, n);
                return "string" != typeof c || s || o[c] ? s ? !(l = c) : void 0 : (e.dataTypes.unshift(c), r(c), !1)
            }), l
        }
        return r(e.dataTypes[0]) || !o["*"] && r("*")
    }

    function eE(t, e) {
        var i, n, o = x.ajaxSettings.flatOptions || {};
        for (i in e) void 0 !== e[i] && ((o[i] ? t : n || (n = {}))[i] = e[i]);
        return n && x.extend(!0, t, n), t
    }
    eS.href = ec.href, x.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ec.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ec.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": ek,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": x.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, e) {
            return e ? eE(eE(t, x.ajaxSettings), e) : eE(x.ajaxSettings, t)
        },
        ajaxPrefilter: eC(e_),
        ajaxTransport: eC(ew),
        ajax: function(e, i) {
            "object" == typeof e && (i = e, e = void 0), i = i || {};
            var n, o, s, r, a, l, c, u, d, p, h = x.ajaxSetup({}, i),
                f = h.context || h,
                g = h.context && (f.nodeType || f.jquery) ? x(f) : x.event,
                m = x.Deferred(),
                y = x.Callbacks("once memory"),
                $ = h.statusCode || {},
                b = {},
                T = {},
                _ = "canceled",
                w = {
                    readyState: 0,
                    getResponseHeader: function(t) {
                        var e;
                        if (c) {
                            if (!r)
                                for (r = {}; e = eb.exec(s);) r[e[1].toLowerCase() + " "] = (r[e[1].toLowerCase() + " "] || []).concat(e[2]);
                            e = r[t.toLowerCase() + " "]
                        }
                        return null == e ? null : e.join(", ")
                    },
                    getAllResponseHeaders: function() {
                        return c ? s : null
                    },
                    setRequestHeader: function(t, e) {
                        return null == c && (b[t = T[t.toLowerCase()] = T[t.toLowerCase()] || t] = e), this
                    },
                    overrideMimeType: function(t) {
                        return null == c && (h.mimeType = t), this
                    },
                    statusCode: function(t) {
                        var e;
                        if (t) {
                            if (c) w.always(t[w.status]);
                            else
                                for (e in t) $[e] = [$[e], t[e]]
                        }
                        return this
                    },
                    abort: function(t) {
                        var e = t || _;
                        return n && n.abort(e), C(0, e), this
                    }
                };
            if (m.promise(w), h.url = ((e || h.url || ec.href) + "").replace(eT, ec.protocol + "//"), h.type = i.method || i.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(z) || [""], null == h.crossDomain) {
                l = v.createElement("a");
                try {
                    l.href = h.url, l.href = l.href, h.crossDomain = eS.protocol + "//" + eS.host != l.protocol + "//" + l.host
                } catch (k) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = x.param(h.data, h.traditional)), e9(e_, h, i, w), c) return w;
            for (d in (u = x.event && h.global) && 0 == x.active++ && x.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !ex.test(h.type), o = h.url.replace(ey, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(em, "+")) : (p = h.url.slice(o.length), h.data && (h.processData || "string" == typeof h.data) && (o += (ed.test(o) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (o = o.replace(e$, "$1"), p = (ed.test(o) ? "&" : "?") + "_=" + eu.guid++ + p), h.url = o + p), h.ifModified && (x.lastModified[o] && w.setRequestHeader("If-Modified-Since", x.lastModified[o]), x.etag[o] && w.setRequestHeader("If-None-Match", x.etag[o])), (h.data && h.hasContent && !1 !== h.contentType || i.contentType) && w.setRequestHeader("Content-Type", h.contentType), w.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + ek + "; q=0.01" : "") : h.accepts["*"]), h.headers) w.setRequestHeader(d, h.headers[d]);
            if (h.beforeSend && (!1 === h.beforeSend.call(f, w, h) || c)) return w.abort();
            if (_ = "abort", y.add(h.complete), w.done(h.success), w.fail(h.error), n = e9(ew, h, i, w)) {
                if (w.readyState = 1, u && g.trigger("ajaxSend", [w, h]), c) return w;
                h.async && 0 < h.timeout && (a = t.setTimeout(function() {
                    w.abort("timeout")
                }, h.timeout));
                try {
                    c = !1, n.send(b, C)
                } catch (S) {
                    if (c) throw S;
                    C(-1, S)
                }
            } else C(-1, "No Transport");

            function C(e, i, r, l) {
                var d, p, v, b, T, _ = i;
                c || (c = !0, a && t.clearTimeout(a), n = void 0, s = l || "", w.readyState = 0 < e ? 4 : 0, d = 200 <= e && e < 300 || 304 === e, r && (b = function(t, e, i) {
                    for (var n, o, s, r, a = t.contents, l = t.dataTypes;
                        "*" === l[0];) l.shift(), void 0 === n && (n = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (n) {
                        for (o in a)
                            if (a[o] && a[o].test(n)) {
                                l.unshift(o);
                                break
                            }
                    }
                    if (l[0] in i) s = l[0];
                    else {
                        for (o in i) {
                            if (!l[0] || t.converters[o + " " + l[0]]) {
                                s = o;
                                break
                            }
                            r || (r = o)
                        }
                        s = s || r
                    }
                    if (s) return s !== l[0] && l.unshift(s), i[s]
                }(h, w, r)), !d && -1 < x.inArray("script", h.dataTypes) && 0 > x.inArray("json", h.dataTypes) && (h.converters["text script"] = function() {}), b = function(t, e, i, n) {
                    var o, s, r, a, l, c = {},
                        u = t.dataTypes.slice();
                    if (u[1])
                        for (r in t.converters) c[r.toLowerCase()] = t.converters[r];
                    for (s = u.shift(); s;)
                        if (t.responseFields[s] && (i[t.responseFields[s]] = e), !l && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = s, s = u.shift()) {
                            if ("*" === s) s = l;
                            else if ("*" !== l && l !== s) {
                                if (!(r = c[l + " " + s] || c["* " + s])) {
                                    for (o in c)
                                        if ((a = o.split(" "))[1] === s && (r = c[l + " " + a[0]] || c["* " + a[0]])) {
                                            !0 === r ? r = c[o] : !0 !== c[o] && (s = a[0], u.unshift(a[1]));
                                            break
                                        }
                                }
                                if (!0 !== r) {
                                    if (r && t.throws) e = r(e);
                                    else try {
                                        e = r(e)
                                    } catch (d) {
                                        return {
                                            state: "parsererror",
                                            error: r ? d : "No conversion from " + l + " to " + s
                                        }
                                    }
                                }
                            }
                        }
                    return {
                        state: "success",
                        data: e
                    }
                }(h, b, w, d), d ? (h.ifModified && ((T = w.getResponseHeader("Last-Modified")) && (x.lastModified[o] = T), (T = w.getResponseHeader("etag")) && (x.etag[o] = T)), 204 === e || "HEAD" === h.type ? _ = "nocontent" : 304 === e ? _ = "notmodified" : (_ = b.state, p = b.data, d = !(v = b.error))) : (v = _, !e && _ || (_ = "error", e < 0 && (e = 0))), w.status = e, w.statusText = (i || _) + "", d ? m.resolveWith(f, [p, _, w]) : m.rejectWith(f, [w, _, v]), w.statusCode($), $ = void 0, u && g.trigger(d ? "ajaxSuccess" : "ajaxError", [w, h, d ? p : v]), y.fireWith(f, [w, _]), u && (g.trigger("ajaxComplete", [w, h]), --x.active || x.event.trigger("ajaxStop")))
            }
            return w
        },
        getJSON: function(t, e, i) {
            return x.get(t, e, i, "json")
        },
        getScript: function(t, e) {
            return x.get(t, void 0, e, "script")
        }
    }), x.each(["get", "post"], function(t, e) {
        x[e] = function(t, i, n, o) {
            return f(i) && (o = o || n, n = i, i = void 0), x.ajax(x.extend({
                url: t,
                type: e,
                dataType: o,
                data: i,
                success: n
            }, x.isPlainObject(t) && t))
        }
    }), x.ajaxPrefilter(function(t) {
        var e;
        for (e in t.headers) "content-type" === e.toLowerCase() && (t.contentType = t.headers[e] || "")
    }), x._evalUrl = function(t, e, i) {
        return x.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(t) {
                x.globalEval(t, e, i)
            }
        })
    }, x.fn.extend({
        wrapAll: function(t) {
            var e;
            return this[0] && (f(t) && (t = t.call(this[0])), e = x(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                return t
            }).append(this)), this
        },
        wrapInner: function(t) {
            return f(t) ? this.each(function(e) {
                x(this).wrapInner(t.call(this, e))
            }) : this.each(function() {
                var e = x(this),
                    i = e.contents();
                i.length ? i.wrapAll(t) : e.append(t)
            })
        },
        wrap: function(t) {
            var e = f(t);
            return this.each(function(i) {
                x(this).wrapAll(e ? t.call(this, i) : t)
            })
        },
        unwrap: function(t) {
            return this.parent(t).not("body").each(function() {
                x(this).replaceWith(this.childNodes)
            }), this
        }
    }), x.expr.pseudos.hidden = function(t) {
        return !x.expr.pseudos.visible(t)
    }, x.expr.pseudos.visible = function(t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
    }, x.ajaxSettings.xhr = function() {
        try {
            return new t.XMLHttpRequest
        } catch (e) {}
    };
    var eA = {
            0: 200,
            1223: 204
        },
        eL = x.ajaxSettings.xhr();
    h.cors = !!eL && "withCredentials" in eL, h.ajax = eL = !!eL, x.ajaxTransport(function(e) {
        var i, n;
        if (h.cors || eL && !e.crossDomain) return {
            send: function(o, s) {
                var r, a = e.xhr();
                if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                    for (r in e.xhrFields) a[r] = e.xhrFields[r];
                for (r in e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o) a.setRequestHeader(r, o[r]);
                i = function(t) {
                    return function() {
                        i && (i = n = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null, "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? s(0, "error") : s(a.status, a.statusText) : s(eA[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }, a.onload = i(), n = a.onerror = a.ontimeout = i("error"), void 0 !== a.onabort ? a.onabort = n : a.onreadystatechange = function() {
                    4 === a.readyState && t.setTimeout(function() {
                        i && n()
                    })
                }, i = i("abort");
                try {
                    a.send(e.hasContent && e.data || null)
                } catch (l) {
                    if (i) throw l
                }
            },
            abort: function() {
                i && i()
            }
        }
    }), x.ajaxPrefilter(function(t) {
        t.crossDomain && (t.contents.script = !1)
    }), x.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return x.globalEval(t), t
            }
        }
    }), x.ajaxPrefilter("script", function(t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
    }), x.ajaxTransport("script", function(t) {
        var e, i;
        if (t.crossDomain || t.scriptAttrs) return {
            send: function(n, o) {
                e = x("<script>").attr(t.scriptAttrs || {}).prop({
                    charset: t.scriptCharset,
                    src: t.url
                }).on("load error", i = function(t) {
                    e.remove(), i = null, t && o("error" === t.type ? 404 : 200, t.type)
                }), v.head.appendChild(e[0])
            },
            abort: function() {
                i && i()
            }
        }
    });
    var ej, eD = [],
        eO = /(=)\?(?=&|$)|\?\?/;
    x.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = eD.pop() || x.expando + "_" + eu.guid++;
            return this[t] = !0, t
        }
    }), x.ajaxPrefilter("json jsonp", function(e, i, n) {
        var o, s, r, a = !1 !== e.jsonp && (eO.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && eO.test(e.data) && "data");
        if (a || "jsonp" === e.dataTypes[0]) return o = e.jsonpCallback = f(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(eO, "$1" + o) : !1 !== e.jsonp && (e.url += (ed.test(e.url) ? "&" : "?") + e.jsonp + "=" + o), e.converters["script json"] = function() {
            return r || x.error(o + " was not called"), r[0]
        }, e.dataTypes[0] = "json", s = t[o], t[o] = function() {
            r = arguments
        }, n.always(function() {
            void 0 === s ? x(t).removeProp(o) : t[o] = s, e[o] && (e.jsonpCallback = i.jsonpCallback, eD.push(o)), r && f(s) && s(r[0]), r = s = void 0
        }), "script"
    }), h.createHTMLDocument = ((ej = v.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === ej.childNodes.length), x.parseHTML = function(t, e, i) {
        var n, o, s;
        return "string" != typeof t ? [] : ("boolean" == typeof e && (i = e, e = !1), e || (h.createHTMLDocument ? ((n = (e = v.implementation.createHTMLDocument("")).createElement("base")).href = v.location.href, e.head.appendChild(n)) : e = v), s = !i && [], (o = E.exec(t)) ? [e.createElement(o[1])] : (o = t$([t], e, s), s && s.length && x(s).remove(), x.merge([], o.childNodes)))
    }, x.fn.load = function(t, e, i) {
        var n, o, s, r = this,
            a = t.indexOf(" ");
        return -1 < a && (n = en(t.slice(a)), t = t.slice(0, a)), f(e) ? (i = e, e = void 0) : e && "object" == typeof e && (o = "POST"), 0 < r.length && x.ajax({
            url: t,
            type: o || "GET",
            dataType: "html",
            data: e
        }).done(function(t) {
            s = arguments, r.html(n ? x("<div>").append(x.parseHTML(t)).find(n) : t)
        }).always(i && function(t, e) {
            r.each(function() {
                i.apply(this, s || [t.responseText, e, t])
            })
        }), this
    }, x.expr.pseudos.animated = function(t) {
        return x.grep(x.timers, function(e) {
            return t === e.elem
        }).length
    }, x.offset = {
        setOffset: function(t, e, i) {
            var n, o, s, r, a, l, c = x.css(t, "position"),
                u = x(t),
                d = {};
            "static" === c && (t.style.position = "relative"), a = u.offset(), s = x.css(t, "top"), l = x.css(t, "left"), ("absolute" === c || "fixed" === c) && -1 < (s + l).indexOf("auto") ? (r = (n = u.position()).top, o = n.left) : (r = parseFloat(s) || 0, o = parseFloat(l) || 0), f(e) && (e = e.call(t, i, x.extend({}, a))), null != e.top && (d.top = e.top - a.top + r), null != e.left && (d.left = e.left - a.left + o), "using" in e ? e.using.call(t, d) : u.css(d)
        }
    }, x.fn.extend({
        offset: function(t) {
            if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                x.offset.setOffset(this, t, e)
            });
            var e, i, n = this[0];
            return n ? n.getClientRects().length ? (e = n.getBoundingClientRect(), i = n.ownerDocument.defaultView, {
                top: e.top + i.pageYOffset,
                left: e.left + i.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var t, e, i, n = this[0],
                    o = {
                        top: 0,
                        left: 0
                    };
                if ("fixed" === x.css(n, "position")) e = n.getBoundingClientRect();
                else {
                    for (e = this.offset(), i = n.ownerDocument, t = n.offsetParent || i.documentElement; t && (t === i.body || t === i.documentElement) && "static" === x.css(t, "position");) t = t.parentNode;
                    t && t !== n && 1 === t.nodeType && ((o = x(t).offset()).top += x.css(t, "borderTopWidth", !0), o.left += x.css(t, "borderLeftWidth", !0))
                }
                return {
                    top: e.top - o.top - x.css(n, "marginTop", !0),
                    left: e.left - o.left - x.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && "static" === x.css(t, "position");) t = t.offsetParent;
                return t || tn
            })
        }
    }), x.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, e) {
        var i = "pageYOffset" === e;
        x.fn[t] = function(n) {
            return M(this, function(t, n, o) {
                var s;
                if (g(t) ? s = t : 9 === t.nodeType && (s = t.defaultView), void 0 === o) return s ? s[e] : t[n];
                s ? s.scrollTo(i ? s.pageXOffset : o, i ? o : s.pageYOffset) : t[n] = o
            }, t, n, arguments.length)
        }
    }), x.each(["top", "left"], function(t, e) {
        x.cssHooks[e] = tq(h.pixelPosition, function(t, i) {
            if (i) return i = tI(t, e), tH.test(i) ? x(t).position()[e] + "px" : i
        })
    }), x.each({
        Height: "height",
        Width: "width"
    }, function(t, e) {
        x.each({
            padding: "inner" + t,
            content: e,
            "": "outer" + t
        }, function(i, n) {
            x.fn[n] = function(o, s) {
                var r = arguments.length && (i || "boolean" != typeof o),
                    a = i || (!0 === o || !0 === s ? "margin" : "border");
                return M(this, function(e, i, o) {
                    var s;
                    return g(e) ? 0 === n.indexOf("outer") ? e["inner" + t] : e.document.documentElement["client" + t] : 9 === e.nodeType ? (s = e.documentElement, Math.max(e.body["scroll" + t], s["scroll" + t], e.body["offset" + t], s["offset" + t], s["client" + t])) : void 0 === o ? x.css(e, i, a) : x.style(e, i, o, a)
                }, e, r ? o : void 0, r)
            }
        })
    }), x.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
        x.fn[e] = function(t) {
            return this.on(e, t)
        }
    }), x.fn.extend({
        bind: function(t, e, i) {
            return this.on(t, null, e, i)
        },
        unbind: function(t, e) {
            return this.off(t, null, e)
        },
        delegate: function(t, e, i, n) {
            return this.on(e, t, i, n)
        },
        undelegate: function(t, e, i) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", i)
        },
        hover: function(t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }), x.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(t, e) {
        x.fn[e] = function(t, i) {
            return 0 < arguments.length ? this.on(e, null, t, i) : this.trigger(e)
        }
    });
    var eH = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    x.proxy = function(t, e) {
        var i, n, s;
        if ("string" == typeof e && (i = t[e], e = t, t = i), f(t)) return n = o.call(arguments, 2), (s = function() {
            return t.apply(e || this, n.concat(o.call(arguments)))
        }).guid = t.guid = t.guid || x.guid++, s
    }, x.holdReady = function(t) {
        t ? x.readyWait++ : x.ready(!0)
    }, x.isArray = Array.isArray, x.parseJSON = JSON.parse, x.nodeName = C, x.isFunction = f, x.isWindow = g, x.camelCase = X, x.type = $, x.now = Date.now, x.isNumeric = function(t) {
        var e = x.type(t);
        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
    }, x.trim = function(t) {
        return null == t ? "" : (t + "").replace(eH, "")
    }, "function" == typeof define && define.amd && define("jquery", [], function() {
        return x
    });
    var ez = t.jQuery,
        eP = t.$;
    return x.noConflict = function(e) {
        return t.$ === x && (t.$ = eP), e && t.jQuery === x && (t.jQuery = ez), x
    }, void 0 === e && (t.jQuery = t.$ = x), x
}),
function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    "use strict";
    var e, i = window.Slick || {};
    (i = (e = 0, function i(n, o) {
        var s, r = this;
        r.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: t(n),
            appendDots: t(n),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function(e, i) {
                return t('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1)
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: .35,
            fade: !1,
            focusOnSelect: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3
        }, r.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1
        }, t.extend(r, r.initials), r.activeBreakpoint = null, r.animType = null, r.animProp = null, r.breakpoints = [], r.breakpointSettings = [], r.cssTransitions = !1, r.focussed = !1, r.interrupted = !1, r.hidden = "hidden", r.paused = !0, r.positionProp = null, r.respondTo = null, r.rowCount = 1, r.shouldClick = !0, r.$slider = t(n), r.$slidesCache = null, r.transformType = null, r.transitionType = null, r.visibilityChange = "visibilitychange", r.windowWidth = 0, r.windowTimer = null, s = t(n).data("slick") || {}, r.options = t.extend({}, r.defaults, o, s), r.currentSlide = r.options.initialSlide, r.originalSettings = r.options, void 0 !== document.mozHidden ? (r.hidden = "mozHidden", r.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (r.hidden = "webkitHidden", r.visibilityChange = "webkitvisibilitychange"), r.autoPlay = t.proxy(r.autoPlay, r), r.autoPlayClear = t.proxy(r.autoPlayClear, r), r.autoPlayIterator = t.proxy(r.autoPlayIterator, r), r.changeSlide = t.proxy(r.changeSlide, r), r.clickHandler = t.proxy(r.clickHandler, r), r.selectHandler = t.proxy(r.selectHandler, r), r.setPosition = t.proxy(r.setPosition, r), r.swipeHandler = t.proxy(r.swipeHandler, r), r.dragHandler = t.proxy(r.dragHandler, r), r.keyHandler = t.proxy(r.keyHandler, r), r.instanceUid = e++, r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, r.registerBreakpoints(), r.init(!0)
    })).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, i.prototype.addSlide = i.prototype.slickAdd = function(e, i, n) {
        var o = this;
        if ("boolean" == typeof i) n = i, i = null;
        else if (0 > i || i >= o.slideCount) return !1;
        o.unload(), "number" == typeof i ? 0 === i && 0 === o.$slides.length ? t(e).appendTo(o.$slideTrack) : n ? t(e).insertBefore(o.$slides.eq(i)) : t(e).insertAfter(o.$slides.eq(i)) : !0 === n ? t(e).prependTo(o.$slideTrack) : t(e).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function(e, i) {
            t(i).attr("data-slick-index", e)
        }), o.$slidesCache = o.$slides, o.reinit()
    }, i.prototype.animateHeight = function() {
        if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
            var t = this.$slides.eq(this.currentSlide).outerHeight(!0);
            this.$list.animate({
                height: t
            }, this.options.speed)
        }
    }, i.prototype.animateSlide = function(e, i) {
        var n = {},
            o = this;
        o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (e = -e), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
            left: e
        }, o.options.speed, o.options.easing, i) : o.$slideTrack.animate({
            top: e
        }, o.options.speed, o.options.easing, i) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), t({
            animStart: o.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: o.options.speed,
            easing: o.options.easing,
            step: function(t) {
                t = Math.ceil(t), !1 === o.options.vertical ? (n[o.animType] = "translate(" + t + "px, 0px)", o.$slideTrack.css(n)) : (n[o.animType] = "translate(0px," + t + "px)", o.$slideTrack.css(n))
            },
            complete: function() {
                i && i.call()
            }
        })) : (o.applyTransition(), e = Math.ceil(e), !1 === o.options.vertical ? n[o.animType] = "translate3d(" + e + "px, 0px, 0px)" : n[o.animType] = "translate3d(0px," + e + "px, 0px)", o.$slideTrack.css(n), i && setTimeout(function() {
            o.disableTransition(), i.call()
        }, o.options.speed))
    }, i.prototype.getNavTarget = function() {
        var e = this.options.asNavFor;
        return e && null !== e && (e = t(e).not(this.$slider)), e
    }, i.prototype.asNavFor = function(e) {
        var i = this.getNavTarget();
        null !== i && "object" == typeof i && i.each(function() {
            var i = t(this).slick("getSlick");
            i.unslicked || i.slideHandler(e, !0)
        })
    }, i.prototype.applyTransition = function(t) {
        var e = this,
            i = {};
        !1 === e.options.fade ? i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
    }, i.prototype.autoPlay = function() {
        var t = this;
        t.autoPlayClear(), t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
    }, i.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    }, i.prototype.autoPlayIterator = function() {
        var t = this,
            e = t.currentSlide + t.options.slidesToScroll;
        t.paused || t.interrupted || t.focussed || (!1 === t.options.infinite && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll, t.currentSlide - 1 == 0 && (t.direction = 1))), t.slideHandler(e))
    }, i.prototype.buildArrows = function() {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, i.prototype.buildDots = function() {
        var e, i, n = this;
        if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
            for (n.$slider.addClass("slick-dotted"), i = t("<ul />").addClass(n.options.dotsClass), e = 0; e <= n.getDotCount(); e += 1) i.append(t("<li />").append(n.options.customPaging.call(this, n, e)));
            n.$dots = i.appendTo(n.options.appendDots), n.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
        }
    }, i.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, i) {
            t(i).attr("data-slick-index", e).data("originalStyling", t(i).attr("style") || "")
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? t('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), (!0 === e.options.centerMode || !0 === e.options.swipeToSlide) && (e.options.slidesToScroll = 1), t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
    }, i.prototype.buildRows = function() {
        var t, e, i, n, o, s, r;
        if (n = document.createDocumentFragment(), s = this.$slider.children(), this.options.rows > 1) {
            for (r = this.options.slidesPerRow * this.options.rows, o = Math.ceil(s.length / r), t = 0; o > t; t++) {
                var a = document.createElement("div");
                for (e = 0; e < this.options.rows; e++) {
                    var l = document.createElement("div");
                    for (i = 0; i < this.options.slidesPerRow; i++) {
                        var c = t * r + (e * this.options.slidesPerRow + i);
                        s.get(c) && l.appendChild(s.get(c))
                    }
                    a.appendChild(l)
                }
                n.appendChild(a)
            }
            this.$slider.empty().append(n), this.$slider.children().children().children().css({
                width: 100 / this.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, i.prototype.checkResponsive = function(e, i) {
        var n, o, s, r = this,
            a = !1,
            l = r.$slider.width(),
            c = window.innerWidth || t(window).width();
        if ("window" === r.respondTo ? s = c : "slider" === r.respondTo ? s = l : "min" === r.respondTo && (s = Math.min(c, l)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            for (n in o = null, r.breakpoints) r.breakpoints.hasOwnProperty(n) && (!1 === r.originalSettings.mobileFirst ? s < r.breakpoints[n] && (o = r.breakpoints[n]) : s > r.breakpoints[n] && (o = r.breakpoints[n]));
            null !== o ? null !== r.activeBreakpoint ? (o !== r.activeBreakpoint || i) && (r.activeBreakpoint = o, "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[o]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = o) : (r.activeBreakpoint = o, "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[o]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = o) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), a = o), e || !1 === a || r.$slider.trigger("breakpoint", [r, a])
        }
    }, i.prototype.changeSlide = function(e, i) {
        var n, o, s, r = t(e.currentTarget);
        switch (r.is("a") && e.preventDefault(), r.is("li") || (r = r.closest("li")), n = (s = this.slideCount % this.options.slidesToScroll != 0) ? 0 : (this.slideCount - this.currentSlide) % this.options.slidesToScroll, e.data.message) {
            case "previous":
                o = 0 === n ? this.options.slidesToScroll : this.options.slidesToShow - n, this.slideCount > this.options.slidesToShow && this.slideHandler(this.currentSlide - o, !1, i);
                break;
            case "next":
                o = 0 === n ? this.options.slidesToScroll : n, this.slideCount > this.options.slidesToShow && this.slideHandler(this.currentSlide + o, !1, i);
                break;
            case "index":
                var a = 0 === e.data.index ? 0 : e.data.index || r.index() * this.options.slidesToScroll;
                this.slideHandler(this.checkNavigable(a), !1, i), r.children().trigger("focus");
                break;
            default:
                return
        }
    }, i.prototype.checkNavigable = function(t) {
        var e, i;
        if (e = this.getNavigableIndexes(), i = 0, t > e[e.length - 1]) t = e[e.length - 1];
        else
            for (var n in e) {
                if (t < e[n]) {
                    t = i;
                    break
                }
                i = e[n]
            }
        return t
    }, i.prototype.cleanUpEvents = function() {
        this.options.dots && null !== this.$dots && t("li", this.$dots).off("click.slick", this.changeSlide).off("mouseenter.slick", t.proxy(this.interrupt, this, !0)).off("mouseleave.slick", t.proxy(this.interrupt, this, !1)), this.$slider.off("focus.slick blur.slick"), !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow && this.$prevArrow.off("click.slick", this.changeSlide), this.$nextArrow && this.$nextArrow.off("click.slick", this.changeSlide)), this.$list.off("touchstart.slick mousedown.slick", this.swipeHandler), this.$list.off("touchmove.slick mousemove.slick", this.swipeHandler), this.$list.off("touchend.slick mouseup.slick", this.swipeHandler), this.$list.off("touchcancel.slick mouseleave.slick", this.swipeHandler), this.$list.off("click.slick", this.clickHandler), t(document).off(this.visibilityChange, this.visibility), this.cleanUpSlideEvents(), !0 === this.options.accessibility && this.$list.off("keydown.slick", this.keyHandler), !0 === this.options.focusOnSelect && t(this.$slideTrack).children().off("click.slick", this.selectHandler), t(window).off("orientationchange.slick.slick-" + this.instanceUid, this.orientationChange), t(window).off("resize.slick.slick-" + this.instanceUid, this.resize), t("[draggable!=true]", this.$slideTrack).off("dragstart", this.preventDefault), t(window).off("load.slick.slick-" + this.instanceUid, this.setPosition), t(document).off("ready.slick.slick-" + this.instanceUid, this.setPosition)
    }, i.prototype.cleanUpSlideEvents = function() {
        this.$list.off("mouseenter.slick", t.proxy(this.interrupt, this, !0)), this.$list.off("mouseleave.slick", t.proxy(this.interrupt, this, !1))
    }, i.prototype.cleanUpRows = function() {
        var t;
        this.options.rows > 1 && ((t = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(t))
    }, i.prototype.clickHandler = function(t) {
        !1 === this.shouldClick && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault())
    }, i.prototype.destroy = function(e) {
        var i = this;
        i.autoPlayClear(), i.touchObject = {}, i.cleanUpEvents(), t(".slick-cloned", i.$slider).detach(), i.$dots && i.$dots.remove(), i.$prevArrow && i.$prevArrow.length && (i.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()), i.$nextArrow && i.$nextArrow.length && (i.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()), i.$slides && (i.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            t(this).attr("style", t(this).data("originalStyling"))
        }), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.detach(), i.$list.detach(), i.$slider.append(i.$slides)), i.cleanUpRows(), i.$slider.removeClass("slick-slider"), i.$slider.removeClass("slick-initialized"), i.$slider.removeClass("slick-dotted"), i.unslicked = !0, e || i.$slider.trigger("destroy", [i])
    }, i.prototype.disableTransition = function(t) {
        var e = this,
            i = {};
        i[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
    }, i.prototype.fadeSlide = function(t, e) {
        var i = this;
        !1 === i.cssTransitions ? (i.$slides.eq(t).css({
            zIndex: i.options.zIndex
        }), i.$slides.eq(t).animate({
            opacity: 1
        }, i.options.speed, i.options.easing, e)) : (i.applyTransition(t), i.$slides.eq(t).css({
            opacity: 1,
            zIndex: i.options.zIndex
        }), e && setTimeout(function() {
            i.disableTransition(t), e.call()
        }, i.options.speed))
    }, i.prototype.fadeSlideOut = function(t) {
        !1 === this.cssTransitions ? this.$slides.eq(t).animate({
            opacity: 0,
            zIndex: this.options.zIndex - 2
        }, this.options.speed, this.options.easing) : (this.applyTransition(t), this.$slides.eq(t).css({
            opacity: 0,
            zIndex: this.options.zIndex - 2
        }))
    }, i.prototype.filterSlides = i.prototype.slickFilter = function(t) {
        var e = this;
        null !== t && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(t).appendTo(e.$slideTrack), e.reinit())
    }, i.prototype.focusHandler = function() {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(i) {
            i.stopImmediatePropagation();
            var n = t(this);
            setTimeout(function() {
                e.options.pauseOnFocus && (e.focussed = n.is(":focus"), e.autoPlay())
            }, 0)
        })
    }, i.prototype.getCurrent = i.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }, i.prototype.getDotCount = function() {
        var t = 0,
            e = 0,
            i = 0;
        if (!0 === this.options.infinite)
            for (; t < this.slideCount;) ++i, t = e + this.options.slidesToScroll, e += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        else if (!0 === this.options.centerMode) i = this.slideCount;
        else if (this.options.asNavFor)
            for (; t < this.slideCount;) ++i, t = e + this.options.slidesToScroll, e += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        else i = 1 + Math.ceil((this.slideCount - this.options.slidesToShow) / this.options.slidesToScroll);
        return i - 1
    }, i.prototype.getLeft = function(t) {
        var e, i, n, o = this,
            s = 0;
        return o.slideOffset = 0, i = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = -(o.slideWidth * o.options.slidesToShow * 1), s = -(i * o.options.slidesToShow * 1)), o.slideCount % o.options.slidesToScroll != 0 && t + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (t > o.slideCount ? (o.slideOffset = -((o.options.slidesToShow - (t - o.slideCount)) * o.slideWidth * 1), s = -((o.options.slidesToShow - (t - o.slideCount)) * i * 1)) : (o.slideOffset = -(o.slideCount % o.options.slidesToScroll * o.slideWidth * 1), s = -(o.slideCount % o.options.slidesToScroll * i * 1)))) : t + o.options.slidesToShow > o.slideCount && (o.slideOffset = (t + o.options.slidesToShow - o.slideCount) * o.slideWidth, s = (t + o.options.slidesToShow - o.slideCount) * i), o.slideCount <= o.options.slidesToShow && (o.slideOffset = 0, s = 0), !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), e = !1 === o.options.vertical ? -(t * o.slideWidth * 1) + o.slideOffset : -(t * i * 1) + s, !0 === o.options.variableWidth && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow), e = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0, !0 === o.options.centerMode && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow + 1), e = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0, e += (o.$list.width() - n.outerWidth()) / 2)), e
    }, i.prototype.getOption = i.prototype.slickGetOption = function(t) {
        return this.options[t]
    }, i.prototype.getNavigableIndexes = function() {
        var t, e = 0,
            i = 0,
            n = [];
        for (!1 === this.options.infinite ? t = this.slideCount : (e = -1 * this.options.slidesToScroll, i = -1 * this.options.slidesToScroll, t = 2 * this.slideCount); t > e;) n.push(e), e = i + this.options.slidesToScroll, i += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        return n
    }, i.prototype.getSlick = function() {
        return this
    }, i.prototype.getSlideCount = function() {
        var e, i, n, o = this;
        return n = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(e, s) {
            return s.offsetLeft - n + t(s).outerWidth() / 2 > -1 * o.swipeLeft ? (i = s, !1) : void 0
        }), e = Math.abs(t(i).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }, i.prototype.goTo = i.prototype.slickGoTo = function(t, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(t)
            }
        }, e)
    }, i.prototype.init = function(e) {
        var i = this;
        t(i.$slider).hasClass("slick-initialized") || (t(i.$slider).addClass("slick-initialized"), i.buildRows(), i.buildOut(), i.setProps(), i.startLoad(), i.loadSlider(), i.initializeEvents(), i.updateArrows(), i.updateDots(), i.checkResponsive(!0), i.focusHandler()), e && i.$slider.trigger("init", [i]), !0 === i.options.accessibility && i.initADA(), i.options.autoplay && (i.paused = !1, i.autoPlay())
    }, i.prototype.initADA = function() {
        var e = this;
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), e.$slideTrack.attr("role", "listbox"), e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(i) {
            t(this).attr({
                role: "option",
                "aria-describedby": "slick-slide" + e.instanceUid + i
            })
        }), null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(i) {
            t(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + e.instanceUid + i,
                id: "slick-slide" + e.instanceUid + i
            })
        }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), e.activateADA()
    }, i.prototype.initArrowEvents = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, this.changeSlide), this.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, this.changeSlide))
    }, i.prototype.initDotEvents = function() {
        !0 === this.options.dots && this.slideCount > this.options.slidesToShow && t("li", this.$dots).on("click.slick", {
            message: "index"
        }, this.changeSlide), !0 === this.options.dots && !0 === this.options.pauseOnDotsHover && t("li", this.$dots).on("mouseenter.slick", t.proxy(this.interrupt, this, !0)).on("mouseleave.slick", t.proxy(this.interrupt, this, !1))
    }, i.prototype.initSlideEvents = function() {
        this.options.pauseOnHover && (this.$list.on("mouseenter.slick", t.proxy(this.interrupt, this, !0)), this.$list.on("mouseleave.slick", t.proxy(this.interrupt, this, !1)))
    }, i.prototype.initializeEvents = function() {
        this.initArrowEvents(), this.initDotEvents(), this.initSlideEvents(), this.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, this.swipeHandler), this.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, this.swipeHandler), this.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, this.swipeHandler), this.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, this.swipeHandler), this.$list.on("click.slick", this.clickHandler), t(document).on(this.visibilityChange, t.proxy(this.visibility, this)), !0 === this.options.accessibility && this.$list.on("keydown.slick", this.keyHandler), !0 === this.options.focusOnSelect && t(this.$slideTrack).children().on("click.slick", this.selectHandler), t(window).on("orientationchange.slick.slick-" + this.instanceUid, t.proxy(this.orientationChange, this)), t(window).on("resize.slick.slick-" + this.instanceUid, t.proxy(this.resize, this)), t("[draggable!=true]", this.$slideTrack).on("dragstart", this.preventDefault), t(window).on("load.slick.slick-" + this.instanceUid, this.setPosition), t(document).on("ready.slick.slick-" + this.instanceUid, this.setPosition)
    }, i.prototype.initUI = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.show(), this.$nextArrow.show()), !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.show()
    }, i.prototype.keyHandler = function(t) {
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && !0 === this.options.accessibility ? this.changeSlide({
            data: {
                message: !0 === this.options.rtl ? "next" : "previous"
            }
        }) : 39 === t.keyCode && !0 === this.options.accessibility && this.changeSlide({
            data: {
                message: !0 === this.options.rtl ? "previous" : "next"
            }
        }))
    }, i.prototype.lazyLoad = function() {
        function e(e) {
            t("img[data-lazy]", e).each(function() {
                var e = t(this),
                    i = t(this).attr("data-lazy"),
                    n = document.createElement("img");
                n.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        e.attr("src", i).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy").removeClass("slick-loading")
                        }), r.$slider.trigger("lazyLoaded", [r, e, i])
                    })
                }, n.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, e, i])
                }, n.src = i
            })
        }
        var i, n, o, s, r = this;
        !0 === r.options.centerMode ? !0 === r.options.infinite ? s = (o = r.currentSlide + (r.options.slidesToShow / 2 + 1)) + r.options.slidesToShow + 2 : (o = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), s = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = Math.ceil((o = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide) + r.options.slidesToShow), !0 === r.options.fade && (o > 0 && o--, s <= r.slideCount && s++)), e(i = r.$slider.find(".slick-slide").slice(o, s)), r.slideCount <= r.options.slidesToShow ? e(n = r.$slider.find(".slick-slide")) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? e(n = r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow)) : 0 === r.currentSlide && e(n = r.$slider.find(".slick-cloned").slice(-1 * r.options.slidesToShow))
    }, i.prototype.loadSlider = function() {
        this.setPosition(), this.$slideTrack.css({
            opacity: 1
        }), this.$slider.removeClass("slick-loading"), this.initUI(), "progressive" === this.options.lazyLoad && this.progressiveLazyLoad()
    }, i.prototype.next = i.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }, i.prototype.orientationChange = function() {
        this.checkResponsive(), this.setPosition()
    }, i.prototype.pause = i.prototype.slickPause = function() {
        var t = this;
        t.autoPlayClear(), t.paused = !0
    }, i.prototype.play = i.prototype.slickPlay = function() {
        var t = this;
        t.autoPlay(), t.options.autoplay = !0, t.paused = !1, t.focussed = !1, t.interrupted = !1
    }, i.prototype.postSlide = function(t) {
        var e = this;
        e.unslicked || (e.$slider.trigger("afterChange", [e, t]), e.animating = !1, e.setPosition(), e.swipeLeft = null, e.options.autoplay && e.autoPlay(), !0 === e.options.accessibility && e.initADA())
    }, i.prototype.prev = i.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, i.prototype.preventDefault = function(t) {
        t.preventDefault()
    }, i.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var i, n, o, s = this,
            r = t("img[data-lazy]", s.$slider);
        r.length ? (n = (i = r.first()).attr("data-lazy"), (o = document.createElement("img")).onload = function() {
            i.attr("src", n).removeAttr("data-lazy").removeClass("slick-loading"), !0 === s.options.adaptiveHeight && s.setPosition(), s.$slider.trigger("lazyLoaded", [s, i, n]), s.progressiveLazyLoad()
        }, o.onerror = function() {
            3 > e ? setTimeout(function() {
                s.progressiveLazyLoad(e + 1)
            }, 500) : (i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, i, n]), s.progressiveLazyLoad())
        }, o.src = n) : s.$slider.trigger("allImagesLoaded", [s])
    }, i.prototype.refresh = function(e) {
        var i, n, o = this;
        n = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > n && (o.currentSlide = n), o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), i = o.currentSlide, o.destroy(!0), t.extend(o, o.initials, {
            currentSlide: i
        }), o.init(), e || o.changeSlide({
            data: {
                message: "index",
                index: i
            }
        }, !1)
    }, i.prototype.registerBreakpoints = function() {
        var e, i, n, o = this,
            s = o.options.responsive || null;
        if ("array" === t.type(s) && s.length) {
            for (e in o.respondTo = o.options.respondTo || "window", s)
                if (n = o.breakpoints.length - 1, i = s[e].breakpoint, s.hasOwnProperty(e)) {
                    for (; n >= 0;) o.breakpoints[n] && o.breakpoints[n] === i && o.breakpoints.splice(n, 1), n--;
                    o.breakpoints.push(i), o.breakpointSettings[i] = s[e].settings
                }
            o.breakpoints.sort(function(t, e) {
                return o.options.mobileFirst ? t - e : e - t
            })
        }
    }, i.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
    }, i.prototype.resize = function() {
        var e = this;
        t(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
            e.windowWidth = t(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, i.prototype.removeSlide = i.prototype.slickRemove = function(t, e, i) {
        var n = this;
        return t = "boolean" == typeof t ? !0 === (e = t) ? 0 : n.slideCount - 1 : !0 === e ? --t : t, !(n.slideCount < 1) && !(0 > t) && !(t > n.slideCount - 1) && (n.unload(), !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(t).remove(), n.$slides = n.$slideTrack.children(this.options.slide), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.append(n.$slides), n.$slidesCache = n.$slides, void n.reinit())
    }, i.prototype.setCSS = function(t) {
        var e, i, n = this,
            o = {};
        !0 === n.options.rtl && (t = -t), e = "left" == n.positionProp ? Math.ceil(t) + "px" : "0px", i = "top" == n.positionProp ? Math.ceil(t) + "px" : "0px", o[n.positionProp] = t, !1 === n.transformsEnabled ? n.$slideTrack.css(o) : (o = {}, !1 === n.cssTransitions ? (o[n.animType] = "translate(" + e + ", " + i + ")", n.$slideTrack.css(o)) : (o[n.animType] = "translate3d(" + e + ", " + i + ", 0px)", n.$slideTrack.css(o)))
    }, i.prototype.setDimensions = function() {
        var t = this;
        !1 === t.options.vertical ? !0 === t.options.centerMode && t.$list.css({
            padding: "0px " + t.options.centerPadding
        }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow), !0 === t.options.centerMode && t.$list.css({
            padding: t.options.centerPadding + " 0px"
        })), t.listWidth = t.$list.width(), t.listHeight = t.$list.height(), !1 === t.options.vertical && !1 === t.options.variableWidth ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : !0 === t.options.variableWidth ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        !1 === t.options.variableWidth && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
    }, i.prototype.setFade = function() {
        var e, i = this;
        i.$slides.each(function(n, o) {
            e = -(i.slideWidth * n * 1), !0 === i.options.rtl ? t(o).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            }) : t(o).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            })
        }), i.$slides.eq(i.currentSlide).css({
            zIndex: i.options.zIndex - 1,
            opacity: 1
        })
    }, i.prototype.setHeight = function() {
        if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
            var t = this.$slides.eq(this.currentSlide).outerHeight(!0);
            this.$list.css("height", t)
        }
    }, i.prototype.setOption = i.prototype.slickSetOption = function() {
        var e, i, n, o, s, r = this,
            a = !1;
        if ("object" === t.type(arguments[0]) ? (n = arguments[0], a = arguments[1], s = "multiple") : "string" === t.type(arguments[0]) && (n = arguments[0], o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === t.type(arguments[1]) ? s = "responsive" : void 0 !== arguments[1] && (s = "single")), "single" === s) r.options[n] = o;
        else if ("multiple" === s) t.each(n, function(t, e) {
            r.options[t] = e
        });
        else if ("responsive" === s)
            for (i in o)
                if ("array" !== t.type(r.options.responsive)) r.options.responsive = [o[i]];
                else {
                    for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === o[i].breakpoint && r.options.responsive.splice(e, 1), e--;
                    r.options.responsive.push(o[i])
                }
        a && (r.unload(), r.reinit())
    }, i.prototype.setPosition = function() {
        this.setDimensions(), this.setHeight(), !1 === this.options.fade ? this.setCSS(this.getLeft(this.currentSlide)) : this.setFade(), this.$slider.trigger("setPosition", [this])
    }, i.prototype.setProps = function() {
        var t = this,
            e = document.body.style;
        t.positionProp = !0 === t.options.vertical ? "top" : "left", "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"), (void 0 !== e.WebkitTransition || void 0 !== e.MozTransition || void 0 !== e.msTransition) && !0 === t.options.useCSS && (t.cssTransitions = !0), t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex), void 0 !== e.OTransform && (t.animType = "OTransform", t.transformType = "-o-transform", t.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.MozTransform && (t.animType = "MozTransform", t.transformType = "-moz-transform", t.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)), void 0 !== e.webkitTransform && (t.animType = "webkitTransform", t.transformType = "-webkit-transform", t.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.msTransform && (t.animType = "msTransform", t.transformType = "-ms-transform", t.transitionType = "msTransition", void 0 === e.msTransform && (t.animType = !1)), void 0 !== e.transform && !1 !== t.animType && (t.animType = "transform", t.transformType = "transform", t.transitionType = "transition"), t.transformsEnabled = t.options.useTransform && null !== t.animType && !1 !== t.animType
    }, i.prototype.setSlideClasses = function(t) {
        var e, i, n, o;
        i = this.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), this.$slides.eq(t).addClass("slick-current"), !0 === this.options.centerMode ? (e = Math.floor(this.options.slidesToShow / 2), !0 === this.options.infinite && (t >= e && t <= this.slideCount - 1 - e ? this.$slides.slice(t - e, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (n = this.options.slidesToShow + t, i.slice(n - e + 1, n + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === t ? i.eq(i.length - 1 - this.options.slidesToShow).addClass("slick-center") : t === this.slideCount - 1 && i.eq(this.options.slidesToShow).addClass("slick-center")), this.$slides.eq(t).addClass("slick-center")) : t >= 0 && t <= this.slideCount - this.options.slidesToShow ? this.$slides.slice(t, t + this.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= this.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (o = this.slideCount % this.options.slidesToShow, n = !0 === this.options.infinite ? this.options.slidesToShow + t : t, this.options.slidesToShow == this.options.slidesToScroll && this.slideCount - t < this.options.slidesToShow ? i.slice(n - (this.options.slidesToShow - o), n + o).addClass("slick-active").attr("aria-hidden", "false") : i.slice(n, n + this.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" === this.options.lazyLoad && this.lazyLoad()
    }, i.prototype.setupInfinite = function() {
        var e, i, n, o = this;
        if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (i = null, o.slideCount > o.options.slidesToShow)) {
            for (n = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, e = o.slideCount; e > o.slideCount - n; e -= 1) i = e - 1, t(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
            for (e = 0; n > e; e += 1) i = e, t(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
            o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                t(this).attr("id", "")
            })
        }
    }, i.prototype.interrupt = function(t) {
        var e = this;
        t || e.autoPlay(), e.interrupted = t
    }, i.prototype.selectHandler = function(e) {
        var i = parseInt((t(e.target).is(".slick-slide") ? t(e.target) : t(e.target).parents(".slick-slide")).attr("data-slick-index"));
        return i || (i = 0), this.slideCount <= this.options.slidesToShow ? (this.setSlideClasses(i), void this.asNavFor(i)) : void this.slideHandler(i)
    }, i.prototype.slideHandler = function(t, e, i) {
        var n, o, s, r, a, l = null,
            c = this;
        return e = e || !1, !0 === c.animating && !0 === c.options.waitForAnimate || !0 === c.options.fade && c.currentSlide === t || c.slideCount <= c.options.slidesToShow ? void 0 : (!1 === e && c.asNavFor(t), n = t, l = c.getLeft(n), r = c.getLeft(c.currentSlide), c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft, !1 === c.options.infinite && !1 === c.options.centerMode && (0 > t || t > c.getDotCount() * c.options.slidesToScroll) ? void(!1 === c.options.fade && (n = c.currentSlide, !0 !== i ? c.animateSlide(r, function() {
            c.postSlide(n)
        }) : c.postSlide(n))) : !1 === c.options.infinite && !0 === c.options.centerMode && (0 > t || t > c.slideCount - c.options.slidesToScroll) ? void(!1 === c.options.fade && (n = c.currentSlide, !0 !== i ? c.animateSlide(r, function() {
            c.postSlide(n)
        }) : c.postSlide(n))) : (c.options.autoplay && clearInterval(c.autoPlayTimer), o = 0 > n ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + n : n >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : n - c.slideCount : n, c.animating = !0, c.$slider.trigger("beforeChange", [c, c.currentSlide, o]), s = c.currentSlide, c.currentSlide = o, c.setSlideClasses(c.currentSlide), c.options.asNavFor && (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide), c.updateDots(), c.updateArrows(), !0 === c.options.fade ? (!0 !== i ? (c.fadeSlideOut(s), c.fadeSlide(o, function() {
            c.postSlide(o)
        })) : c.postSlide(o), void c.animateHeight()) : void(!0 !== i ? c.animateSlide(l, function() {
            c.postSlide(o)
        }) : c.postSlide(o))))
    }, i.prototype.startLoad = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.hide(), this.$nextArrow.hide()), !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.hide(), this.$slider.addClass("slick-loading")
    }, i.prototype.swipeDirection = function() {
        var t, e, i, n;
        return t = this.touchObject.startX - this.touchObject.curX, 0 > (n = Math.round(180 * (i = Math.atan2(e = this.touchObject.startY - this.touchObject.curY, t)) / Math.PI)) && (n = 360 - Math.abs(n)), 45 >= n && n >= 0 ? !1 === this.options.rtl ? "left" : "right" : 360 >= n && n >= 315 ? !1 === this.options.rtl ? "left" : "right" : n >= 135 && 225 >= n ? !1 === this.options.rtl ? "right" : "left" : !0 === this.options.verticalSwiping ? n >= 35 && 135 >= n ? "down" : "up" : "vertical"
    }, i.prototype.swipeEnd = function(t) {
        var e, i, n = this;
        if (n.dragging = !1, n.interrupted = !1, n.shouldClick = !(n.touchObject.swipeLength > 10), void 0 === n.touchObject.curX) return !1;
        if (!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [n, n.swipeDirection()]), n.touchObject.swipeLength >= n.touchObject.minSwipe) {
            switch (i = n.swipeDirection()) {
                case "left":
                case "down":
                    e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount(), n.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount(), n.currentDirection = 1
            }
            "vertical" != i && (n.slideHandler(e), n.touchObject = {}, n.$slider.trigger("swipe", [n, i]))
        } else n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide), n.touchObject = {})
    }, i.prototype.swipeHandler = function(t) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== t.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), t.data.action) {
            case "start":
                e.swipeStart(t);
                break;
            case "move":
                e.swipeMove(t);
                break;
            case "end":
                e.swipeEnd(t)
        }
    }, i.prototype.swipeMove = function(t) {
        var e, i, n, o, s, r = this;
        return s = void 0 !== t.originalEvent ? t.originalEvent.touches : null, !!r.dragging && (!s || 1 === s.length) && (e = r.getLeft(r.currentSlide), r.touchObject.curX = void 0 !== s ? s[0].pageX : t.clientX, r.touchObject.curY = void 0 !== s ? s[0].pageY : t.clientY, r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))), !0 === r.options.verticalSwiping && (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))), "vertical" !== (i = r.swipeDirection()) ? (void 0 !== t.originalEvent && r.touchObject.swipeLength > 4 && t.preventDefault(), o = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1), !0 === r.options.verticalSwiping && (o = r.touchObject.curY > r.touchObject.startY ? 1 : -1), n = r.touchObject.swipeLength, r.touchObject.edgeHit = !1, !1 === r.options.infinite && (0 === r.currentSlide && "right" === i || r.currentSlide >= r.getDotCount() && "left" === i) && (n = r.touchObject.swipeLength * r.options.edgeFriction, r.touchObject.edgeHit = !0), !1 === r.options.vertical ? r.swipeLeft = e + n * o : r.swipeLeft = e + n * (r.$list.height() / r.listWidth) * o, !0 === r.options.verticalSwiping && (r.swipeLeft = e + n * o), !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? (r.swipeLeft = null, !1) : void r.setCSS(r.swipeLeft))) : void 0)
    }, i.prototype.swipeStart = function(t) {
        var e, i = this;
        return i.interrupted = !0, 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow ? (i.touchObject = {}, !1) : (void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]), i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX, i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY, void(i.dragging = !0))
    }, i.prototype.unfilterSlides = i.prototype.slickUnfilter = function() {
        null !== this.$slidesCache && (this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.appendTo(this.$slideTrack), this.reinit())
    }, i.prototype.unload = function() {
        t(".slick-cloned", this.$slider).remove(), this.$dots && this.$dots.remove(), this.$prevArrow && this.htmlExpr.test(this.options.prevArrow) && this.$prevArrow.remove(), this.$nextArrow && this.htmlExpr.test(this.options.nextArrow) && this.$nextArrow.remove(), this.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, i.prototype.unslick = function(t) {
        this.$slider.trigger("unslick", [this, t]), this.destroy()
    }, i.prototype.updateArrows = function() {
        var t;
        t = Math.floor(this.options.slidesToShow / 2), !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && !this.options.infinite && (this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), this.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === this.currentSlide ? (this.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), this.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : this.currentSlide >= this.slideCount - this.options.slidesToShow && !1 === this.options.centerMode ? (this.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : this.currentSlide >= this.slideCount - 1 && !0 === this.options.centerMode && (this.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, i.prototype.updateDots = function() {
        null !== this.$dots && (this.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), this.$dots.find("li").eq(Math.floor(this.currentSlide / this.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
    }, i.prototype.visibility = function() {
        var t = this;
        t.options.autoplay && (document[t.hidden] ? t.interrupted = !0 : t.interrupted = !1)
    }, t.fn.slick = function() {
        var t, e, n = this,
            o = arguments[0],
            s = Array.prototype.slice.call(arguments, 1),
            r = n.length;
        for (t = 0; r > t; t++)
            if ("object" == typeof o || void 0 === o ? n[t].slick = new i(n[t], o) : e = n[t].slick[o].apply(n[t].slick, s), void 0 !== e) return e;
        return n
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
}(window, function(t, e) {
    "use strict";

    function i(i, s, a) {
        (a = a || e || t.jQuery) && (s.prototype.option || (s.prototype.option = function(t) {
            a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t))
        }), a.fn[i] = function(t) {
            if ("string" == typeof t) {
                var e, n, l, c, u, d = o.call(arguments, 1);
                return e = this, n = t, l = d, u = "$()." + i + '("' + n + '")', e.each(function(t, e) {
                    var o = a.data(e, i);
                    if (!o) return void r(i + " not initialized. Cannot call methods, i.e. " + u);
                    var s = o[n];
                    if (!s || "_" == n.charAt(0)) return void r(u + " is not a valid method");
                    var d = s.apply(o, l);
                    c = void 0 === c ? d : c
                }), void 0 !== c ? c : e
            }
            return function t(e, n) {
                e.each(function(t, e) {
                    var o = a.data(e, i);
                    o ? (o.option(n), o._init()) : (o = new s(e, n), a.data(e, i, o))
                })
            }(this, t), this
        }, n(a))
    }

    function n(t) {
        !t || t && t.bridget || (t.bridget = i)
    }
    var o = Array.prototype.slice,
        s = t.console,
        r = void 0 === s ? function() {} : function(t) {
            s.error(t)
        };
    return n(e || t.jQuery), i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {},
                n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e), this
        }
    }, e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {};
            return (i[t] = i[t] || {})[e] = !0, this
        }
    }, e.off = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this
        }
    }, e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0), e = e || [];
            for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                var s = i[o];
                n && n[s] && (this.off(t, s), delete n[s]), s.apply(this, e)
            }
            return this
        }
    }, e.allOff = function() {
        delete this._events, delete this._onceEvents
    }, t
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function() {
    "use strict";

    function t(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }

    function e(t) {
        var e = getComputedStyle(t);
        return e || o("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e
    }

    function i(o) {
        if (function o() {
                if (!a) {
                    a = !0;
                    var s = document.createElement("div");
                    s.style.width = "200px", s.style.padding = "1px 2px 3px 4px", s.style.borderStyle = "solid", s.style.borderWidth = "1px 2px 3px 4px", s.style.boxSizing = "border-box";
                    var r = document.body || document.documentElement;
                    r.appendChild(s), n = 200 == Math.round(t(e(s).width)), i.isBoxSizeOuter = n, r.removeChild(s)
                }
            }(), "string" == typeof o && (o = document.querySelector(o)), o && "object" == typeof o && o.nodeType) {
            var l = e(o);
            if ("none" == l.display) return function t() {
                for (var e = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0
                    }, i = 0; r > i; i++) e[s[i]] = 0;
                return e
            }();
            var c = {};
            c.width = o.offsetWidth, c.height = o.offsetHeight;
            for (var u = c.isBorderBox = "border-box" == l.boxSizing, d = 0; r > d; d++) {
                var p = s[d],
                    h = parseFloat(l[p]);
                c[p] = isNaN(h) ? 0 : h
            }
            var f = c.paddingLeft + c.paddingRight,
                g = c.paddingTop + c.paddingBottom,
                v = c.marginLeft + c.marginRight,
                m = c.marginTop + c.marginBottom,
                y = c.borderLeftWidth + c.borderRightWidth,
                $ = c.borderTopWidth + c.borderBottomWidth,
                b = u && n,
                x = t(l.width);
            !1 !== x && (c.width = x + (b ? 0 : f + y));
            var T = t(l.height);
            return !1 !== T && (c.height = T + (b ? 0 : g + $)), c.innerWidth = c.width - (f + y), c.innerHeight = c.height - (g + $), c.outerWidth = c.width + v, c.outerHeight = c.height + m, c
        }
    }
    var n, o = "undefined" == typeof console ? function t() {} : function(t) {
            console.error(t)
        },
        s = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
        r = s.length,
        a = !1;
    return i
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function() {
    "use strict";
    var t = function() {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n = e[i] + "MatchesSelector";
            if (t[n]) return n
        }
    }();
    return function(e, i) {
        return e[t](i)
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector)
}(window, function(t, e) {
    var i = {};
    i.extend = function(t, e) {
        for (var i in e) t[i] = e[i];
        return t
    }, i.modulo = function(t, e) {
        return (t % e + e) % e
    };
    var n = Array.prototype.slice;
    i.makeArray = function(t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? n.call(t) : [t]
    }, i.removeFrom = function(t, e) {
        var i = t.indexOf(e); - 1 != i && t.splice(i, 1)
    }, i.getParent = function(t, i) {
        for (; t.parentNode && t != document.body;)
            if (e(t = t.parentNode, i)) return t
    }, i.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }, i.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, i.filterFindElements = function(t, n) {
        t = i.makeArray(t);
        var o = [];
        return t.forEach(function(t) {
            if (t instanceof HTMLElement) {
                if (!n) return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), s = 0; s < i.length; s++) o.push(i[s])
            }
        }), o
    }, i.debounceMethod = function(t, e, i) {
        i = i || 100;
        var n = t.prototype[e],
            o = e + "Timeout";
        t.prototype[e] = function() {
            clearTimeout(this[o]);
            var t = arguments,
                e = this;
            this[o] = setTimeout(function() {
                n.apply(e, t), delete e[o]
            }, i)
        }
    }, i.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }, i.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(t, e, i) {
            return e + "-" + i
        }).toLowerCase()
    };
    var o = t.console;
    return i.htmlInit = function(e, n) {
        i.docReady(function() {
            var s = i.toDashed(n),
                r = "data-" + s,
                a = document.querySelectorAll("[" + r + "]"),
                l = document.querySelectorAll(".js-" + s),
                c = i.makeArray(a).concat(i.makeArray(l)),
                u = r + "-options",
                d = t.jQuery;
            c.forEach(function(t) {
                var i, s = t.getAttribute(r) || t.getAttribute(u);
                try {
                    i = s && JSON.parse(s)
                } catch (a) {
                    return void(o && o.error("Error parsing " + r + " on " + t.className + ": " + a))
                }
                var l = new e(t, i);
                d && d.data(t, n, l)
            })
        })
    }, i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize))
}(window, function(t, e) {
    "use strict";

    function i(t, e) {
        t && (this.element = t, this.layout = e, this.position = {
            x: 0,
            y: 0
        }, this._create())
    }
    var n, o = document.documentElement.style,
        s = "string" == typeof o.transition ? "transition" : "WebkitTransition",
        r = "string" == typeof o.transform ? "transform" : "WebkitTransform",
        a = {
            WebkitTransition: "webkitTransitionEnd",
            transition: "transitionend"
        }[s],
        l = {
            transform: r,
            transition: s,
            transitionDuration: s + "Duration",
            transitionProperty: s + "Property",
            transitionDelay: s + "Delay"
        },
        c = i.prototype = Object.create(t.prototype);
    c.constructor = i, c._create = function() {
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        }, this.css({
            position: "absolute"
        })
    }, c.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, c.getSize = function() {
        this.size = e(this.element)
    }, c.css = function(t) {
        var e = this.element.style;
        for (var i in t) e[l[i] || i] = t[i]
    }, c.getPosition = function() {
        var t = getComputedStyle(this.element),
            e = this.layout._getOption("originLeft"),
            i = this.layout._getOption("originTop"),
            n = t[e ? "left" : "right"],
            o = t[i ? "top" : "bottom"],
            s = parseFloat(n),
            r = parseFloat(o),
            a = this.layout.size; - 1 != n.indexOf("%") && (s = s / 100 * a.width), -1 != o.indexOf("%") && (r = r / 100 * a.height), s = isNaN(s) ? 0 : s, r = isNaN(r) ? 0 : r, s -= e ? a.paddingLeft : a.paddingRight, r -= i ? a.paddingTop : a.paddingBottom, this.position.x = s, this.position.y = r
    }, c.layoutPosition = function() {
        var t = this.layout.size,
            e = {},
            i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop"),
            o = i ? "left" : "right",
            s = i ? "right" : "left",
            r = this.position.x + t[i ? "paddingLeft" : "paddingRight"];
        e[o] = this.getXValue(r), e[s] = "";
        var a = n ? "top" : "bottom",
            l = n ? "bottom" : "top",
            c = this.position.y + t[n ? "paddingTop" : "paddingBottom"];
        e[a] = this.getYValue(c), e[l] = "", this.css(e), this.emitEvent("layout", [this])
    }, c.getXValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
    }, c.getYValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
    }, c._transitionTo = function(t, e) {
        this.getPosition();
        var i = this.position.x,
            n = this.position.y,
            o = t == this.position.x && e == this.position.y;
        if (this.setPosition(t, e), o && !this.isTransitioning) return void this.layoutPosition();
        var s = {};
        s.transform = this.getTranslate(t - i, e - n), this.transition({
            to: s,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: !0
        })
    }, c.getTranslate = function(t, e) {
        var i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop");
        return "translate3d(" + (t = i ? t : -t) + "px, " + (e = n ? e : -e) + "px, 0)"
    }, c.goTo = function(t, e) {
        this.setPosition(t, e), this.layoutPosition()
    }, c.moveTo = c._transitionTo, c.setPosition = function(t, e) {
        this.position.x = parseFloat(t), this.position.y = parseFloat(e)
    }, c._nonTransition = function(t) {
        for (var e in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) t.onTransitionEnd[e].call(this)
    }, c.transition = function(t) {
        if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
        var e = this._transn;
        for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
        for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
        if (t.from) {
            this.css(t.from);
            var n = this.element.offsetHeight;
            n = null
        }
        this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
    };
    var u = "opacity," + (n = r).replace(/([A-Z])/g, function(t) {
        return "-" + t.toLowerCase()
    });
    c.enableTransition = function() {
        if (!this.isTransitioning) {
            var t = this.layout.options.transitionDuration;
            t = "number" == typeof t ? t + "ms" : t, this.css({
                transitionProperty: u,
                transitionDuration: t,
                transitionDelay: this.staggerDelay || 0
            }), this.element.addEventListener(a, this, !1)
        }
    }, c.onwebkitTransitionEnd = function(t) {
        this.ontransitionend(t)
    }, c.onotransitionend = function(t) {
        this.ontransitionend(t)
    };
    var d = {
        "-webkit-transform": "transform"
    };
    c.ontransitionend = function(t) {
        if (t.target === this.element) {
            var e = this._transn,
                i = d[t.propertyName] || t.propertyName;
            delete e.ingProperties[i],
                function t(e) {
                    for (var i in e) return !1;
                    return i = null, !0
                }(e.ingProperties) && this.disableTransition(), i in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[i]), i in e.onEnd && (e.onEnd[i].call(this), delete e.onEnd[i]), this.emitEvent("transitionEnd", [this])
        }
    }, c.disableTransition = function() {
        this.removeTransitionStyles(), this.element.removeEventListener(a, this, !1), this.isTransitioning = !1
    }, c._removeStyles = function(t) {
        var e = {};
        for (var i in t) e[i] = "";
        this.css(e)
    };
    var p = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
    };
    return c.removeTransitionStyles = function() {
        this.css(p)
    }, c.stagger = function(t) {
        t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms"
    }, c.removeElem = function() {
        this.element.parentNode.removeChild(this.element), this.css({
            display: ""
        }), this.emitEvent("remove", [this])
    }, c.remove = function() {
        return s && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
            this.removeElem()
        }), void this.hide()) : void this.removeElem()
    }, c.reveal = function() {
        delete this.isHidden, this.css({
            display: ""
        });
        var t = this.layout.options,
            e = {};
        e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, c.onRevealTransitionEnd = function() {
        this.isHidden || this.emitEvent("reveal")
    }, c.getHideRevealTransitionEndProperty = function(t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var i in e) return i
    }, c.hide = function() {
        this.isHidden = !0, this.css({
            display: ""
        });
        var t = this.layout.options,
            e = {};
        e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, c.onHideTransitionEnd = function() {
        this.isHidden && (this.css({
            display: "none"
        }), this.emitEvent("hide"))
    }, c.destroy = function() {
        this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: ""
        })
    }, i
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(i, n, o, s) {
        return e(t, i, n, o, s)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item)
}(window, function(t, e, i, n, o) {
    "use strict";

    function s(t, e) {
        var i = n.getQueryElement(t);
        if (!i) return void(a && a.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
        this.element = i, l && (this.$element = l(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e);
        var o = ++u;
        this.element.outlayerGUID = o, d[o] = this, this._create(), this._getOption("initLayout") && this.layout()
    }

    function r(t) {
        function e() {
            t.apply(this, arguments)
        }
        return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e
    }
    var a = t.console,
        l = t.jQuery,
        c = function() {},
        u = 0,
        d = {};
    s.namespace = "outlayer", s.Item = o, s.defaults = {
        containerStyle: {
            position: "relative"
        },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)"
        },
        visibleStyle: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
    var p = s.prototype;
    n.extend(p, e.prototype), p.option = function(t) {
        n.extend(this.options, t)
    }, p._getOption = function(t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
    }, s.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    }, p._create = function() {
        this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize()
    }, p.reloadItems = function() {
        this.items = this._itemize(this.element.children)
    }, p._itemize = function(t) {
        for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
            var s = e[o],
                r = new i(s, this);
            n.push(r)
        }
        return n
    }, p._filterFindItemElements = function(t) {
        return n.filterFindElements(t, this.options.itemSelector)
    }, p.getItemElements = function() {
        return this.items.map(function(t) {
            return t.element
        })
    }, p.layout = function() {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"),
            e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), this._isLayoutInited = !0
    }, p._init = p.layout, p._resetLayout = function() {
        this.getSize()
    }, p.getSize = function() {
        this.size = i(this.element)
    }, p._getMeasurement = function(t, e) {
        var n, o = this.options[t];
        o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o), this[t] = n ? i(n)[e] : o) : this[t] = 0
    }, p.layoutItems = function(t, e) {
        t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
    }, p._getItemsForLayout = function(t) {
        return t.filter(function(t) {
            return !t.isIgnored
        })
    }, p._layoutItems = function(t, e) {
        if (this._emitCompleteOnItems("layout", t), t && t.length) {
            var i = [];
            t.forEach(function(t) {
                var n = this._getItemLayoutPosition(t);
                n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n)
            }, this), this._processLayoutQueue(i)
        }
    }, p._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        }
    }, p._processLayoutQueue = function(t) {
        this.updateStagger(), t.forEach(function(t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e)
        }, this)
    }, p.updateStagger = function() {
        var t = this.options.stagger;
        return null == t ? void(this.stagger = 0) : (this.stagger = function t(e) {
            if ("number" == typeof e) return e;
            var i = e.match(/(^\d*\.?\d*)(\w*)/),
                n = i && i[1],
                o = i && i[2];
            return n.length ? (n = parseFloat(n)) * (h[o] || 1) : 0
        }(t), this.stagger)
    }, p._positionItem = function(t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i))
    }, p._postLayout = function() {
        this.resizeContainer()
    }, p.resizeContainer = function() {
        if (this._getOption("resizeContainer")) {
            var t = this._getContainerSize();
            t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1))
        }
    }, p._getContainerSize = c, p._setContainerMeasure = function(t, e) {
        if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px"
        }
    }, p._emitCompleteOnItems = function(t, e) {
        function i() {
            o.dispatchEvent(t + "Complete", null, [e])
        }

        function n() {
            ++r == s && i()
        }
        var o = this,
            s = e.length;
        if (!e || !s) return void i();
        var r = 0;
        e.forEach(function(e) {
            e.once(t, n)
        })
    }, p.dispatchEvent = function(t, e, i) {
        var n = e ? [e].concat(i) : i;
        if (this.emitEvent(t, n), l) {
            if (this.$element = this.$element || l(this.element), e) {
                var o = l.Event(e);
                o.type = t, this.$element.trigger(o, i)
            } else this.$element.trigger(t, i)
        }
    }, p.ignore = function(t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0)
    }, p.unignore = function(t) {
        var e = this.getItem(t);
        e && delete e.isIgnored
    }, p.stamp = function(t) {
        (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this))
    }, p.unstamp = function(t) {
        (t = this._find(t)) && t.forEach(function(t) {
            n.removeFrom(this.stamps, t), this.unignore(t)
        }, this)
    }, p._find = function(t) {
        return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t)) : void 0
    }, p._manageStamps = function() {
        this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
    }, p._getBoundingRect = function() {
        var t = this.element.getBoundingClientRect(),
            e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        }
    }, p._manageStamp = c, p._getElementOffset = function(t) {
        var e = t.getBoundingClientRect(),
            n = this._boundingRect,
            o = i(t);
        return {
            left: e.left - n.left - o.marginLeft,
            top: e.top - n.top - o.marginTop,
            right: n.right - e.right - o.marginRight,
            bottom: n.bottom - e.bottom - o.marginBottom
        }
    }, p.handleEvent = n.handleEvent, p.bindResize = function() {
        t.addEventListener("resize", this), this.isResizeBound = !0
    }, p.unbindResize = function() {
        t.removeEventListener("resize", this), this.isResizeBound = !1
    }, p.onresize = function() {
        this.resize()
    }, n.debounceMethod(s, "onresize", 100), p.resize = function() {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }, p.needsResizeLayout = function() {
        var t = i(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth
    }, p.addItems = function(t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e
    }, p.appended = function(t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e))
    }, p.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            var i = this.items.slice(0);
            this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i)
        }
    }, p.reveal = function(t) {
        if (this._emitCompleteOnItems("reveal", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e), t.reveal()
            })
        }
    }, p.hide = function(t) {
        if (this._emitCompleteOnItems("hide", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e), t.hide()
            })
        }
    }, p.revealItemElements = function(t) {
        var e = this.getItems(t);
        this.reveal(e)
    }, p.hideItemElements = function(t) {
        var e = this.getItems(t);
        this.hide(e)
    }, p.getItem = function(t) {
        for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t) return i
        }
    }, p.getItems = function(t) {
        t = n.makeArray(t);
        var e = [];
        return t.forEach(function(t) {
            var i = this.getItem(t);
            i && e.push(i)
        }, this), e
    }, p.remove = function(t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function(t) {
            t.remove(), n.removeFrom(this.items, t)
        }, this)
    }, p.destroy = function() {
        var t = this.element.style;
        t.height = "", t.position = "", t.width = "", this.items.forEach(function(t) {
            t.destroy()
        }), this.unbindResize(), delete d[this.element.outlayerGUID], delete this.element.outlayerGUID, l && l.removeData(this.element, this.constructor.namespace)
    }, s.data = function(t) {
        var e = (t = n.getQueryElement(t)) && t.outlayerGUID;
        return e && d[e]
    }, s.create = function(t, e) {
        var i = r(s);
        return i.defaults = n.extend({}, s.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, s.compatOptions), i.namespace = t, i.data = s.data, i.Item = r(o), n.htmlInit(i, t), l && l.bridget && l.bridget(t, i), i
    };
    var h = {
        ms: 1,
        s: 1e3
    };
    return s.Item = o, s
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
}(window, function(t, e) {
    var i = t.create("masonry");
    i.compatOptions.fitWidth = "isFitWidth";
    var n = i.prototype;
    return n._resetLayout = function() {
        this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        this.maxY = 0, this.horizontalColIndex = 0
    }, n.measureColumns = function() {
        if (this.getContainerWidth(), !this.columnWidth) {
            var t = this.items[0],
                i = t && t.element;
            this.columnWidth = i && e(i).outerWidth || this.containerWidth
        }
        var n = this.columnWidth += this.gutter,
            o = this.containerWidth + this.gutter,
            s = o / n,
            r = n - o % n;
        s = Math[r && 1 > r ? "round" : "floor"](s), this.cols = Math.max(s, 1)
    }, n.getContainerWidth = function() {
        var t = e(this._getOption("fitWidth") ? this.element.parentNode : this.element);
        this.containerWidth = t && t.innerWidth
    }, n._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth,
            i = Math[e && 1 > e ? "round" : "ceil"](t.size.outerWidth / this.columnWidth);
        i = Math.min(i, this.cols);
        for (var n = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", o = this[n](i, t), s = {
                x: this.columnWidth * o.col,
                y: o.y
            }, r = o.y + t.size.outerHeight, a = i + o.col, l = o.col; a > l; l++) this.colYs[l] = r;
        return s
    }, n._getTopColPosition = function(t) {
        var e = this._getTopColGroup(t),
            i = Math.min.apply(Math, e);
        return {
            col: e.indexOf(i),
            y: i
        }
    }, n._getTopColGroup = function(t) {
        if (2 > t) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) e[n] = this._getColGroupY(n, t);
        return e
    }, n._getColGroupY = function(t, e) {
        if (2 > e) return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i)
    }, n._getHorizontalColPosition = function(t, e) {
        var i = this.horizontalColIndex % this.cols;
        i = t > 1 && i + t > this.cols ? 0 : i;
        var n = e.size.outerWidth && e.size.outerHeight;
        return this.horizontalColIndex = n ? i + t : this.horizontalColIndex, {
            col: i,
            y: this._getColGroupY(i, t)
        }
    }, n._manageStamp = function(t) {
        var i = e(t),
            n = this._getElementOffset(t),
            o = this._getOption("originLeft") ? n.left : n.right,
            s = o + i.outerWidth,
            r = Math.floor(o / this.columnWidth);
        r = Math.max(0, r);
        var a = Math.floor(s / this.columnWidth);
        a -= s % this.columnWidth ? 0 : 1, a = Math.min(this.cols - 1, a);
        for (var l = this._getOption("originTop"), c = (l ? n.top : n.bottom) + i.outerHeight, u = r; a >= u; u++) this.colYs[u] = Math.max(c, this.colYs[u])
    }, n._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {
            height: this.maxY
        };
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t
    }, n._getContainerFitWidth = function() {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) t++;
        return (this.cols - t) * this.columnWidth - this.gutter
    }, n.needsResizeLayout = function() {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth
    }, i
});

/*! jQuery v3.6.0 | (c) OpenJS Foundation and other contributors | jquery.org/license */
! function(t, e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function(t) {
        if (!t.document) throw Error("jQuery requires a window with a document");
        return e(t)
    } : e(t)
}("undefined" != typeof window ? window : this, function(t, e) {
    "use strict";
    var i = [],
        n = Object.getPrototypeOf,
        o = i.slice,
        s = i.flat ? function(t) {
            return i.flat.call(t)
        } : function(t) {
            return i.concat.apply([], t)
        },
        r = i.push,
        a = i.indexOf,
        l = {},
        c = l.toString,
        u = l.hasOwnProperty,
        d = u.toString,
        p = d.call(Object),
        h = {},
        f = function(t) {
            return "function" == typeof t && "number" != typeof t.nodeType && "function" != typeof t.item
        },
        g = function(t) {
            return null != t && t === t.window
        },
        v = t.document,
        m = {
            type: !0,
            src: !0,
            nonce: !0,
            noModule: !0
        };

    function y(t, e, i) {
        var n, o, s = (i = i || v).createElement("script");
        if (s.text = t, e)
            for (n in m)(o = e[n] || e.getAttribute && e.getAttribute(n)) && s.setAttribute(n, o);
        i.head.appendChild(s).parentNode.removeChild(s)
    }

    function $(t) {
        return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? l[c.call(t)] || "object" : typeof t
    }
    var b = "3.6.0",
        x = function(t, e) {
            return new x.fn.init(t, e)
        };

    function T(t) {
        var e = !!t && "length" in t && t.length,
            i = $(t);
        return !f(t) && !g(t) && ("array" === i || 0 === e || "number" == typeof e && 0 < e && e - 1 in t)
    }
    x.fn = x.prototype = {
        jquery: b,
        constructor: x,
        length: 0,
        toArray: function() {
            return o.call(this)
        },
        get: function(t) {
            return null == t ? o.call(this) : t < 0 ? this[t + this.length] : this[t]
        },
        pushStack: function(t) {
            var e = x.merge(this.constructor(), t);
            return e.prevObject = this, e
        },
        each: function(t) {
            return x.each(this, t)
        },
        map: function(t) {
            return this.pushStack(x.map(this, function(e, i) {
                return t.call(e, i, e)
            }))
        },
        slice: function() {
            return this.pushStack(o.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        even: function() {
            return this.pushStack(x.grep(this, function(t, e) {
                return (e + 1) % 2
            }))
        },
        odd: function() {
            return this.pushStack(x.grep(this, function(t, e) {
                return e % 2
            }))
        },
        eq: function(t) {
            var e = this.length,
                i = +t + (t < 0 ? e : 0);
            return this.pushStack(0 <= i && i < e ? [this[i]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: r,
        sort: i.sort,
        splice: i.splice
    }, x.extend = x.fn.extend = function() {
        var t, e, i, n, o, s, r = arguments[0] || {},
            a = 1,
            l = arguments.length,
            c = !1;
        for ("boolean" == typeof r && (c = r, r = arguments[a] || {}, a++), "object" == typeof r || f(r) || (r = {}), a === l && (r = this, a--); a < l; a++)
            if (null != (t = arguments[a]))
                for (e in t) n = t[e], "__proto__" !== e && r !== n && (c && n && (x.isPlainObject(n) || (o = Array.isArray(n))) ? (i = r[e], s = o && !Array.isArray(i) ? [] : o || x.isPlainObject(i) ? i : {}, o = !1, r[e] = x.extend(c, s, n)) : void 0 !== n && (r[e] = n));
        return r
    }, x.extend({
        expando: "jQuery" + (b + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw Error(t)
        },
        noop: function() {},
        isPlainObject: function(t) {
            var e, i;
            return !(!t || "[object Object]" !== c.call(t)) && (!(e = n(t)) || "function" == typeof(i = u.call(e, "constructor") && e.constructor) && d.call(i) === p)
        },
        isEmptyObject: function(t) {
            var e;
            for (e in t) return !1;
            return !0
        },
        globalEval: function(t, e, i) {
            y(t, {
                nonce: e && e.nonce
            }, i)
        },
        each: function(t, e) {
            var i, n = 0;
            if (T(t))
                for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++);
            else
                for (n in t)
                    if (!1 === e.call(t[n], n, t[n])) break;
            return t
        },
        makeArray: function(t, e) {
            var i = e || [];
            return null != t && (T(Object(t)) ? x.merge(i, "string" == typeof t ? [t] : t) : r.call(i, t)), i
        },
        inArray: function(t, e, i) {
            return null == e ? -1 : a.call(e, t, i)
        },
        merge: function(t, e) {
            for (var i = +e.length, n = 0, o = t.length; n < i; n++) t[o++] = e[n];
            return t.length = o, t
        },
        grep: function(t, e, i) {
            for (var n = [], o = 0, s = t.length, r = !i; o < s; o++) !e(t[o], o) !== r && n.push(t[o]);
            return n
        },
        map: function(t, e, i) {
            var n, o, r = 0,
                a = [];
            if (T(t))
                for (n = t.length; r < n; r++) null != (o = e(t[r], r, i)) && a.push(o);
            else
                for (r in t) null != (o = e(t[r], r, i)) && a.push(o);
            return s(a)
        },
        guid: 1,
        support: h
    }), "function" == typeof Symbol && (x.fn[Symbol.iterator] = i[Symbol.iterator]), x.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
        l["[object " + e + "]"] = e.toLowerCase()
    });
    var _ = function(t) {
        var e, i, n, o, s, r, a, l, c, u, d, p, h, f, g, v, m, y, $, b = "sizzle" + 1 * new Date,
            x = t.document,
            T = 0,
            _ = 0,
            w = tc(),
            k = tc(),
            S = tc(),
            C = tc(),
            E = function(t, e) {
                return t === e && (d = !0), 0
            },
            A = {}.hasOwnProperty,
            L = [],
            j = L.pop,
            D = L.push,
            O = L.push,
            H = L.slice,
            z = function(t, e) {
                for (var i = 0, n = t.length; i < n; i++)
                    if (t[i] === e) return i;
                return -1
            },
            P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            N = "[\\x20\\t\\r\\n\\f]",
            I = "(?:\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            q = "\\[" + N + "*(" + I + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + N + "*\\]",
            W = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + q + ")*)|.*)\\)|)",
            R = RegExp(N + "+", "g"),
            M = RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g"),
            B = RegExp("^" + N + "*," + N + "*"),
            F = RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"),
            U = RegExp(N + "|>"),
            X = RegExp(W),
            Y = RegExp("^" + I + "$"),
            G = {
                ID: RegExp("^#(" + I + ")"),
                CLASS: RegExp("^\\.(" + I + ")"),
                TAG: RegExp("^(" + I + "|[*])"),
                ATTR: RegExp("^" + q),
                PSEUDO: RegExp("^" + W),
                CHILD: RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)", "i"),
                bool: RegExp("^(?:" + P + ")$", "i"),
                needsContext: RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)", "i")
            },
            Q = /HTML$/i,
            V = /^(?:input|select|textarea|button)$/i,
            K = /^h\d$/i,
            J = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            tt = /[+~]/,
            te = RegExp("\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\([^\\r\\n\\f])", "g"),
            ti = function(t, e) {
                var i = "0x" + t.slice(1) - 65536;
                return e || (i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320))
            },
            tn = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            to = function(t, e) {
                return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
            },
            ts = function() {
                p()
            },
            tr = tx(function(t) {
                return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase()
            }, {
                dir: "parentNode",
                next: "legend"
            });
        try {
            O.apply(L = H.call(x.childNodes), x.childNodes), L[x.childNodes.length].nodeType
        } catch (ta) {
            O = {
                apply: L.length ? function(t, e) {
                    D.apply(t, H.call(e))
                } : function(t, e) {
                    for (var i = t.length, n = 0; t[i++] = e[n++];);
                    t.length = i - 1
                }
            }
        }

        function tl(t, e, n, o) {
            var s, a, c, u, d, f, m, y = e && e.ownerDocument,
                x = e ? e.nodeType : 9;
            if (n = n || [], "string" != typeof t || !t || 1 !== x && 9 !== x && 11 !== x) return n;
            if (!o && (p(e), e = e || h, g)) {
                if (11 !== x && (d = Z.exec(t))) {
                    if (s = d[1]) {
                        if (9 === x) {
                            if (!(c = e.getElementById(s))) return n;
                            if (c.id === s) return n.push(c), n
                        } else if (y && (c = y.getElementById(s)) && $(e, c) && c.id === s) return n.push(c), n
                    } else {
                        if (d[2]) return O.apply(n, e.getElementsByTagName(t)), n;
                        if ((s = d[3]) && i.getElementsByClassName && e.getElementsByClassName) return O.apply(n, e.getElementsByClassName(s)), n
                    }
                }
                if (i.qsa && !C[t + " "] && (!v || !v.test(t)) && (1 !== x || "object" !== e.nodeName.toLowerCase())) {
                    if (m = t, y = e, 1 === x && (U.test(t) || F.test(t))) {
                        for ((y = tt.test(t) && ty(e.parentNode) || e) === e && i.scope || ((u = e.getAttribute("id")) ? u = u.replace(tn, to) : e.setAttribute("id", u = b)), a = (f = r(t)).length; a--;) f[a] = (u ? "#" + u : ":scope") + " " + tb(f[a]);
                        m = f.join(",")
                    }
                    try {
                        return O.apply(n, y.querySelectorAll(m)), n
                    } catch (T) {
                        C(t, !0)
                    } finally {
                        u === b && e.removeAttribute("id")
                    }
                }
            }
            return l(t.replace(M, "$1"), e, n, o)
        }

        function tc() {
            var t = [];
            return function e(i, o) {
                return t.push(i + " ") > n.cacheLength && delete e[t.shift()], e[i + " "] = o
            }
        }

        function tu(t) {
            return t[b] = !0, t
        }

        function td(t) {
            var e = h.createElement("fieldset");
            try {
                return !!t(e)
            } catch (i) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e), e = null
            }
        }

        function tp(t, e) {
            for (var i = t.split("|"), o = i.length; o--;) n.attrHandle[i[o]] = e
        }

        function th(t, e) {
            var i = e && t,
                n = i && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
            if (n) return n;
            if (i) {
                for (; i = i.nextSibling;)
                    if (i === e) return -1
            }
            return t ? 1 : -1
        }

        function tf(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }

        function tg(t) {
            return function(e) {
                var i = e.nodeName.toLowerCase();
                return ("input" === i || "button" === i) && e.type === t
            }
        }

        function tv(t) {
            return function(e) {
                return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || !t !== e.isDisabled && tr(e) === t : e.disabled === t : "label" in e && e.disabled === t
            }
        }

        function tm(t) {
            return tu(function(e) {
                return e = +e, tu(function(i, n) {
                    for (var o, s = t([], i.length, e), r = s.length; r--;) i[o = s[r]] && (i[o] = !(n[o] = i[o]))
                })
            })
        }

        function ty(t) {
            return t && void 0 !== t.getElementsByTagName && t
        }
        for (e in i = tl.support = {}, s = tl.isXML = function(t) {
                var e = t && t.namespaceURI,
                    i = t && (t.ownerDocument || t).documentElement;
                return !Q.test(e || i && i.nodeName || "HTML")
            }, p = tl.setDocument = function(t) {
                var e, o, r = t ? t.ownerDocument || t : x;
                return r != h && 9 === r.nodeType && r.documentElement && (f = (h = r).documentElement, g = !s(h), x != h && (o = h.defaultView) && o.top !== o && (o.addEventListener ? o.addEventListener("unload", ts, !1) : o.attachEvent && o.attachEvent("onunload", ts)), i.scope = td(function(t) {
                    return f.appendChild(t).appendChild(h.createElement("div")), void 0 !== t.querySelectorAll && !t.querySelectorAll(":scope fieldset div").length
                }), i.attributes = td(function(t) {
                    return t.className = "i", !t.getAttribute("className")
                }), i.getElementsByTagName = td(function(t) {
                    return t.appendChild(h.createComment("")), !t.getElementsByTagName("*").length
                }), i.getElementsByClassName = J.test(h.getElementsByClassName), i.getById = td(function(t) {
                    return f.appendChild(t).id = b, !h.getElementsByName || !h.getElementsByName(b).length
                }), i.getById ? (n.filter.ID = function(t) {
                    var e = t.replace(te, ti);
                    return function(t) {
                        return t.getAttribute("id") === e
                    }
                }, n.find.ID = function(t, e) {
                    if (void 0 !== e.getElementById && g) {
                        var i = e.getElementById(t);
                        return i ? [i] : []
                    }
                }) : (n.filter.ID = function(t) {
                    var e = t.replace(te, ti);
                    return function(t) {
                        var i = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                        return i && i.value === e
                    }
                }, n.find.ID = function(t, e) {
                    if (void 0 !== e.getElementById && g) {
                        var i, n, o, s = e.getElementById(t);
                        if (s) {
                            if ((i = s.getAttributeNode("id")) && i.value === t) return [s];
                            for (o = e.getElementsByName(t), n = 0; s = o[n++];)
                                if ((i = s.getAttributeNode("id")) && i.value === t) return [s]
                        }
                        return []
                    }
                }), n.find.TAG = i.getElementsByTagName ? function(t, e) {
                    return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : i.qsa ? e.querySelectorAll(t) : void 0
                } : function(t, e) {
                    var i, n = [],
                        o = 0,
                        s = e.getElementsByTagName(t);
                    if ("*" === t) {
                        for (; i = s[o++];) 1 === i.nodeType && n.push(i);
                        return n
                    }
                    return s
                }, n.find.CLASS = i.getElementsByClassName && function(t, e) {
                    if (void 0 !== e.getElementsByClassName && g) return e.getElementsByClassName(t)
                }, m = [], v = [], (i.qsa = J.test(h.querySelectorAll)) && (td(function(t) {
                    var e;
                    f.appendChild(t).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + N + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || v.push("\\[" + N + "*(?:value|" + P + ")"), t.querySelectorAll("[id~=" + b + "-]").length || v.push("~="), (e = h.createElement("input")).setAttribute("name", ""), t.appendChild(e), t.querySelectorAll("[name='']").length || v.push("\\[" + N + "*name" + N + "*=" + N + "*(?:''|\"\")"), t.querySelectorAll(":checked").length || v.push(":checked"), t.querySelectorAll("a#" + b + "+*").length || v.push(".#.+[+~]"), t.querySelectorAll("\\\f"), v.push("[\\r\\n\\f]")
                }), td(function(t) {
                    t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    var e = h.createElement("input");
                    e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && v.push("name" + N + "*[*^$|!~]?="), 2 !== t.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"), f.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), v.push(",.*:")
                })), (i.matchesSelector = J.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && td(function(t) {
                    i.disconnectedMatch = y.call(t, "*"), y.call(t, "[s!='']:x"), m.push("!=", W)
                }), v = v.length && RegExp(v.join("|")), m = m.length && RegExp(m.join("|")), $ = (e = J.test(f.compareDocumentPosition)) || J.test(f.contains) ? function(t, e) {
                    var i = 9 === t.nodeType ? t.documentElement : t,
                        n = e && e.parentNode;
                    return t === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n)))
                } : function(t, e) {
                    if (e) {
                        for (; e = e.parentNode;)
                            if (e === t) return !0
                    }
                    return !1
                }, E = e ? function(t, e) {
                    if (t === e) return d = !0, 0;
                    var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                    return n || (1 & (n = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !i.sortDetached && e.compareDocumentPosition(t) === n ? t == h || t.ownerDocument == x && $(x, t) ? -1 : e == h || e.ownerDocument == x && $(x, e) ? 1 : u ? z(u, t) - z(u, e) : 0 : 4 & n ? -1 : 1)
                } : function(t, e) {
                    if (t === e) return d = !0, 0;
                    var i, n = 0,
                        o = t.parentNode,
                        s = e.parentNode,
                        r = [t],
                        a = [e];
                    if (!o || !s) return t == h ? -1 : e == h ? 1 : o ? -1 : s ? 1 : u ? z(u, t) - z(u, e) : 0;
                    if (o === s) return th(t, e);
                    for (i = t; i = i.parentNode;) r.unshift(i);
                    for (i = e; i = i.parentNode;) a.unshift(i);
                    for (; r[n] === a[n];) n++;
                    return n ? th(r[n], a[n]) : r[n] == x ? -1 : a[n] == x ? 1 : 0
                }), h
            }, tl.matches = function(t, e) {
                return tl(t, null, null, e)
            }, tl.matchesSelector = function(t, e) {
                if (p(t), i.matchesSelector && g && !C[e + " "] && (!m || !m.test(e)) && (!v || !v.test(e))) try {
                    var n = y.call(t, e);
                    if (n || i.disconnectedMatch || t.document && 11 !== t.document.nodeType) return n
                } catch (o) {
                    C(e, !0)
                }
                return 0 < tl(e, h, null, [t]).length
            }, tl.contains = function(t, e) {
                return (t.ownerDocument || t) != h && p(t), $(t, e)
            }, tl.attr = function(t, e) {
                (t.ownerDocument || t) != h && p(t);
                var o = n.attrHandle[e.toLowerCase()],
                    s = o && A.call(n.attrHandle, e.toLowerCase()) ? o(t, e, !g) : void 0;
                return void 0 !== s ? s : i.attributes || !g ? t.getAttribute(e) : (s = t.getAttributeNode(e)) && s.specified ? s.value : null
            }, tl.escape = function(t) {
                return (t + "").replace(tn, to)
            }, tl.error = function(t) {
                throw Error("Syntax error, unrecognized expression: " + t)
            }, tl.uniqueSort = function(t) {
                var e, n = [],
                    o = 0,
                    s = 0;
                if (d = !i.detectDuplicates, u = !i.sortStable && t.slice(0), t.sort(E), d) {
                    for (; e = t[s++];) e === t[s] && (o = n.push(s));
                    for (; o--;) t.splice(n[o], 1)
                }
                return u = null, t
            }, o = tl.getText = function(t) {
                var e, i = "",
                    n = 0,
                    s = t.nodeType;
                if (s) {
                    if (1 === s || 9 === s || 11 === s) {
                        if ("string" == typeof t.textContent) return t.textContent;
                        for (t = t.firstChild; t; t = t.nextSibling) i += o(t)
                    } else if (3 === s || 4 === s) return t.nodeValue
                } else
                    for (; e = t[n++];) i += o(e);
                return i
            }, (n = tl.selectors = {
                cacheLength: 50,
                createPseudo: tu,
                match: G,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(t) {
                        return t[1] = t[1].replace(te, ti), t[3] = (t[3] || t[4] || t[5] || "").replace(te, ti), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                    },
                    CHILD: function(t) {
                        return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || tl.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && tl.error(t[0]), t
                    },
                    PSEUDO: function(t) {
                        var e, i = !t[6] && t[2];
                        return G.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : i && X.test(i) && (e = r(i, !0)) && (e = i.indexOf(")", i.length - e) - i.length) && (t[0] = t[0].slice(0, e), t[2] = i.slice(0, e)), t.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(t) {
                        var e = t.replace(te, ti).toLowerCase();
                        return "*" === t ? function() {
                            return !0
                        } : function(t) {
                            return t.nodeName && t.nodeName.toLowerCase() === e
                        }
                    },
                    CLASS: function(t) {
                        var e = w[t + " "];
                        return e || (e = RegExp("(^|" + N + ")" + t + "(" + N + "|$)"), w(t, function(t) {
                            return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                        }))
                    },
                    ATTR: function(t, e, i) {
                        return function(n) {
                            var o = tl.attr(n, t);
                            return null == o ? "!=" === e : !e || (o += "", "=" === e ? o === i : "!=" === e ? o !== i : "^=" === e ? i && 0 === o.indexOf(i) : "*=" === e ? i && -1 < o.indexOf(i) : "$=" === e ? i && o.slice(-i.length) === i : "~=" === e ? -1 < (" " + o.replace(R, " ") + " ").indexOf(i) : "|=" === e && (o === i || o.slice(0, i.length + 1) === i + "-"))
                        }
                    },
                    CHILD: function(t, e, i, n, o) {
                        var s = "nth" !== t.slice(0, 3),
                            r = "last" !== t.slice(-4),
                            a = "of-type" === e;
                        return 1 === n && 0 === o ? function(t) {
                            return !!t.parentNode
                        } : function(e, i, l) {
                            var c, u, d, p, h, f, g = s !== r ? "nextSibling" : "previousSibling",
                                v = e.parentNode,
                                m = a && e.nodeName.toLowerCase(),
                                y = !l && !a,
                                $ = !1;
                            if (v) {
                                if (s) {
                                    for (; g;) {
                                        for (p = e; p = p[g];)
                                            if (a ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) return !1;
                                        f = g = "only" === t && !f && "nextSibling"
                                    }
                                    return !0
                                }
                                if (f = [r ? v.firstChild : v.lastChild], r && y) {
                                    for ($ = (h = (c = (u = (d = (p = v)[b] || (p[b] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === T && c[1]) && c[2], p = h && v.childNodes[h]; p = ++h && p && p[g] || ($ = h = 0) || f.pop();)
                                        if (1 === p.nodeType && ++$ && p === e) {
                                            u[t] = [T, h, $];
                                            break
                                        }
                                } else if (y && ($ = h = (c = (u = (d = (p = e)[b] || (p[b] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === T && c[1]), !1 === $)
                                    for (;
                                        (p = ++h && p && p[g] || ($ = h = 0) || f.pop()) && (!((a ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) && ++$) || (y && ((u = (d = p[b] || (p[b] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] = [T, $]), p !== e)););
                                return ($ -= o) === n || $ % n == 0 && 0 <= $ / n
                            }
                        }
                    },
                    PSEUDO: function(t, e) {
                        var i, o = n.pseudos[t] || n.setFilters[t.toLowerCase()] || tl.error("unsupported pseudo: " + t);
                        return o[b] ? o(e) : 1 < o.length ? (i = [t, t, "", e], n.setFilters.hasOwnProperty(t.toLowerCase()) ? tu(function(t, i) {
                            for (var n, s = o(t, e), r = s.length; r--;) t[n = z(t, s[r])] = !(i[n] = s[r])
                        }) : function(t) {
                            return o(t, 0, i)
                        }) : o
                    }
                },
                pseudos: {
                    not: tu(function(t) {
                        var e = [],
                            i = [],
                            n = a(t.replace(M, "$1"));
                        return n[b] ? tu(function(t, e, i, o) {
                            for (var s, r = n(t, null, o, []), a = t.length; a--;)(s = r[a]) && (t[a] = !(e[a] = s))
                        }) : function(t, o, s) {
                            return e[0] = t, n(e, null, s, i), e[0] = null, !i.pop()
                        }
                    }),
                    has: tu(function(t) {
                        return function(e) {
                            return 0 < tl(t, e).length
                        }
                    }),
                    contains: tu(function(t) {
                        return t = t.replace(te, ti),
                            function(e) {
                                return -1 < (e.textContent || o(e)).indexOf(t)
                            }
                    }),
                    lang: tu(function(t) {
                        return Y.test(t || "") || tl.error("unsupported lang: " + t), t = t.replace(te, ti).toLowerCase(),
                            function(e) {
                                var i;
                                do
                                    if (i = g ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (i = i.toLowerCase()) === t || 0 === i.indexOf(t + "-"); while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1
                            }
                    }),
                    target: function(e) {
                        var i = t.location && t.location.hash;
                        return i && i.slice(1) === e.id
                    },
                    root: function(t) {
                        return t === f
                    },
                    focus: function(t) {
                        return t === h.activeElement && (!h.hasFocus || h.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                    },
                    enabled: tv(!1),
                    disabled: tv(!0),
                    checked: function(t) {
                        var e = t.nodeName.toLowerCase();
                        return "input" === e && !!t.checked || "option" === e && !!t.selected
                    },
                    selected: function(t) {
                        return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                    },
                    empty: function(t) {
                        for (t = t.firstChild; t; t = t.nextSibling)
                            if (t.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(t) {
                        return !n.pseudos.empty(t)
                    },
                    header: function(t) {
                        return K.test(t.nodeName)
                    },
                    input: function(t) {
                        return V.test(t.nodeName)
                    },
                    button: function(t) {
                        var e = t.nodeName.toLowerCase();
                        return "input" === e && "button" === t.type || "button" === e
                    },
                    text: function(t) {
                        var e;
                        return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                    },
                    first: tm(function() {
                        return [0]
                    }),
                    last: tm(function(t, e) {
                        return [e - 1]
                    }),
                    eq: tm(function(t, e, i) {
                        return [i < 0 ? i + e : i]
                    }),
                    even: tm(function(t, e) {
                        for (var i = 0; i < e; i += 2) t.push(i);
                        return t
                    }),
                    odd: tm(function(t, e) {
                        for (var i = 1; i < e; i += 2) t.push(i);
                        return t
                    }),
                    lt: tm(function(t, e, i) {
                        for (var n = i < 0 ? i + e : e < i ? e : i; 0 <= --n;) t.push(n);
                        return t
                    }),
                    gt: tm(function(t, e, i) {
                        for (var n = i < 0 ? i + e : i; ++n < e;) t.push(n);
                        return t
                    })
                }
            }).pseudos.nth = n.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) n.pseudos[e] = tf(e);
        for (e in {
                submit: !0,
                reset: !0
            }) n.pseudos[e] = tg(e);

        function t$() {}

        function tb(t) {
            for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
            return n
        }

        function tx(t, e, i) {
            var n = e.dir,
                o = e.next,
                s = o || n,
                r = i && "parentNode" === s,
                a = _++;
            return e.first ? function(e, i, o) {
                for (; e = e[n];)
                    if (1 === e.nodeType || r) return t(e, i, o);
                return !1
            } : function(e, i, l) {
                var c, u, d, p = [T, a];
                if (l) {
                    for (; e = e[n];)
                        if ((1 === e.nodeType || r) && t(e, i, l)) return !0
                } else
                    for (; e = e[n];)
                        if (1 === e.nodeType || r) {
                            if (u = (d = e[b] || (e[b] = {}))[e.uniqueID] || (d[e.uniqueID] = {}), o && o === e.nodeName.toLowerCase()) e = e[n] || e;
                            else {
                                if ((c = u[s]) && c[0] === T && c[1] === a) return p[2] = c[2];
                                if ((u[s] = p)[2] = t(e, i, l)) return !0
                            }
                        } return !1
            }
        }

        function tT(t) {
            return 1 < t.length ? function(e, i, n) {
                for (var o = t.length; o--;)
                    if (!t[o](e, i, n)) return !1;
                return !0
            } : t[0]
        }

        function t_(t, e, i, n, o) {
            for (var s, r = [], a = 0, l = t.length, c = null != e; a < l; a++)(s = t[a]) && (i && !i(s, n, o) || (r.push(s), c && e.push(a)));
            return r
        }

        function tw(t, e, i, n, o, s) {
            return n && !n[b] && (n = tw(n)), o && !o[b] && (o = tw(o, s)), tu(function(s, r, a, l) {
                var c, u, d, p = [],
                    h = [],
                    f = r.length,
                    g = s || function(t, e, i) {
                        for (var n = 0, o = e.length; n < o; n++) tl(t, e[n], i);
                        return i
                    }(e || "*", a.nodeType ? [a] : a, []),
                    v = t && (s || !e) ? t_(g, p, t, a, l) : g,
                    m = i ? o || (s ? t : f || n) ? [] : r : v;
                if (i && i(v, m, a, l), n)
                    for (c = t_(m, h), n(c, [], a, l), u = c.length; u--;)(d = c[u]) && (m[h[u]] = !(v[h[u]] = d));
                if (s) {
                    if (o || t) {
                        if (o) {
                            for (c = [], u = m.length; u--;)(d = m[u]) && c.push(v[u] = d);
                            o(null, m = [], c, l)
                        }
                        for (u = m.length; u--;)(d = m[u]) && -1 < (c = o ? z(s, d) : p[u]) && (s[c] = !(r[c] = d))
                    }
                } else m = t_(m === r ? m.splice(f, m.length) : m), o ? o(null, r, m, l) : O.apply(r, m)
            })
        }

        function tk(t) {
            for (var e, i, o, s = t.length, r = n.relative[t[0].type], a = r || n.relative[" "], l = r ? 1 : 0, u = tx(function(t) {
                    return t === e
                }, a, !0), d = tx(function(t) {
                    return -1 < z(e, t)
                }, a, !0), p = [function(t, i, n) {
                    var o = !r && (n || i !== c) || ((e = i).nodeType ? u(t, i, n) : d(t, i, n));
                    return e = null, o
                }]; l < s; l++)
                if (i = n.relative[t[l].type]) p = [tx(tT(p), i)];
                else {
                    if ((i = n.filter[t[l].type].apply(null, t[l].matches))[b]) {
                        for (o = ++l; o < s && !n.relative[t[o].type]; o++);
                        return tw(1 < l && tT(p), 1 < l && tb(t.slice(0, l - 1).concat({
                            value: " " === t[l - 2].type ? "*" : ""
                        })).replace(M, "$1"), i, l < o && tk(t.slice(l, o)), o < s && tk(t = t.slice(o)), o < s && tb(t))
                    }
                    p.push(i)
                }
            return tT(p)
        }
        return t$.prototype = n.filters = n.pseudos, n.setFilters = new t$, r = tl.tokenize = function(t, e) {
            var i, o, s, r, a, l, c, u = k[t + " "];
            if (u) return e ? 0 : u.slice(0);
            for (a = t, l = [], c = n.preFilter; a;) {
                for (r in (!i || (o = B.exec(a))) && (o && (a = a.slice(o[0].length) || a), l.push(s = [])), i = !1, (o = F.exec(a)) && (i = o.shift(), s.push({
                        value: i,
                        type: o[0].replace(M, " ")
                    }), a = a.slice(i.length)), n.filter)(o = G[r].exec(a)) && (!c[r] || (o = c[r](o))) && (i = o.shift(), s.push({
                    value: i,
                    type: r,
                    matches: o
                }), a = a.slice(i.length));
                if (!i) break
            }
            return e ? a.length : a ? tl.error(t) : k(t, l).slice(0)
        }, a = tl.compile = function(t, e) {
            var i, o, s, a, l, u, d = [],
                f = [],
                v = S[t + " "];
            if (!v) {
                for (e || (e = r(t)), i = e.length; i--;)(v = tk(e[i]))[b] ? d.push(v) : f.push(v);
                (v = S(t, (o = f, a = 0 < (s = d).length, l = 0 < o.length, u = function(t, e, i, r, u) {
                    var d, f, v, m = 0,
                        y = "0",
                        $ = t && [],
                        b = [],
                        x = c,
                        _ = t || l && n.find.TAG("*", u),
                        w = T += null == x ? 1 : Math.random() || .1,
                        k = _.length;
                    for (u && (c = e == h || e || u); y !== k && null != (d = _[y]); y++) {
                        if (l && d) {
                            for (f = 0, e || d.ownerDocument == h || (p(d), i = !g); v = o[f++];)
                                if (v(d, e || h, i)) {
                                    r.push(d);
                                    break
                                }
                            u && (T = w)
                        }
                        a && ((d = !v && d) && m--, t && $.push(d))
                    }
                    if (m += y, a && y !== m) {
                        for (f = 0; v = s[f++];) v($, b, e, i);
                        if (t) {
                            if (0 < m)
                                for (; y--;) $[y] || b[y] || (b[y] = j.call(r));
                            b = t_(b)
                        }
                        O.apply(r, b), u && !t && 0 < b.length && 1 < m + s.length && tl.uniqueSort(r)
                    }
                    return u && (T = w, c = x), $
                }, a ? tu(u) : u))).selector = t
            }
            return v
        }, l = tl.select = function(t, e, i, o) {
            var s, l, c, u, d, p = "function" == typeof t && t,
                h = !o && r(t = p.selector || t);
            if (i = i || [], 1 === h.length) {
                if (2 < (l = h[0] = h[0].slice(0)).length && "ID" === (c = l[0]).type && 9 === e.nodeType && g && n.relative[l[1].type]) {
                    if (!(e = (n.find.ID(c.matches[0].replace(te, ti), e) || [])[0])) return i;
                    p && (e = e.parentNode), t = t.slice(l.shift().value.length)
                }
                for (s = G.needsContext.test(t) ? 0 : l.length; s-- && (c = l[s], !n.relative[u = c.type]);)
                    if ((d = n.find[u]) && (o = d(c.matches[0].replace(te, ti), tt.test(l[0].type) && ty(e.parentNode) || e))) {
                        if (l.splice(s, 1), !(t = o.length && tb(l))) return O.apply(i, o), i;
                        break
                    }
            }
            return (p || a(t, h))(o, e, !g, i, !e || tt.test(t) && ty(e.parentNode) || e), i
        }, i.sortStable = b.split("").sort(E).join("") === b, i.detectDuplicates = !!d, p(), i.sortDetached = td(function(t) {
            return 1 & t.compareDocumentPosition(h.createElement("fieldset"))
        }), td(function(t) {
            return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
        }) || tp("type|href|height|width", function(t, e, i) {
            if (!i) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }), i.attributes && td(function(t) {
            return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
        }) || tp("value", function(t, e, i) {
            if (!i && "input" === t.nodeName.toLowerCase()) return t.defaultValue
        }), td(function(t) {
            return null == t.getAttribute("disabled")
        }) || tp(P, function(t, e, i) {
            var n;
            if (!i) return !0 === t[e] ? e.toLowerCase() : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
        }), tl
    }(t);
    x.find = _, x.expr = _.selectors, x.expr[":"] = x.expr.pseudos, x.uniqueSort = x.unique = _.uniqueSort, x.text = _.getText, x.isXMLDoc = _.isXML, x.contains = _.contains, x.escapeSelector = _.escape;
    var w = function(t, e, i) {
            for (var n = [], o = void 0 !== i;
                (t = t[e]) && 9 !== t.nodeType;)
                if (1 === t.nodeType) {
                    if (o && x(t).is(i)) break;
                    n.push(t)
                }
            return n
        },
        k = function(t, e) {
            for (var i = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && i.push(t);
            return i
        },
        S = x.expr.match.needsContext;

    function C(t, e) {
        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
    }
    var E = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function A(t, e, i) {
        return f(e) ? x.grep(t, function(t, n) {
            return !!e.call(t, n, t) !== i
        }) : e.nodeType ? x.grep(t, function(t) {
            return t === e !== i
        }) : "string" != typeof e ? x.grep(t, function(t) {
            return -1 < a.call(e, t) !== i
        }) : x.filter(e, t, i)
    }
    x.filter = function(t, e, i) {
        var n = e[0];
        return i && (t = ":not(" + t + ")"), 1 === e.length && 1 === n.nodeType ? x.find.matchesSelector(n, t) ? [n] : [] : x.find.matches(t, x.grep(e, function(t) {
            return 1 === t.nodeType
        }))
    }, x.fn.extend({
        find: function(t) {
            var e, i, n = this.length,
                o = this;
            if ("string" != typeof t) return this.pushStack(x(t).filter(function() {
                for (e = 0; e < n; e++)
                    if (x.contains(o[e], this)) return !0
            }));
            for (i = this.pushStack([]), e = 0; e < n; e++) x.find(t, o[e], i);
            return 1 < n ? x.uniqueSort(i) : i
        },
        filter: function(t) {
            return this.pushStack(A(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(A(this, t || [], !0))
        },
        is: function(t) {
            return !!A(this, "string" == typeof t && S.test(t) ? x(t) : t || [], !1).length
        }
    });
    var L, j = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (x.fn.init = function(t, e, i) {
        var n, o;
        if (!t) return this;
        if (i = i || L, "string" == typeof t) {
            if (!(n = "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length ? [null, t, null] : j.exec(t)) || !n[1] && e) return !e || e.jquery ? (e || i).find(t) : this.constructor(e).find(t);
            if (n[1]) {
                if (e = e instanceof x ? e[0] : e, x.merge(this, x.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : v, !0)), E.test(n[1]) && x.isPlainObject(e))
                    for (n in e) f(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                return this
            }
            return (o = v.getElementById(n[2])) && (this[0] = o, this.length = 1), this
        }
        return t.nodeType ? (this[0] = t, this.length = 1, this) : f(t) ? void 0 !== i.ready ? i.ready(t) : t(x) : x.makeArray(t, this)
    }).prototype = x.fn, L = x(v);
    var D = /^(?:parents|prev(?:Until|All))/,
        O = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };

    function H(t, e) {
        for (;
            (t = t[e]) && 1 !== t.nodeType;);
        return t
    }
    x.fn.extend({
        has: function(t) {
            var e = x(t, this),
                i = e.length;
            return this.filter(function() {
                for (var t = 0; t < i; t++)
                    if (x.contains(this, e[t])) return !0
            })
        },
        closest: function(t, e) {
            var i, n = 0,
                o = this.length,
                s = [],
                r = "string" != typeof t && x(t);
            if (!S.test(t)) {
                for (; n < o; n++)
                    for (i = this[n]; i && i !== e; i = i.parentNode)
                        if (i.nodeType < 11 && (r ? -1 < r.index(i) : 1 === i.nodeType && x.find.matchesSelector(i, t))) {
                            s.push(i);
                            break
                        }
            }
            return this.pushStack(1 < s.length ? x.uniqueSort(s) : s)
        },
        index: function(t) {
            return t ? "string" == typeof t ? a.call(x(t), this[0]) : a.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, e) {
            return this.pushStack(x.uniqueSort(x.merge(this.get(), x(t, e))))
        },
        addBack: function(t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }), x.each({
        parent: function(t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null
        },
        parents: function(t) {
            return w(t, "parentNode")
        },
        parentsUntil: function(t, e, i) {
            return w(t, "parentNode", i)
        },
        next: function(t) {
            return H(t, "nextSibling")
        },
        prev: function(t) {
            return H(t, "previousSibling")
        },
        nextAll: function(t) {
            return w(t, "nextSibling")
        },
        prevAll: function(t) {
            return w(t, "previousSibling")
        },
        nextUntil: function(t, e, i) {
            return w(t, "nextSibling", i)
        },
        prevUntil: function(t, e, i) {
            return w(t, "previousSibling", i)
        },
        siblings: function(t) {
            return k((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return k(t.firstChild)
        },
        contents: function(t) {
            return null != t.contentDocument && n(t.contentDocument) ? t.contentDocument : (C(t, "template") && (t = t.content || t), x.merge([], t.childNodes))
        }
    }, function(t, e) {
        x.fn[t] = function(i, n) {
            var o = x.map(this, e, i);
            return "Until" !== t.slice(-5) && (n = i), n && "string" == typeof n && (o = x.filter(n, o)), 1 < this.length && (O[t] || x.uniqueSort(o), D.test(t) && o.reverse()), this.pushStack(o)
        }
    });
    var z = /[^\x20\t\r\n\f]+/g;

    function P(t) {
        return t
    }

    function N(t) {
        throw t
    }

    function I(t, e, i, n) {
        var o;
        try {
            t && f(o = t.promise) ? o.call(t).done(e).fail(i) : t && f(o = t.then) ? o.call(t, e, i) : e.apply(void 0, [t].slice(n))
        } catch (s) {
            i.apply(void 0, [s])
        }
    }
    x.Callbacks = function(t) {
        t = "string" == typeof t ? (e = t, i = {}, x.each(e.match(z) || [], function(t, e) {
            i[e] = !0
        }), i) : x.extend({}, t);
        var e, i, n, o, s, r, a = [],
            l = [],
            c = -1,
            u = function() {
                for (r = r || t.once, s = n = !0; l.length; c = -1)
                    for (o = l.shift(); ++c < a.length;) !1 === a[c].apply(o[0], o[1]) && t.stopOnFalse && (c = a.length, o = !1);
                t.memory || (o = !1), n = !1, r && (a = o ? [] : "")
            },
            d = {
                add: function() {
                    return a && (o && !n && (c = a.length - 1, l.push(o)), function e(i) {
                        x.each(i, function(i, n) {
                            f(n) ? t.unique && d.has(n) || a.push(n) : n && n.length && "string" !== $(n) && e(n)
                        })
                    }(arguments), o && !n && u()), this
                },
                remove: function() {
                    return x.each(arguments, function(t, e) {
                        for (var i; - 1 < (i = x.inArray(e, a, i));) a.splice(i, 1), i <= c && c--
                    }), this
                },
                has: function(t) {
                    return t ? -1 < x.inArray(t, a) : 0 < a.length
                },
                empty: function() {
                    return a && (a = []), this
                },
                disable: function() {
                    return r = l = [], a = o = "", this
                },
                disabled: function() {
                    return !a
                },
                lock: function() {
                    return r = l = [], o || n || (a = o = ""), this
                },
                locked: function() {
                    return !!r
                },
                fireWith: function(t, e) {
                    return r || (e = [t, (e = e || []).slice ? e.slice() : e], l.push(e), n || u()), this
                },
                fire: function() {
                    return d.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!s
                }
            };
        return d
    }, x.extend({
        Deferred: function(e) {
            var i = [
                    ["notify", "progress", x.Callbacks("memory"), x.Callbacks("memory"), 2],
                    ["resolve", "done", x.Callbacks("once memory"), x.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", x.Callbacks("once memory"), x.Callbacks("once memory"), 1, "rejected"]
                ],
                n = "pending",
                o = {
                    state: function() {
                        return n
                    },
                    always: function() {
                        return s.done(arguments).fail(arguments), this
                    },
                    catch: function(t) {
                        return o.then(null, t)
                    },
                    pipe: function() {
                        var t = arguments;
                        return x.Deferred(function(e) {
                            x.each(i, function(i, n) {
                                var o = f(t[n[4]]) && t[n[4]];
                                s[n[1]](function() {
                                    var t = o && o.apply(this, arguments);
                                    t && f(t.promise) ? t.promise().progress(e.notify).done(e.resolve).fail(e.reject) : e[n[0] + "With"](this, o ? [t] : arguments)
                                })
                            }), t = null
                        }).promise()
                    },
                    then: function(e, n, o) {
                        var s = 0;

                        function r(e, i, n, o) {
                            return function() {
                                var a = this,
                                    l = arguments,
                                    c = function() {
                                        var t, c;
                                        if (!(e < s)) {
                                            if ((t = n.apply(a, l)) === i.promise()) throw TypeError("Thenable self-resolution");
                                            f(c = t && ("object" == typeof t || "function" == typeof t) && t.then) ? o ? c.call(t, r(s, i, P, o), r(s, i, N, o)) : (s++, c.call(t, r(s, i, P, o), r(s, i, N, o), r(s, i, P, i.notifyWith))) : (n !== P && (a = void 0, l = [t]), (o || i.resolveWith)(a, l))
                                        }
                                    },
                                    u = o ? c : function() {
                                        try {
                                            c()
                                        } catch (t) {
                                            x.Deferred.exceptionHook && x.Deferred.exceptionHook(t, u.stackTrace), s <= e + 1 && (n !== N && (a = void 0, l = [t]), i.rejectWith(a, l))
                                        }
                                    };
                                e ? u() : (x.Deferred.getStackHook && (u.stackTrace = x.Deferred.getStackHook()), t.setTimeout(u))
                            }
                        }
                        return x.Deferred(function(t) {
                            i[0][3].add(r(0, t, f(o) ? o : P, t.notifyWith)), i[1][3].add(r(0, t, f(e) ? e : P)), i[2][3].add(r(0, t, f(n) ? n : N))
                        }).promise()
                    },
                    promise: function(t) {
                        return null != t ? x.extend(t, o) : o
                    }
                },
                s = {};
            return x.each(i, function(t, e) {
                var r = e[2],
                    a = e[5];
                o[e[1]] = r.add, a && r.add(function() {
                    n = a
                }, i[3 - t][2].disable, i[3 - t][3].disable, i[0][2].lock, i[0][3].lock), r.add(e[3].fire), s[e[0]] = function() {
                    return s[e[0] + "With"](this === s ? void 0 : this, arguments), this
                }, s[e[0] + "With"] = r.fireWith
            }), o.promise(s), e && e.call(s, s), s
        },
        when: function(t) {
            var e = arguments.length,
                i = e,
                n = Array(i),
                s = o.call(arguments),
                r = x.Deferred(),
                a = function(t) {
                    return function(i) {
                        n[t] = this, s[t] = 1 < arguments.length ? o.call(arguments) : i, --e || r.resolveWith(n, s)
                    }
                };
            if (e <= 1 && (I(t, r.done(a(i)).resolve, r.reject, !e), "pending" === r.state() || f(s[i] && s[i].then))) return r.then();
            for (; i--;) I(s[i], a(i), r.reject);
            return r.promise()
        }
    });
    var q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    x.Deferred.exceptionHook = function(e, i) {
        t.console && t.console.warn && e && q.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, i)
    }, x.readyException = function(e) {
        t.setTimeout(function() {
            throw e
        })
    };
    var W = x.Deferred();

    function R() {
        v.removeEventListener("DOMContentLoaded", R), t.removeEventListener("load", R), x.ready()
    }
    x.fn.ready = function(t) {
        return W.then(t).catch(function(t) {
            x.readyException(t)
        }), this
    }, x.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(t) {
            (!0 === t ? --x.readyWait : x.isReady) || (x.isReady = !0) !== t && 0 < --x.readyWait || W.resolveWith(v, [x])
        }
    }), x.ready.then = W.then, "complete" !== v.readyState && ("loading" === v.readyState || v.documentElement.doScroll) ? (v.addEventListener("DOMContentLoaded", R), t.addEventListener("load", R)) : t.setTimeout(x.ready);
    var M = function(t, e, i, n, o, s, r) {
            var a = 0,
                l = t.length,
                c = null == i;
            if ("object" === $(i))
                for (a in o = !0, i) M(t, e, a, i[a], !0, s, r);
            else if (void 0 !== n && (o = !0, f(n) || (r = !0), c && (r ? (e.call(t, n), e = null) : (c = e, e = function(t, e, i) {
                    return c.call(x(t), i)
                })), e))
                for (; a < l; a++) e(t[a], i, r ? n : n.call(t[a], a, e(t[a], i)));
            return o ? t : c ? e.call(t) : l ? e(t[0], i) : s
        },
        B = /^-ms-/,
        F = /-([a-z])/g;

    function U(t, e) {
        return e.toUpperCase()
    }

    function X(t) {
        return t.replace(B, "ms-").replace(F, U)
    }
    var Y = function(t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
    };

    function G() {
        this.expando = x.expando + G.uid++
    }
    G.uid = 1, G.prototype = {
        cache: function(t) {
            var e = t[this.expando];
            return e || (e = {}, Y(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))), e
        },
        set: function(t, e, i) {
            var n, o = this.cache(t);
            if ("string" == typeof e) o[X(e)] = i;
            else
                for (n in e) o[X(n)] = e[n];
            return o
        },
        get: function(t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][X(e)]
        },
        access: function(t, e, i) {
            return void 0 === e || e && "string" == typeof e && void 0 === i ? this.get(t, e) : (this.set(t, e, i), void 0 !== i ? i : e)
        },
        remove: function(t, e) {
            var i, n = t[this.expando];
            if (void 0 !== n) {
                if (void 0 !== e)
                    for (i = (e = Array.isArray(e) ? e.map(X) : ((e = X(e)) in n) ? [e] : e.match(z) || []).length; i--;) delete n[e[i]];
                (void 0 === e || x.isEmptyObject(n)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var e = t[this.expando];
            return void 0 !== e && !x.isEmptyObject(e)
        }
    };
    var Q = new G,
        V = new G,
        K = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        J = /[A-Z]/g;

    function Z(t, e, i) {
        var n, o;
        if (void 0 === i && 1 === t.nodeType) {
            if (n = "data-" + e.replace(J, "-$&").toLowerCase(), "string" == typeof(i = t.getAttribute(n))) {
                try {
                    i = "true" === (o = i) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : K.test(o) ? JSON.parse(o) : o)
                } catch (s) {}
                V.set(t, e, i)
            } else i = void 0
        }
        return i
    }
    x.extend({
        hasData: function(t) {
            return V.hasData(t) || Q.hasData(t)
        },
        data: function(t, e, i) {
            return V.access(t, e, i)
        },
        removeData: function(t, e) {
            V.remove(t, e)
        },
        _data: function(t, e, i) {
            return Q.access(t, e, i)
        },
        _removeData: function(t, e) {
            Q.remove(t, e)
        }
    }), x.fn.extend({
        data: function(t, e) {
            var i, n, o, s = this[0],
                r = s && s.attributes;
            if (void 0 === t) {
                if (this.length && (o = V.get(s), 1 === s.nodeType && !Q.get(s, "hasDataAttrs"))) {
                    for (i = r.length; i--;) r[i] && 0 === (n = r[i].name).indexOf("data-") && Z(s, n = X(n.slice(5)), o[n]);
                    Q.set(s, "hasDataAttrs", !0)
                }
                return o
            }
            return "object" == typeof t ? this.each(function() {
                V.set(this, t)
            }) : M(this, function(e) {
                var i;
                if (s && void 0 === e) return void 0 !== (i = V.get(s, t)) ? i : void 0 !== (i = Z(s, t)) ? i : void 0;
                this.each(function() {
                    V.set(this, t, e)
                })
            }, null, e, 1 < arguments.length, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                V.remove(this, t)
            })
        }
    }), x.extend({
        queue: function(t, e, i) {
            var n;
            if (t) return e = (e || "fx") + "queue", n = Q.get(t, e), i && (!n || Array.isArray(i) ? n = Q.access(t, e, x.makeArray(i)) : n.push(i)), n || []
        },
        dequeue: function(t, e) {
            e = e || "fx";
            var i = x.queue(t, e),
                n = i.length,
                o = i.shift(),
                s = x._queueHooks(t, e);
            "inprogress" === o && (o = i.shift(), n--), o && ("fx" === e && i.unshift("inprogress"), delete s.stop, o.call(t, function() {
                x.dequeue(t, e)
            }, s)), !n && s && s.empty.fire()
        },
        _queueHooks: function(t, e) {
            var i = e + "queueHooks";
            return Q.get(t, i) || Q.access(t, i, {
                empty: x.Callbacks("once memory").add(function() {
                    Q.remove(t, [e + "queue", i])
                })
            })
        }
    }), x.fn.extend({
        queue: function(t, e) {
            var i = 2;
            return "string" != typeof t && (e = t, t = "fx", i--), arguments.length < i ? x.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                var i = x.queue(this, t, e);
                x._queueHooks(this, t), "fx" === t && "inprogress" !== i[0] && x.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                x.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, e) {
            var i, n = 1,
                o = x.Deferred(),
                s = this,
                r = this.length,
                a = function() {
                    --n || o.resolveWith(s, [s])
                };
            for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; r--;)(i = Q.get(s[r], t + "queueHooks")) && i.empty && (n++, i.empty.add(a));
            return a(), o.promise(e)
        }
    });
    var tt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = RegExp("^(?:([+-])=|)(" + tt + ")([a-z%]*)$", "i"),
        ti = ["Top", "Right", "Bottom", "Left"],
        tn = v.documentElement,
        to = function(t) {
            return x.contains(t.ownerDocument, t)
        },
        ts = {
            composed: !0
        };
    tn.getRootNode && (to = function(t) {
        return x.contains(t.ownerDocument, t) || t.getRootNode(ts) === t.ownerDocument
    });
    var tr = function(t, e) {
        return "none" === (t = e || t).style.display || "" === t.style.display && to(t) && "none" === x.css(t, "display")
    };

    function ta(t, e, i, n) {
        var o, s, r = 20,
            a = n ? function() {
                return n.cur()
            } : function() {
                return x.css(t, e, "")
            },
            l = a(),
            c = i && i[3] || (x.cssNumber[e] ? "" : "px"),
            u = t.nodeType && (x.cssNumber[e] || "px" !== c && +l) && te.exec(x.css(t, e));
        if (u && u[3] !== c) {
            for (l /= 2, c = c || u[3], u = +l || 1; r--;) x.style(t, e, u + c), (1 - s) * (1 - (s = a() / l || .5)) <= 0 && (r = 0), u /= s;
            u *= 2, x.style(t, e, u + c), i = i || []
        }
        return i && (u = +u || +l || 0, o = i[1] ? u + (i[1] + 1) * i[2] : +i[2], n && (n.unit = c, n.start = u, n.end = o)), o
    }
    var tl = {};

    function tc(t, e) {
        for (var i, n, o, s, r, a, l, c = [], u = 0, d = t.length; u < d; u++)(n = t[u]).style && (i = n.style.display, e ? ("none" === i && (c[u] = Q.get(n, "display") || null, c[u] || (n.style.display = "")), "" === n.style.display && tr(n) && (c[u] = (l = r = s = void 0, r = (o = n).ownerDocument, (l = tl[a = o.nodeName]) || (s = r.body.appendChild(r.createElement(a)), l = x.css(s, "display"), s.parentNode.removeChild(s), "none" === l && (l = "block"), tl[a] = l)))) : "none" !== i && (c[u] = "none", Q.set(n, "display", i)));
        for (u = 0; u < d; u++) null != c[u] && (t[u].style.display = c[u]);
        return t
    }
    x.fn.extend({
        show: function() {
            return tc(this, !0)
        },
        hide: function() {
            return tc(this)
        },
        toggle: function(t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                tr(this) ? x(this).show() : x(this).hide()
            })
        }
    });
    var tu, td, tp = /^(?:checkbox|radio)$/i,
        th = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        tf = /^$|^module$|\/(?:java|ecma)script/i;
    tu = v.createDocumentFragment().appendChild(v.createElement("div")), (td = v.createElement("input")).setAttribute("type", "radio"), td.setAttribute("checked", "checked"), td.setAttribute("name", "t"), tu.appendChild(td), h.checkClone = tu.cloneNode(!0).cloneNode(!0).lastChild.checked, tu.innerHTML = "<textarea>x</textarea>", h.noCloneChecked = !!tu.cloneNode(!0).lastChild.defaultValue, tu.innerHTML = "<option></option>", h.option = !!tu.lastChild;
    var tg = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };

    function tv(t, e) {
        var i;
        return i = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [], void 0 === e || e && C(t, e) ? x.merge([t], i) : i
    }

    function tm(t, e) {
        for (var i = 0, n = t.length; i < n; i++) Q.set(t[i], "globalEval", !e || Q.get(e[i], "globalEval"))
    }
    tg.tbody = tg.tfoot = tg.colgroup = tg.caption = tg.thead, tg.th = tg.td, h.option || (tg.optgroup = tg.option = [1, "<select multiple='multiple'>", "</select>"]);
    var ty = /<|&#?\w+;/;

    function t$(t, e, i, n, o) {
        for (var s, r, a, l, c, u, d = e.createDocumentFragment(), p = [], h = 0, f = t.length; h < f; h++)
            if ((s = t[h]) || 0 === s) {
                if ("object" === $(s)) x.merge(p, s.nodeType ? [s] : s);
                else if (ty.test(s)) {
                    for (r = r || d.appendChild(e.createElement("div")), l = tg[a = (th.exec(s) || ["", ""])[1].toLowerCase()] || tg._default, r.innerHTML = l[1] + x.htmlPrefilter(s) + l[2], u = l[0]; u--;) r = r.lastChild;
                    x.merge(p, r.childNodes), (r = d.firstChild).textContent = ""
                } else p.push(e.createTextNode(s))
            }
        for (d.textContent = "", h = 0; s = p[h++];)
            if (n && -1 < x.inArray(s, n)) o && o.push(s);
            else if (c = to(s), r = tv(d.appendChild(s), "script"), c && tm(r), i)
            for (u = 0; s = r[u++];) tf.test(s.type || "") && i.push(s);
        return d
    }
    var tb = /^([^.]*)(?:\.(.+)|)/;

    function tx() {
        return !0
    }

    function tT() {
        return !1
    }

    function t_(t, e) {
        return t === function() {
            try {
                return v.activeElement
            } catch (t) {}
        }() == ("focus" === e)
    }

    function tw(t, e, i, n, o, s) {
        var r, a;
        if ("object" == typeof e) {
            for (a in "string" != typeof i && (n = n || i, i = void 0), e) tw(t, a, i, n, e[a], s);
            return t
        }
        if (null == n && null == o ? (o = i, n = i = void 0) : null == o && ("string" == typeof i ? (o = n, n = void 0) : (o = n, n = i, i = void 0)), !1 === o) o = tT;
        else if (!o) return t;
        return 1 === s && (r = o, (o = function(t) {
            return x().off(t), r.apply(this, arguments)
        }).guid = r.guid || (r.guid = x.guid++)), t.each(function() {
            x.event.add(this, e, o, n, i)
        })
    }

    function tk(t, e, i) {
        i ? (Q.set(t, e, !1), x.event.add(t, e, {
            namespace: !1,
            handler: function(t) {
                var n, s, r = Q.get(this, e);
                if (1 & t.isTrigger && this[e]) {
                    if (r.length)(x.event.special[e] || {}).delegateType && t.stopPropagation();
                    else if (r = o.call(arguments), Q.set(this, e, r), n = i(this, e), this[e](), r !== (s = Q.get(this, e)) || n ? Q.set(this, e, !1) : s = {}, r !== s) return t.stopImmediatePropagation(), t.preventDefault(), s && s.value
                } else r.length && (Q.set(this, e, {
                    value: x.event.trigger(x.extend(r[0], x.Event.prototype), r.slice(1), this)
                }), t.stopImmediatePropagation())
            }
        })) : void 0 === Q.get(t, e) && x.event.add(t, e, tx)
    }
    x.event = {
        global: {},
        add: function(t, e, i, n, o) {
            var s, r, a, l, c, u, d, p, h, f, g, v = Q.get(t);
            if (Y(t))
                for (i.handler && (i = (s = i).handler, o = s.selector), o && x.find.matchesSelector(tn, o), i.guid || (i.guid = x.guid++), (l = v.events) || (l = v.events = Object.create(null)), (r = v.handle) || (r = v.handle = function(e) {
                        return x.event.triggered !== e.type ? x.event.dispatch.apply(t, arguments) : void 0
                    }), c = (e = (e || "").match(z) || [""]).length; c--;) h = g = (a = tb.exec(e[c]) || [])[1], f = (a[2] || "").split(".").sort(), h && (d = x.event.special[h] || {}, h = (o ? d.delegateType : d.bindType) || h, d = x.event.special[h] || {}, u = x.extend({
                    type: h,
                    origType: g,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: o,
                    needsContext: o && x.expr.match.needsContext.test(o),
                    namespace: f.join(".")
                }, s), (p = l[h]) || ((p = l[h] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(t, n, f, r) || t.addEventListener && t.addEventListener(h, r)), d.add && (d.add.call(t, u), u.handler.guid || (u.handler.guid = i.guid)), o ? p.splice(p.delegateCount++, 0, u) : p.push(u), x.event.global[h] = !0)
        },
        remove: function(t, e, i, n, o) {
            var s, r, a, l, c, u, d, p, h, f, g, v = Q.hasData(t) && Q.get(t);
            if (v && (l = v.events)) {
                for (c = (e = (e || "").match(z) || [""]).length; c--;)
                    if (h = g = (a = tb.exec(e[c]) || [])[1], f = (a[2] || "").split(".").sort(), h) {
                        for (d = x.event.special[h] || {}, p = l[h = (n ? d.delegateType : d.bindType) || h] || [], a = a[2] && RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = s = p.length; s--;) u = p[s], !o && g !== u.origType || i && i.guid !== u.guid || a && !a.test(u.namespace) || n && n !== u.selector && ("**" !== n || !u.selector) || (p.splice(s, 1), u.selector && p.delegateCount--, d.remove && d.remove.call(t, u));
                        r && !p.length && (d.teardown && !1 !== d.teardown.call(t, f, v.handle) || x.removeEvent(t, h, v.handle), delete l[h])
                    } else
                        for (h in l) x.event.remove(t, h + e[c], i, n, !0);
                x.isEmptyObject(l) && Q.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            var e, i, n, o, s, r, a = Array(arguments.length),
                l = x.event.fix(t),
                c = (Q.get(this, "events") || Object.create(null))[l.type] || [],
                u = x.event.special[l.type] || {};
            for (a[0] = l, e = 1; e < arguments.length; e++) a[e] = arguments[e];
            if (l.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, l)) {
                for (r = x.event.handlers.call(this, l, c), e = 0;
                    (o = r[e++]) && !l.isPropagationStopped();)
                    for (l.currentTarget = o.elem, i = 0;
                        (s = o.handlers[i++]) && !l.isImmediatePropagationStopped();) l.rnamespace && !1 !== s.namespace && !l.rnamespace.test(s.namespace) || (l.handleObj = s, l.data = s.data, void 0 !== (n = ((x.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, a)) && !1 === (l.result = n) && (l.preventDefault(), l.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, l), l.result
            }
        },
        handlers: function(t, e) {
            var i, n, o, s, r, a = [],
                l = e.delegateCount,
                c = t.target;
            if (l && c.nodeType && !("click" === t.type && 1 <= t.button)) {
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== t.type || !0 !== c.disabled)) {
                        for (s = [], r = {}, i = 0; i < l; i++) void 0 === r[o = (n = e[i]).selector + " "] && (r[o] = n.needsContext ? -1 < x(o, this).index(c) : x.find(o, this, null, [c]).length), r[o] && s.push(n);
                        s.length && a.push({
                            elem: c,
                            handlers: s
                        })
                    }
            }
            return c = this, l < e.length && a.push({
                elem: c,
                handlers: e.slice(l)
            }), a
        },
        addProp: function(t, e) {
            Object.defineProperty(x.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: f(e) ? function() {
                    if (this.originalEvent) return e(this.originalEvent)
                } : function() {
                    if (this.originalEvent) return this.originalEvent[t]
                },
                set: function(e) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: e
                    })
                }
            })
        },
        fix: function(t) {
            return t[x.expando] ? t : new x.Event(t)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(t) {
                    var e = this || t;
                    return tp.test(e.type) && e.click && C(e, "input") && tk(e, "click", tx), !1
                },
                trigger: function(t) {
                    var e = this || t;
                    return tp.test(e.type) && e.click && C(e, "input") && tk(e, "click"), !0
                },
                _default: function(t) {
                    var e = t.target;
                    return tp.test(e.type) && e.click && C(e, "input") && Q.get(e, "click") || C(e, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    }, x.removeEvent = function(t, e, i) {
        t.removeEventListener && t.removeEventListener(e, i)
    }, x.Event = function(t, e) {
        if (!(this instanceof x.Event)) return new x.Event(t, e);
        t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? tx : tT, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && x.extend(this, e), this.timeStamp = t && t.timeStamp || Date.now(), this[x.expando] = !0
    }, x.Event.prototype = {
        constructor: x.Event,
        isDefaultPrevented: tT,
        isPropagationStopped: tT,
        isImmediatePropagationStopped: tT,
        isSimulated: !1,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = tx, t && !this.isSimulated && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = tx, t && !this.isSimulated && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = tx, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
        }
    }, x.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0
    }, x.event.addProp), x.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        x.event.special[t] = {
            setup: function() {
                return tk(this, t, t_), !1
            },
            trigger: function() {
                return tk(this, t), !0
            },
            _default: function() {
                return !0
            },
            delegateType: e
        }
    }), x.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(t, e) {
        x.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function(t) {
                var i, n = t.relatedTarget,
                    o = t.handleObj;
                return n && (n === this || x.contains(this, n)) || (t.type = o.origType, i = o.handler.apply(this, arguments), t.type = e), i
            }
        }
    }), x.fn.extend({
        on: function(t, e, i, n) {
            return tw(this, t, e, i, n)
        },
        one: function(t, e, i, n) {
            return tw(this, t, e, i, n, 1)
        },
        off: function(t, e, i) {
            var n, o;
            if (t && t.preventDefault && t.handleObj) return n = t.handleObj, x(t.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
            if ("object" == typeof t) {
                for (o in t) this.off(o, e, t[o]);
                return this
            }
            return !1 !== e && "function" != typeof e || (i = e, e = void 0), !1 === i && (i = tT), this.each(function() {
                x.event.remove(this, t, i, e)
            })
        }
    });
    var tS = /<script|<style|<link/i,
        tC = /checked\s*(?:[^=]|=\s*.checked.)/i,
        t9 = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function tE(t, e) {
        return C(t, "table") && C(11 !== e.nodeType ? e : e.firstChild, "tr") && x(t).children("tbody")[0] || t
    }

    function tA(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
    }

    function tL(t) {
        return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"), t
    }

    function tj(t, e) {
        var i, n, o, s, r, a;
        if (1 === e.nodeType) {
            if (Q.hasData(t) && (a = Q.get(t).events))
                for (o in Q.remove(e, "handle events"), a)
                    for (i = 0, n = a[o].length; i < n; i++) x.event.add(e, o, a[o][i]);
            V.hasData(t) && (s = V.access(t), r = x.extend({}, s), V.set(e, r))
        }
    }

    function tD(t, e, i, n) {
        e = s(e);
        var o, r, a, l, c, u, d = 0,
            p = t.length,
            g = p - 1,
            v = e[0],
            m = f(v);
        if (m || 1 < p && "string" == typeof v && !h.checkClone && tC.test(v)) return t.each(function(o) {
            var s = t.eq(o);
            m && (e[0] = v.call(this, o, s.html())), tD(s, e, i, n)
        });
        if (p && (r = (o = t$(e, t[0].ownerDocument, !1, t, n)).firstChild, 1 === o.childNodes.length && (o = r), r || n)) {
            for (l = (a = x.map(tv(o, "script"), tA)).length; d < p; d++) c = o, d !== g && (c = x.clone(c, !0, !0), l && x.merge(a, tv(c, "script"))), i.call(t[d], c, d);
            if (l)
                for (u = a[a.length - 1].ownerDocument, x.map(a, tL), d = 0; d < l; d++) c = a[d], tf.test(c.type || "") && !Q.access(c, "globalEval") && x.contains(u, c) && (c.src && "module" !== (c.type || "").toLowerCase() ? x._evalUrl && !c.noModule && x._evalUrl(c.src, {
                    nonce: c.nonce || c.getAttribute("nonce")
                }, u) : y(c.textContent.replace(t9, ""), c, u))
        }
        return t
    }

    function tO(t, e, i) {
        for (var n, o = e ? x.filter(e, t) : t, s = 0; null != (n = o[s]); s++) i || 1 !== n.nodeType || x.cleanData(tv(n)), n.parentNode && (i && to(n) && tm(tv(n, "script")), n.parentNode.removeChild(n));
        return t
    }
    x.extend({
        htmlPrefilter: function(t) {
            return t
        },
        clone: function(t, e, i) {
            var n, o, s, r, a, l, c, u = t.cloneNode(!0),
                d = to(t);
            if (!(h.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || x.isXMLDoc(t)))
                for (r = tv(u), n = 0, o = (s = tv(t)).length; n < o; n++) a = s[n], "input" === (c = (l = r[n]).nodeName.toLowerCase()) && tp.test(a.type) ? l.checked = a.checked : "input" !== c && "textarea" !== c || (l.defaultValue = a.defaultValue);
            if (e) {
                if (i)
                    for (s = s || tv(t), r = r || tv(u), n = 0, o = s.length; n < o; n++) tj(s[n], r[n]);
                else tj(t, u)
            }
            return 0 < (r = tv(u, "script")).length && tm(r, !d && tv(t, "script")), u
        },
        cleanData: function(t) {
            for (var e, i, n, o = x.event.special, s = 0; void 0 !== (i = t[s]); s++)
                if (Y(i)) {
                    if (e = i[Q.expando]) {
                        if (e.events)
                            for (n in e.events) o[n] ? x.event.remove(i, n) : x.removeEvent(i, n, e.handle);
                        i[Q.expando] = void 0
                    }
                    i[V.expando] && (i[V.expando] = void 0)
                }
        }
    }), x.fn.extend({
        detach: function(t) {
            return tO(this, t, !0)
        },
        remove: function(t) {
            return tO(this, t)
        },
        text: function(t) {
            return M(this, function(t) {
                return void 0 === t ? x.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return tD(this, arguments, function(t) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || tE(this, t).appendChild(t)
            })
        },
        prepend: function() {
            return tD(this, arguments, function(t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = tE(this, t);
                    e.insertBefore(t, e.firstChild)
                }
            })
        },
        before: function() {
            return tD(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return tD(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (x.cleanData(tv(t, !1)), t.textContent = "");
            return this
        },
        clone: function(t, e) {
            return t = null != t && t, e = null == e ? t : e, this.map(function() {
                return x.clone(this, t, e)
            })
        },
        html: function(t) {
            return M(this, function(t) {
                var e = this[0] || {},
                    i = 0,
                    n = this.length;
                if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                if ("string" == typeof t && !tS.test(t) && !tg[(th.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = x.htmlPrefilter(t);
                    try {
                        for (; i < n; i++) 1 === (e = this[i] || {}).nodeType && (x.cleanData(tv(e, !1)), e.innerHTML = t);
                        e = 0
                    } catch (o) {}
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return tD(this, arguments, function(e) {
                var i = this.parentNode;
                0 > x.inArray(this, t) && (x.cleanData(tv(this)), i && i.replaceChild(e, this))
            }, t)
        }
    }), x.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(t, e) {
        x.fn[t] = function(t) {
            for (var i, n = [], o = x(t), s = o.length - 1, a = 0; a <= s; a++) i = a === s ? this : this.clone(!0), x(o[a])[e](i), r.apply(n, i.get());
            return this.pushStack(n)
        }
    });
    var tH = RegExp("^(" + tt + ")(?!px)[a-z%]+$", "i"),
        tz = function(e) {
            var i = e.ownerDocument.defaultView;
            return i && i.opener || (i = t), i.getComputedStyle(e)
        },
        tP = function(t, e, i) {
            var n, o, s = {};
            for (o in e) s[o] = t.style[o], t.style[o] = e[o];
            for (o in n = i.call(t), e) t.style[o] = s[o];
            return n
        },
        tN = RegExp(ti.join("|"), "i");

    function tI(t, e, i) {
        var n, o, s, r, a = t.style;
        return (i = i || tz(t)) && ("" !== (r = i.getPropertyValue(e) || i[e]) || to(t) || (r = x.style(t, e)), !h.pixelBoxStyles() && tH.test(r) && tN.test(e) && (n = a.width, o = a.minWidth, s = a.maxWidth, a.minWidth = a.maxWidth = a.width = r, r = i.width, a.width = n, a.minWidth = o, a.maxWidth = s)), void 0 !== r ? r + "" : r
    }

    function tq(t, e) {
        return {
            get: function() {
                if (!t()) return (this.get = e).apply(this, arguments);
                delete this.get
            }
        }
    }! function() {
        function e() {
            if (u) {
                c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", tn.appendChild(c).appendChild(u);
                var e = t.getComputedStyle(u);
                n = "1%" !== e.top, l = 12 === i(e.marginLeft), u.style.right = "60%", r = 36 === i(e.right), o = 36 === i(e.width), u.style.position = "absolute", s = 12 === i(u.offsetWidth / 3), tn.removeChild(c), u = null
            }
        }

        function i(t) {
            return Math.round(parseFloat(t))
        }
        var n, o, s, r, a, l, c = v.createElement("div"),
            u = v.createElement("div");
        u.style && (u.style.backgroundClip = "content-box", u.cloneNode(!0).style.backgroundClip = "", h.clearCloneStyle = "content-box" === u.style.backgroundClip, x.extend(h, {
            boxSizingReliable: function() {
                return e(), o
            },
            pixelBoxStyles: function() {
                return e(), r
            },
            pixelPosition: function() {
                return e(), n
            },
            reliableMarginLeft: function() {
                return e(), l
            },
            scrollboxSize: function() {
                return e(), s
            },
            reliableTrDimensions: function() {
                var e, i, n, o;
                return null == a && (e = v.createElement("table"), i = v.createElement("tr"), n = v.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", i.style.cssText = "border:1px solid", i.style.height = "1px", n.style.height = "9px", n.style.display = "block", tn.appendChild(e).appendChild(i).appendChild(n), a = parseInt((o = t.getComputedStyle(i)).height, 10) + parseInt(o.borderTopWidth, 10) + parseInt(o.borderBottomWidth, 10) === i.offsetHeight, tn.removeChild(e)), a
            }
        }))
    }();
    var tW = ["Webkit", "Moz", "ms"],
        t8 = v.createElement("div").style,
        tR = {};

    function t0(t) {
        return x.cssProps[t] || tR[t] || (t in t8 ? t : tR[t] = function(t) {
            for (var e = t[0].toUpperCase() + t.slice(1), i = tW.length; i--;)
                if ((t = tW[i] + e) in t8) return t
        }(t) || t)
    }
    var tM = /^(none|table(?!-c[ea]).+)/,
        tB = /^--/,
        tF = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        t1 = {
            letterSpacing: "0",
            fontWeight: "400"
        };

    function tU(t, e, i) {
        var n = te.exec(e);
        return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e
    }

    function tX(t, e, i, n, o, s) {
        var r = "width" === e ? 1 : 0,
            a = 0,
            l = 0;
        if (i === (n ? "border" : "content")) return 0;
        for (; r < 4; r += 2) "margin" === i && (l += x.css(t, i + ti[r], !0, o)), n ? ("content" === i && (l -= x.css(t, "padding" + ti[r], !0, o)), "margin" !== i && (l -= x.css(t, "border" + ti[r] + "Width", !0, o))) : (l += x.css(t, "padding" + ti[r], !0, o), "padding" !== i ? l += x.css(t, "border" + ti[r] + "Width", !0, o) : a += x.css(t, "border" + ti[r] + "Width", !0, o));
        return !n && 0 <= s && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - s - l - a - .5)) || 0), l
    }

    function tY(t, e, i) {
        var n = tz(t),
            o = (!h.boxSizingReliable() || i) && "border-box" === x.css(t, "boxSizing", !1, n),
            s = o,
            r = tI(t, e, n),
            a = "offset" + e[0].toUpperCase() + e.slice(1);
        if (tH.test(r)) {
            if (!i) return r;
            r = "auto"
        }
        return (!h.boxSizingReliable() && o || !h.reliableTrDimensions() && C(t, "tr") || "auto" === r || !parseFloat(r) && "inline" === x.css(t, "display", !1, n)) && t.getClientRects().length && (o = "border-box" === x.css(t, "boxSizing", !1, n), (s = a in t) && (r = t[a])), (r = parseFloat(r) || 0) + tX(t, e, i || (o ? "border" : "content"), s, n, r) + "px"
    }

    function t3(t, e, i, n, o) {
        return new t3.prototype.init(t, e, i, n, o)
    }
    x.extend({
        cssHooks: {
            opacity: {
                get: function(t, e) {
                    if (e) {
                        var i = tI(t, "opacity");
                        return "" === i ? "1" : i
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(t, e, i, n) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var o, s, r, a = X(e),
                    l = tB.test(e),
                    c = t.style;
                if (l || (e = t0(a)), r = x.cssHooks[e] || x.cssHooks[a], void 0 === i) return r && "get" in r && void 0 !== (o = r.get(t, !1, n)) ? o : c[e];
                "string" == (s = typeof i) && (o = te.exec(i)) && o[1] && (i = ta(t, e, o), s = "number"), null != i && i == i && ("number" !== s || l || (i += o && o[3] || (x.cssNumber[a] ? "" : "px")), h.clearCloneStyle || "" !== i || 0 !== e.indexOf("background") || (c[e] = "inherit"), r && "set" in r && void 0 === (i = r.set(t, i, n)) || (l ? c.setProperty(e, i) : c[e] = i))
            }
        },
        css: function(t, e, i, n) {
            var o, s, r, a = X(e);
            return tB.test(e) || (e = t0(a)), (r = x.cssHooks[e] || x.cssHooks[a]) && "get" in r && (o = r.get(t, !0, i)), void 0 === o && (o = tI(t, e, n)), "normal" === o && e in t1 && (o = t1[e]), "" === i || i ? (s = parseFloat(o), !0 === i || isFinite(s) ? s || 0 : o) : o
        }
    }), x.each(["height", "width"], function(t, e) {
        x.cssHooks[e] = {
            get: function(t, i, n) {
                if (i) return !tM.test(x.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? tY(t, e, n) : tP(t, tF, function() {
                    return tY(t, e, n)
                })
            },
            set: function(t, i, n) {
                var o, s = tz(t),
                    r = !h.scrollboxSize() && "absolute" === s.position,
                    a = (r || n) && "border-box" === x.css(t, "boxSizing", !1, s),
                    l = n ? tX(t, e, n, a, s) : 0;
                return a && r && (l -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(s[e]) - tX(t, e, "border", !1, s) - .5)), l && (o = te.exec(i)) && "px" !== (o[3] || "px") && (t.style[e] = i, i = x.css(t, e)), tU(0, i, l)
            }
        }
    }), x.cssHooks.marginLeft = tq(h.reliableMarginLeft, function(t, e) {
        if (e) return (parseFloat(tI(t, "marginLeft")) || t.getBoundingClientRect().left - tP(t, {
            marginLeft: 0
        }, function() {
            return t.getBoundingClientRect().left
        })) + "px"
    }), x.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(t, e) {
        x.cssHooks[t + e] = {
            expand: function(i) {
                for (var n = 0, o = {}, s = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++) o[t + ti[n] + e] = s[n] || s[n - 2] || s[0];
                return o
            }
        }, "margin" !== t && (x.cssHooks[t + e].set = tU)
    }), x.fn.extend({
        css: function(t, e) {
            return M(this, function(t, e, i) {
                var n, o, s = {},
                    r = 0;
                if (Array.isArray(e)) {
                    for (n = tz(t), o = e.length; r < o; r++) s[e[r]] = x.css(t, e[r], !1, n);
                    return s
                }
                return void 0 !== i ? x.style(t, e, i) : x.css(t, e)
            }, t, e, 1 < arguments.length)
        }
    }), ((x.Tween = t3).prototype = {
        constructor: t3,
        init: function(t, e, i, n, o, s) {
            this.elem = t, this.prop = i, this.easing = o || x.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = n, this.unit = s || (x.cssNumber[i] ? "" : "px")
        },
        cur: function() {
            var t = t3.propHooks[this.prop];
            return t && t.get ? t.get(this) : t3.propHooks._default.get(this)
        },
        run: function(t) {
            var e, i = t3.propHooks[this.prop];
            return this.options.duration ? this.pos = e = x.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : t3.propHooks._default.set(this), this
        }
    }).init.prototype = t3.prototype, (t3.propHooks = {
        _default: {
            get: function(t) {
                var e;
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = x.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
            },
            set: function(t) {
                x.fx.step[t.prop] ? x.fx.step[t.prop](t) : 1 === t.elem.nodeType && (x.cssHooks[t.prop] || null != t.elem.style[t0(t.prop)]) ? x.style(t.elem, t.prop, t.now + t.unit) : t.elem[t.prop] = t.now
            }
        }
    }).scrollTop = t3.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    }, x.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    }, x.fx = t3.prototype.init, x.fx.step = {};
    var t2, t4, tG, tQ, tV = /^(?:toggle|show|hide)$/,
        t7 = /queueHooks$/;

    function t6() {
        return t.setTimeout(function() {
            t2 = void 0
        }), t2 = Date.now()
    }

    function t5(t, e) {
        var i, n = 0,
            o = {
                height: t
            };
        for (e = e ? 1 : 0; n < 4; n += 2 - e) o["margin" + (i = ti[n])] = o["padding" + i] = t;
        return e && (o.opacity = o.width = t), o
    }

    function tK(t, e, i) {
        for (var n, o = (tJ.tweeners[e] || []).concat(tJ.tweeners["*"]), s = 0, r = o.length; s < r; s++)
            if (n = o[s].call(i, e, t)) return n
    }

    function tJ(t, e, i) {
        var n, o, s = 0,
            r = tJ.prefilters.length,
            a = x.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (o) return !1;
                for (var e = t2 || t6(), i = Math.max(0, c.startTime + c.duration - e), n = 1 - (i / c.duration || 0), s = 0, r = c.tweens.length; s < r; s++) c.tweens[s].run(n);
                return a.notifyWith(t, [c, n, i]), n < 1 && r ? i : (r || a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c]), !1)
            },
            c = a.promise({
                elem: t,
                props: x.extend({}, e),
                opts: x.extend(!0, {
                    specialEasing: {},
                    easing: x.easing._default
                }, i),
                originalProperties: e,
                originalOptions: i,
                startTime: t2 || t6(),
                duration: i.duration,
                tweens: [],
                createTween: function(e, i) {
                    var n = x.Tween(t, c.opts, e, i, c.opts.specialEasing[e] || c.opts.easing);
                    return c.tweens.push(n), n
                },
                stop: function(e) {
                    var i = 0,
                        n = e ? c.tweens.length : 0;
                    if (o) return this;
                    for (o = !0; i < n; i++) c.tweens[i].run(1);
                    return e ? (a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c, e])) : a.rejectWith(t, [c, e]), this
                }
            }),
            u = c.props;
        for (function(t, e) {
                var i, n, o, s, r;
                for (i in t)
                    if (o = e[n = X(i)], Array.isArray(s = t[i]) && (o = s[1], s = t[i] = s[0]), i !== n && (t[n] = s, delete t[i]), (r = x.cssHooks[n]) && ("expand" in r))
                        for (i in s = r.expand(s), delete t[n], s)(i in t) || (t[i] = s[i], e[i] = o);
                    else e[n] = o
            }(u, c.opts.specialEasing); s < r; s++)
            if (n = tJ.prefilters[s].call(c, t, u, c.opts)) return f(n.stop) && (x._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)), n;
        return x.map(u, tK, c), f(c.opts.start) && c.opts.start.call(t, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), x.fx.timer(x.extend(l, {
            elem: t,
            anim: c,
            queue: c.opts.queue
        })), c
    }
    x.Animation = x.extend(tJ, {
        tweeners: {
            "*": [function(t, e) {
                var i = this.createTween(t, e);
                return ta(i.elem, t, te.exec(e), i), i
            }]
        },
        tweener: function(t, e) {
            f(t) ? (e = t, t = ["*"]) : t = t.match(z);
            for (var i, n = 0, o = t.length; n < o; n++) i = t[n], tJ.tweeners[i] = tJ.tweeners[i] || [], tJ.tweeners[i].unshift(e)
        },
        prefilters: [function(t, e, i) {
            var n, o, s, r, a, l, c, u, d = "width" in e || "height" in e,
                p = this,
                h = {},
                f = t.style,
                g = t.nodeType && tr(t),
                v = Q.get(t, "fxshow");
            for (n in i.queue || (null == (r = x._queueHooks(t, "fx")).unqueued && (r.unqueued = 0, a = r.empty.fire, r.empty.fire = function() {
                    r.unqueued || a()
                }), r.unqueued++, p.always(function() {
                    p.always(function() {
                        r.unqueued--, x.queue(t, "fx").length || r.empty.fire()
                    })
                })), e)
                if (o = e[n], tV.test(o)) {
                    if (delete e[n], s = s || "toggle" === o, o === (g ? "hide" : "show")) {
                        if ("show" !== o || !v || void 0 === v[n]) continue;
                        g = !0
                    }
                    h[n] = v && v[n] || x.style(t, n)
                }
            if ((l = !x.isEmptyObject(e)) || !x.isEmptyObject(h))
                for (n in d && 1 === t.nodeType && (i.overflow = [f.overflow, f.overflowX, f.overflowY], null == (c = v && v.display) && (c = Q.get(t, "display")), "none" === (u = x.css(t, "display")) && (c ? u = c : (tc([t], !0), c = t.style.display || c, u = x.css(t, "display"), tc([t]))), ("inline" === u || "inline-block" === u && null != c) && "none" === x.css(t, "float") && (l || (p.done(function() {
                        f.display = c
                    }), null == c && (c = "none" === (u = f.display) ? "" : u)), f.display = "inline-block")), i.overflow && (f.overflow = "hidden", p.always(function() {
                        f.overflow = i.overflow[0], f.overflowX = i.overflow[1], f.overflowY = i.overflow[2]
                    })), l = !1, h) l || (v ? "hidden" in v && (g = v.hidden) : v = Q.access(t, "fxshow", {
                    display: c
                }), s && (v.hidden = !g), g && tc([t], !0), p.done(function() {
                    for (n in g || tc([t]), Q.remove(t, "fxshow"), h) x.style(t, n, h[n])
                })), l = tK(g ? v[n] : 0, n, p), n in v || (v[n] = l.start, g && (l.end = l.start, l.start = 0))
        }],
        prefilter: function(t, e) {
            e ? tJ.prefilters.unshift(t) : tJ.prefilters.push(t)
        }
    }), x.speed = function(t, e, i) {
        var n = t && "object" == typeof t ? x.extend({}, t) : {
            complete: i || !i && e || f(t) && t,
            duration: t,
            easing: i && e || e && !f(e) && e
        };
        return x.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in x.fx.speeds ? n.duration = x.fx.speeds[n.duration] : n.duration = x.fx.speeds._default), null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function() {
            f(n.old) && n.old.call(this), n.queue && x.dequeue(this, n.queue)
        }, n
    }, x.fn.extend({
        fadeTo: function(t, e, i, n) {
            return this.filter(tr).css("opacity", 0).show().end().animate({
                opacity: e
            }, t, i, n)
        },
        animate: function(t, e, i, n) {
            var o = x.isEmptyObject(t),
                s = x.speed(e, i, n),
                r = function() {
                    var e = tJ(this, x.extend({}, t), s);
                    (o || Q.get(this, "finish")) && e.stop(!0)
                };
            return r.finish = r, o || !1 === s.queue ? this.each(r) : this.queue(s.queue, r)
        },
        stop: function(t, e, i) {
            var n = function(t) {
                var e = t.stop;
                delete t.stop, e(i)
            };
            return "string" != typeof t && (i = e, e = t, t = void 0), e && this.queue(t || "fx", []), this.each(function() {
                var e = !0,
                    o = null != t && t + "queueHooks",
                    s = x.timers,
                    r = Q.get(this);
                if (o) r[o] && r[o].stop && n(r[o]);
                else
                    for (o in r) r[o] && r[o].stop && t7.test(o) && n(r[o]);
                for (o = s.length; o--;) s[o].elem !== this || null != t && s[o].queue !== t || (s[o].anim.stop(i), e = !1, s.splice(o, 1));
                !e && i || x.dequeue(this, t)
            })
        },
        finish: function(t) {
            return !1 !== t && (t = t || "fx"), this.each(function() {
                var e, i = Q.get(this),
                    n = i[t + "queue"],
                    o = i[t + "queueHooks"],
                    s = x.timers,
                    r = n ? n.length : 0;
                for (i.finish = !0, x.queue(this, t, []), o && o.stop && o.stop.call(this, !0), e = s.length; e--;) s[e].elem === this && s[e].queue === t && (s[e].anim.stop(!0), s.splice(e, 1));
                for (e = 0; e < r; e++) n[e] && n[e].finish && n[e].finish.call(this);
                delete i.finish
            })
        }
    }), x.each(["toggle", "show", "hide"], function(t, e) {
        var i = x.fn[e];
        x.fn[e] = function(t, n, o) {
            return null == t || "boolean" == typeof t ? i.apply(this, arguments) : this.animate(t5(e, !0), t, n, o)
        }
    }), x.each({
        slideDown: t5("show"),
        slideUp: t5("hide"),
        slideToggle: t5("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(t, e) {
        x.fn[t] = function(t, i, n) {
            return this.animate(e, t, i, n)
        }
    }), x.timers = [], x.fx.tick = function() {
        var t, e = 0,
            i = x.timers;
        for (t2 = Date.now(); e < i.length; e++)(t = i[e])() || i[e] !== t || i.splice(e--, 1);
        i.length || x.fx.stop(), t2 = void 0
    }, x.fx.timer = function(t) {
        x.timers.push(t), x.fx.start()
    }, x.fx.interval = 13, x.fx.start = function() {
        t4 || (t4 = !0, function e() {
            t4 && (!1 === v.hidden && t.requestAnimationFrame ? t.requestAnimationFrame(e) : t.setTimeout(e, x.fx.interval), x.fx.tick())
        }())
    }, x.fx.stop = function() {
        t4 = null
    }, x.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, x.fn.delay = function(e, i) {
        return e = x.fx && x.fx.speeds[e] || e, i = i || "fx", this.queue(i, function(i, n) {
            var o = t.setTimeout(i, e);
            n.stop = function() {
                t.clearTimeout(o)
            }
        })
    }, tG = v.createElement("input"), tQ = v.createElement("select").appendChild(v.createElement("option")), tG.type = "checkbox", h.checkOn = "" !== tG.value, h.optSelected = tQ.selected, (tG = v.createElement("input")).value = "t", tG.type = "radio", h.radioValue = "t" === tG.value;
    var tZ, et = x.expr.attrHandle;
    x.fn.extend({
        attr: function(t, e) {
            return M(this, x.attr, t, e, 1 < arguments.length)
        },
        removeAttr: function(t) {
            return this.each(function() {
                x.removeAttr(this, t)
            })
        }
    }), x.extend({
        attr: function(t, e, i) {
            var n, o, s = t.nodeType;
            if (3 !== s && 8 !== s && 2 !== s) return void 0 === t.getAttribute ? x.prop(t, e, i) : (1 === s && x.isXMLDoc(t) || (o = x.attrHooks[e.toLowerCase()] || (x.expr.match.bool.test(e) ? tZ : void 0)), void 0 !== i ? null === i ? void x.removeAttr(t, e) : o && "set" in o && void 0 !== (n = o.set(t, i, e)) ? n : (t.setAttribute(e, i + ""), i) : o && "get" in o && null !== (n = o.get(t, e)) ? n : null == (n = x.find.attr(t, e)) ? void 0 : n)
        },
        attrHooks: {
            type: {
                set: function(t, e) {
                    if (!h.radioValue && "radio" === e && C(t, "input")) {
                        var i = t.value;
                        return t.setAttribute("type", e), i && (t.value = i), e
                    }
                }
            }
        },
        removeAttr: function(t, e) {
            var i, n = 0,
                o = e && e.match(z);
            if (o && 1 === t.nodeType)
                for (; i = o[n++];) t.removeAttribute(i)
        }
    }), tZ = {
        set: function(t, e, i) {
            return !1 === e ? x.removeAttr(t, i) : t.setAttribute(i, i), i
        }
    }, x.each(x.expr.match.bool.source.match(/\w+/g), function(t, e) {
        var i = et[e] || x.find.attr;
        et[e] = function(t, e, n) {
            var o, s, r = e.toLowerCase();
            return n || (s = et[r], et[r] = o, o = null != i(t, e, n) ? r : null, et[r] = s), o
        }
    });
    var ee = /^(?:input|select|textarea|button)$/i,
        ei = /^(?:a|area)$/i;

    function en(t) {
        return (t.match(z) || []).join(" ")
    }

    function eo(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }

    function es(t) {
        return Array.isArray(t) ? t : "string" == typeof t && t.match(z) || []
    }
    x.fn.extend({
        prop: function(t, e) {
            return M(this, x.prop, t, e, 1 < arguments.length)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[x.propFix[t] || t]
            })
        }
    }), x.extend({
        prop: function(t, e, i) {
            var n, o, s = t.nodeType;
            if (3 !== s && 8 !== s && 2 !== s) return 1 === s && x.isXMLDoc(t) || (e = x.propFix[e] || e, o = x.propHooks[e]), void 0 !== i ? o && "set" in o && void 0 !== (n = o.set(t, i, e)) ? n : t[e] = i : o && "get" in o && null !== (n = o.get(t, e)) ? n : t[e]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var e = x.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : ee.test(t.nodeName) || ei.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), h.optSelected || (x.propHooks.selected = {
        get: function(t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex, null
        },
        set: function(t) {
            var e = t.parentNode;
            e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
        }
    }), x.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        x.propFix[this.toLowerCase()] = this
    }), x.fn.extend({
        addClass: function(t) {
            var e, i, n, o, s, r, a, l = 0;
            if (f(t)) return this.each(function(e) {
                x(this).addClass(t.call(this, e, eo(this)))
            });
            if ((e = es(t)).length) {
                for (; i = this[l++];)
                    if (o = eo(i), n = 1 === i.nodeType && " " + en(o) + " ") {
                        for (r = 0; s = e[r++];) 0 > n.indexOf(" " + s + " ") && (n += s + " ");
                        o !== (a = en(n)) && i.setAttribute("class", a)
                    }
            }
            return this
        },
        removeClass: function(t) {
            var e, i, n, o, s, r, a, l = 0;
            if (f(t)) return this.each(function(e) {
                x(this).removeClass(t.call(this, e, eo(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ((e = es(t)).length) {
                for (; i = this[l++];)
                    if (o = eo(i), n = 1 === i.nodeType && " " + en(o) + " ") {
                        for (r = 0; s = e[r++];)
                            for (; - 1 < n.indexOf(" " + s + " ");) n = n.replace(" " + s + " ", " ");
                        o !== (a = en(n)) && i.setAttribute("class", a)
                    }
            }
            return this
        },
        toggleClass: function(t, e) {
            var i = typeof t,
                n = "string" === i || Array.isArray(t);
            return "boolean" == typeof e && n ? e ? this.addClass(t) : this.removeClass(t) : f(t) ? this.each(function(i) {
                x(this).toggleClass(t.call(this, i, eo(this), e), e)
            }) : this.each(function() {
                var e, o, s, r;
                if (n)
                    for (o = 0, s = x(this), r = es(t); e = r[o++];) s.hasClass(e) ? s.removeClass(e) : s.addClass(e);
                else void 0 !== t && "boolean" !== i || ((e = eo(this)) && Q.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : Q.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var e, i, n = 0;
            for (e = " " + t + " "; i = this[n++];)
                if (1 === i.nodeType && -1 < (" " + en(eo(i)) + " ").indexOf(e)) return !0;
            return !1
        }
    });
    var er = /\r/g;
    x.fn.extend({
        val: function(t) {
            var e, i, n, o = this[0];
            return arguments.length ? (n = f(t), this.each(function(i) {
                var o;
                1 === this.nodeType && (null == (o = n ? t.call(this, i, x(this).val()) : t) ? o = "" : "number" == typeof o ? o += "" : Array.isArray(o) && (o = x.map(o, function(t) {
                    return null == t ? "" : t + ""
                })), (e = x.valHooks[this.type] || x.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, o, "value") || (this.value = o))
            })) : o ? (e = x.valHooks[o.type] || x.valHooks[o.nodeName.toLowerCase()]) && "get" in e && void 0 !== (i = e.get(o, "value")) ? i : "string" == typeof(i = o.value) ? i.replace(er, "") : null == i ? "" : i : void 0
        }
    }), x.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var e = x.find.attr(t, "value");
                    return null != e ? e : en(x.text(t))
                }
            },
            select: {
                get: function(t) {
                    var e, i, n, o = t.options,
                        s = t.selectedIndex,
                        r = "select-one" === t.type,
                        a = r ? null : [],
                        l = r ? s + 1 : o.length;
                    for (n = s < 0 ? l : r ? s : 0; n < l; n++)
                        if (((i = o[n]).selected || n === s) && !i.disabled && (!i.parentNode.disabled || !C(i.parentNode, "optgroup"))) {
                            if (e = x(i).val(), r) return e;
                            a.push(e)
                        }
                    return a
                },
                set: function(t, e) {
                    for (var i, n, o = t.options, s = x.makeArray(e), r = o.length; r--;)((n = o[r]).selected = -1 < x.inArray(x.valHooks.option.get(n), s)) && (i = !0);
                    return i || (t.selectedIndex = -1), s
                }
            }
        }
    }), x.each(["radio", "checkbox"], function() {
        x.valHooks[this] = {
            set: function(t, e) {
                if (Array.isArray(e)) return t.checked = -1 < x.inArray(x(t).val(), e)
            }
        }, h.checkOn || (x.valHooks[this].get = function(t) {
            return null === t.getAttribute("value") ? "on" : t.value
        })
    }), h.focusin = "onfocusin" in t;
    var ea = /^(?:focusinfocus|focusoutblur)$/,
        el = function(t) {
            t.stopPropagation()
        };
    x.extend(x.event, {
        trigger: function(e, i, n, o) {
            var s, r, a, l, c, d, p, h, m = [n || v],
                y = u.call(e, "type") ? e.type : e,
                $ = u.call(e, "namespace") ? e.namespace.split(".") : [];
            if (r = h = a = n = n || v, 3 !== n.nodeType && 8 !== n.nodeType && !ea.test(y + x.event.triggered) && (-1 < y.indexOf(".") && (y = ($ = y.split(".")).shift(), $.sort()), c = 0 > y.indexOf(":") && "on" + y, (e = e[x.expando] ? e : new x.Event(y, "object" == typeof e && e)).isTrigger = o ? 2 : 3, e.namespace = $.join("."), e.rnamespace = e.namespace ? RegExp("(^|\\.)" + $.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), i = null == i ? [e] : x.makeArray(i, [e]), p = x.event.special[y] || {}, o || !p.trigger || !1 !== p.trigger.apply(n, i))) {
                if (!o && !p.noBubble && !g(n)) {
                    for (l = p.delegateType || y, ea.test(l + y) || (r = r.parentNode); r; r = r.parentNode) m.push(r), a = r;
                    a === (n.ownerDocument || v) && m.push(a.defaultView || a.parentWindow || t)
                }
                for (s = 0;
                    (r = m[s++]) && !e.isPropagationStopped();) h = r, e.type = 1 < s ? l : p.bindType || y, (d = (Q.get(r, "events") || Object.create(null))[e.type] && Q.get(r, "handle")) && d.apply(r, i), (d = c && r[c]) && d.apply && Y(r) && (e.result = d.apply(r, i), !1 === e.result && e.preventDefault());
                return e.type = y, o || e.isDefaultPrevented() || p._default && !1 !== p._default.apply(m.pop(), i) || !Y(n) || c && f(n[y]) && !g(n) && ((a = n[c]) && (n[c] = null), x.event.triggered = y, e.isPropagationStopped() && h.addEventListener(y, el), n[y](), e.isPropagationStopped() && h.removeEventListener(y, el), x.event.triggered = void 0, a && (n[c] = a)), e.result
            }
        },
        simulate: function(t, e, i) {
            var n = x.extend(new x.Event, i, {
                type: t,
                isSimulated: !0
            });
            x.event.trigger(n, null, e)
        }
    }), x.fn.extend({
        trigger: function(t, e) {
            return this.each(function() {
                x.event.trigger(t, e, this)
            })
        },
        triggerHandler: function(t, e) {
            var i = this[0];
            if (i) return x.event.trigger(t, e, i, !0)
        }
    }), h.focusin || x.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        var i = function(t) {
            x.event.simulate(e, t.target, x.event.fix(t))
        };
        x.event.special[e] = {
            setup: function() {
                var n = this.ownerDocument || this.document || this,
                    o = Q.access(n, e);
                o || n.addEventListener(t, i, !0), Q.access(n, e, (o || 0) + 1)
            },
            teardown: function() {
                var n = this.ownerDocument || this.document || this,
                    o = Q.access(n, e) - 1;
                o ? Q.access(n, e, o) : (n.removeEventListener(t, i, !0), Q.remove(n, e))
            }
        }
    });
    var ec = t.location,
        eu = {
            guid: Date.now()
        },
        ed = /\?/;
    x.parseXML = function(e) {
        var i, n;
        if (!e || "string" != typeof e) return null;
        try {
            i = (new t.DOMParser).parseFromString(e, "text/xml")
        } catch (o) {}
        return n = i && i.getElementsByTagName("parsererror")[0], i && !n || x.error("Invalid XML: " + (n ? x.map(n.childNodes, function(t) {
            return t.textContent
        }).join("\n") : e)), i
    };
    var ep = /\[\]$/,
        eh = /\r?\n/g,
        ef = /^(?:submit|button|image|reset|file)$/i,
        eg = /^(?:input|select|textarea|keygen)/i;

    function ev(t, e, i, n) {
        var o;
        if (Array.isArray(e)) x.each(e, function(e, o) {
            i || ep.test(t) ? n(t, o) : ev(t + "[" + ("object" == typeof o && null != o ? e : "") + "]", o, i, n)
        });
        else if (i || "object" !== $(e)) n(t, e);
        else
            for (o in e) ev(t + "[" + o + "]", e[o], i, n)
    }
    x.param = function(t, e) {
        var i, n = [],
            o = function(t, e) {
                var i = f(e) ? e() : e;
                n[n.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == i ? "" : i)
            };
        if (null == t) return "";
        if (Array.isArray(t) || t.jquery && !x.isPlainObject(t)) x.each(t, function() {
            o(this.name, this.value)
        });
        else
            for (i in t) ev(i, t[i], e, o);
        return n.join("&")
    }, x.fn.extend({
        serialize: function() {
            return x.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = x.prop(this, "elements");
                return t ? x.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !x(this).is(":disabled") && eg.test(this.nodeName) && !ef.test(t) && (this.checked || !tp.test(t))
            }).map(function(t, e) {
                var i = x(this).val();
                return null == i ? null : Array.isArray(i) ? x.map(i, function(t) {
                    return {
                        name: e.name,
                        value: t.replace(eh, "\r\n")
                    }
                }) : {
                    name: e.name,
                    value: i.replace(eh, "\r\n")
                }
            }).get()
        }
    });
    var em = /%20/g,
        ey = /#.*$/,
        e$ = /([?&])_=[^&]*/,
        eb = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        ex = /^(?:GET|HEAD)$/,
        eT = /^\/\//,
        e_ = {},
        ew = {},
        ek = "*/".concat("*"),
        eS = v.createElement("a");

    function eC(t) {
        return function(e, i) {
            "string" != typeof e && (i = e, e = "*");
            var n, o = 0,
                s = e.toLowerCase().match(z) || [];
            if (f(i))
                for (; n = s[o++];) "+" === n[0] ? (t[n = n.slice(1) || "*"] = t[n] || []).unshift(i) : (t[n] = t[n] || []).push(i)
        }
    }

    function e9(t, e, i, n) {
        var o = {},
            s = t === ew;

        function r(a) {
            var l;
            return o[a] = !0, x.each(t[a] || [], function(t, a) {
                var c = a(e, i, n);
                return "string" != typeof c || s || o[c] ? s ? !(l = c) : void 0 : (e.dataTypes.unshift(c), r(c), !1)
            }), l
        }
        return r(e.dataTypes[0]) || !o["*"] && r("*")
    }

    function eE(t, e) {
        var i, n, o = x.ajaxSettings.flatOptions || {};
        for (i in e) void 0 !== e[i] && ((o[i] ? t : n || (n = {}))[i] = e[i]);
        return n && x.extend(!0, t, n), t
    }
    eS.href = ec.href, x.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ec.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ec.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": ek,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": x.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, e) {
            return e ? eE(eE(t, x.ajaxSettings), e) : eE(x.ajaxSettings, t)
        },
        ajaxPrefilter: eC(e_),
        ajaxTransport: eC(ew),
        ajax: function(e, i) {
            "object" == typeof e && (i = e, e = void 0), i = i || {};
            var n, o, s, r, a, l, c, u, d, p, h = x.ajaxSetup({}, i),
                f = h.context || h,
                g = h.context && (f.nodeType || f.jquery) ? x(f) : x.event,
                m = x.Deferred(),
                y = x.Callbacks("once memory"),
                $ = h.statusCode || {},
                b = {},
                T = {},
                _ = "canceled",
                w = {
                    readyState: 0,
                    getResponseHeader: function(t) {
                        var e;
                        if (c) {
                            if (!r)
                                for (r = {}; e = eb.exec(s);) r[e[1].toLowerCase() + " "] = (r[e[1].toLowerCase() + " "] || []).concat(e[2]);
                            e = r[t.toLowerCase() + " "]
                        }
                        return null == e ? null : e.join(", ")
                    },
                    getAllResponseHeaders: function() {
                        return c ? s : null
                    },
                    setRequestHeader: function(t, e) {
                        return null == c && (b[t = T[t.toLowerCase()] = T[t.toLowerCase()] || t] = e), this
                    },
                    overrideMimeType: function(t) {
                        return null == c && (h.mimeType = t), this
                    },
                    statusCode: function(t) {
                        var e;
                        if (t) {
                            if (c) w.always(t[w.status]);
                            else
                                for (e in t) $[e] = [$[e], t[e]]
                        }
                        return this
                    },
                    abort: function(t) {
                        var e = t || _;
                        return n && n.abort(e), C(0, e), this
                    }
                };
            if (m.promise(w), h.url = ((e || h.url || ec.href) + "").replace(eT, ec.protocol + "//"), h.type = i.method || i.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(z) || [""], null == h.crossDomain) {
                l = v.createElement("a");
                try {
                    l.href = h.url, l.href = l.href, h.crossDomain = eS.protocol + "//" + eS.host != l.protocol + "//" + l.host
                } catch (k) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = x.param(h.data, h.traditional)), e9(e_, h, i, w), c) return w;
            for (d in (u = x.event && h.global) && 0 == x.active++ && x.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !ex.test(h.type), o = h.url.replace(ey, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(em, "+")) : (p = h.url.slice(o.length), h.data && (h.processData || "string" == typeof h.data) && (o += (ed.test(o) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (o = o.replace(e$, "$1"), p = (ed.test(o) ? "&" : "?") + "_=" + eu.guid++ + p), h.url = o + p), h.ifModified && (x.lastModified[o] && w.setRequestHeader("If-Modified-Since", x.lastModified[o]), x.etag[o] && w.setRequestHeader("If-None-Match", x.etag[o])), (h.data && h.hasContent && !1 !== h.contentType || i.contentType) && w.setRequestHeader("Content-Type", h.contentType), w.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + ek + "; q=0.01" : "") : h.accepts["*"]), h.headers) w.setRequestHeader(d, h.headers[d]);
            if (h.beforeSend && (!1 === h.beforeSend.call(f, w, h) || c)) return w.abort();
            if (_ = "abort", y.add(h.complete), w.done(h.success), w.fail(h.error), n = e9(ew, h, i, w)) {
                if (w.readyState = 1, u && g.trigger("ajaxSend", [w, h]), c) return w;
                h.async && 0 < h.timeout && (a = t.setTimeout(function() {
                    w.abort("timeout")
                }, h.timeout));
                try {
                    c = !1, n.send(b, C)
                } catch (S) {
                    if (c) throw S;
                    C(-1, S)
                }
            } else C(-1, "No Transport");

            function C(e, i, r, l) {
                var d, p, v, b, T, _ = i;
                c || (c = !0, a && t.clearTimeout(a), n = void 0, s = l || "", w.readyState = 0 < e ? 4 : 0, d = 200 <= e && e < 300 || 304 === e, r && (b = function(t, e, i) {
                    for (var n, o, s, r, a = t.contents, l = t.dataTypes;
                        "*" === l[0];) l.shift(), void 0 === n && (n = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (n) {
                        for (o in a)
                            if (a[o] && a[o].test(n)) {
                                l.unshift(o);
                                break
                            }
                    }
                    if (l[0] in i) s = l[0];
                    else {
                        for (o in i) {
                            if (!l[0] || t.converters[o + " " + l[0]]) {
                                s = o;
                                break
                            }
                            r || (r = o)
                        }
                        s = s || r
                    }
                    if (s) return s !== l[0] && l.unshift(s), i[s]
                }(h, w, r)), !d && -1 < x.inArray("script", h.dataTypes) && 0 > x.inArray("json", h.dataTypes) && (h.converters["text script"] = function() {}), b = function(t, e, i, n) {
                    var o, s, r, a, l, c = {},
                        u = t.dataTypes.slice();
                    if (u[1])
                        for (r in t.converters) c[r.toLowerCase()] = t.converters[r];
                    for (s = u.shift(); s;)
                        if (t.responseFields[s] && (i[t.responseFields[s]] = e), !l && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = s, s = u.shift()) {
                            if ("*" === s) s = l;
                            else if ("*" !== l && l !== s) {
                                if (!(r = c[l + " " + s] || c["* " + s])) {
                                    for (o in c)
                                        if ((a = o.split(" "))[1] === s && (r = c[l + " " + a[0]] || c["* " + a[0]])) {
                                            !0 === r ? r = c[o] : !0 !== c[o] && (s = a[0], u.unshift(a[1]));
                                            break
                                        }
                                }
                                if (!0 !== r) {
                                    if (r && t.throws) e = r(e);
                                    else try {
                                        e = r(e)
                                    } catch (d) {
                                        return {
                                            state: "parsererror",
                                            error: r ? d : "No conversion from " + l + " to " + s
                                        }
                                    }
                                }
                            }
                        }
                    return {
                        state: "success",
                        data: e
                    }
                }(h, b, w, d), d ? (h.ifModified && ((T = w.getResponseHeader("Last-Modified")) && (x.lastModified[o] = T), (T = w.getResponseHeader("etag")) && (x.etag[o] = T)), 204 === e || "HEAD" === h.type ? _ = "nocontent" : 304 === e ? _ = "notmodified" : (_ = b.state, p = b.data, d = !(v = b.error))) : (v = _, !e && _ || (_ = "error", e < 0 && (e = 0))), w.status = e, w.statusText = (i || _) + "", d ? m.resolveWith(f, [p, _, w]) : m.rejectWith(f, [w, _, v]), w.statusCode($), $ = void 0, u && g.trigger(d ? "ajaxSuccess" : "ajaxError", [w, h, d ? p : v]), y.fireWith(f, [w, _]), u && (g.trigger("ajaxComplete", [w, h]), --x.active || x.event.trigger("ajaxStop")))
            }
            return w
        },
        getJSON: function(t, e, i) {
            return x.get(t, e, i, "json")
        },
        getScript: function(t, e) {
            return x.get(t, void 0, e, "script")
        }
    }), x.each(["get", "post"], function(t, e) {
        x[e] = function(t, i, n, o) {
            return f(i) && (o = o || n, n = i, i = void 0), x.ajax(x.extend({
                url: t,
                type: e,
                dataType: o,
                data: i,
                success: n
            }, x.isPlainObject(t) && t))
        }
    }), x.ajaxPrefilter(function(t) {
        var e;
        for (e in t.headers) "content-type" === e.toLowerCase() && (t.contentType = t.headers[e] || "")
    }), x._evalUrl = function(t, e, i) {
        return x.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(t) {
                x.globalEval(t, e, i)
            }
        })
    }, x.fn.extend({
        wrapAll: function(t) {
            var e;
            return this[0] && (f(t) && (t = t.call(this[0])), e = x(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                return t
            }).append(this)), this
        },
        wrapInner: function(t) {
            return f(t) ? this.each(function(e) {
                x(this).wrapInner(t.call(this, e))
            }) : this.each(function() {
                var e = x(this),
                    i = e.contents();
                i.length ? i.wrapAll(t) : e.append(t)
            })
        },
        wrap: function(t) {
            var e = f(t);
            return this.each(function(i) {
                x(this).wrapAll(e ? t.call(this, i) : t)
            })
        },
        unwrap: function(t) {
            return this.parent(t).not("body").each(function() {
                x(this).replaceWith(this.childNodes)
            }), this
        }
    }), x.expr.pseudos.hidden = function(t) {
        return !x.expr.pseudos.visible(t)
    }, x.expr.pseudos.visible = function(t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
    }, x.ajaxSettings.xhr = function() {
        try {
            return new t.XMLHttpRequest
        } catch (e) {}
    };
    var eA = {
            0: 200,
            1223: 204
        },
        eL = x.ajaxSettings.xhr();
    h.cors = !!eL && "withCredentials" in eL, h.ajax = eL = !!eL, x.ajaxTransport(function(e) {
        var i, n;
        if (h.cors || eL && !e.crossDomain) return {
            send: function(o, s) {
                var r, a = e.xhr();
                if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                    for (r in e.xhrFields) a[r] = e.xhrFields[r];
                for (r in e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o) a.setRequestHeader(r, o[r]);
                i = function(t) {
                    return function() {
                        i && (i = n = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null, "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? s(0, "error") : s(a.status, a.statusText) : s(eA[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }, a.onload = i(), n = a.onerror = a.ontimeout = i("error"), void 0 !== a.onabort ? a.onabort = n : a.onreadystatechange = function() {
                    4 === a.readyState && t.setTimeout(function() {
                        i && n()
                    })
                }, i = i("abort");
                try {
                    a.send(e.hasContent && e.data || null)
                } catch (l) {
                    if (i) throw l
                }
            },
            abort: function() {
                i && i()
            }
        }
    }), x.ajaxPrefilter(function(t) {
        t.crossDomain && (t.contents.script = !1)
    }), x.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return x.globalEval(t), t
            }
        }
    }), x.ajaxPrefilter("script", function(t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
    }), x.ajaxTransport("script", function(t) {
        var e, i;
        if (t.crossDomain || t.scriptAttrs) return {
            send: function(n, o) {
                e = x("<script>").attr(t.scriptAttrs || {}).prop({
                    charset: t.scriptCharset,
                    src: t.url
                }).on("load error", i = function(t) {
                    e.remove(), i = null, t && o("error" === t.type ? 404 : 200, t.type)
                }), v.head.appendChild(e[0])
            },
            abort: function() {
                i && i()
            }
        }
    });
    var ej, eD = [],
        eO = /(=)\?(?=&|$)|\?\?/;
    x.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = eD.pop() || x.expando + "_" + eu.guid++;
            return this[t] = !0, t
        }
    }), x.ajaxPrefilter("json jsonp", function(e, i, n) {
        var o, s, r, a = !1 !== e.jsonp && (eO.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && eO.test(e.data) && "data");
        if (a || "jsonp" === e.dataTypes[0]) return o = e.jsonpCallback = f(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(eO, "$1" + o) : !1 !== e.jsonp && (e.url += (ed.test(e.url) ? "&" : "?") + e.jsonp + "=" + o), e.converters["script json"] = function() {
            return r || x.error(o + " was not called"), r[0]
        }, e.dataTypes[0] = "json", s = t[o], t[o] = function() {
            r = arguments
        }, n.always(function() {
            void 0 === s ? x(t).removeProp(o) : t[o] = s, e[o] && (e.jsonpCallback = i.jsonpCallback, eD.push(o)), r && f(s) && s(r[0]), r = s = void 0
        }), "script"
    }), h.createHTMLDocument = ((ej = v.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === ej.childNodes.length), x.parseHTML = function(t, e, i) {
        var n, o, s;
        return "string" != typeof t ? [] : ("boolean" == typeof e && (i = e, e = !1), e || (h.createHTMLDocument ? ((n = (e = v.implementation.createHTMLDocument("")).createElement("base")).href = v.location.href, e.head.appendChild(n)) : e = v), s = !i && [], (o = E.exec(t)) ? [e.createElement(o[1])] : (o = t$([t], e, s), s && s.length && x(s).remove(), x.merge([], o.childNodes)))
    }, x.fn.load = function(t, e, i) {
        var n, o, s, r = this,
            a = t.indexOf(" ");
        return -1 < a && (n = en(t.slice(a)), t = t.slice(0, a)), f(e) ? (i = e, e = void 0) : e && "object" == typeof e && (o = "POST"), 0 < r.length && x.ajax({
            url: t,
            type: o || "GET",
            dataType: "html",
            data: e
        }).done(function(t) {
            s = arguments, r.html(n ? x("<div>").append(x.parseHTML(t)).find(n) : t)
        }).always(i && function(t, e) {
            r.each(function() {
                i.apply(this, s || [t.responseText, e, t])
            })
        }), this
    }, x.expr.pseudos.animated = function(t) {
        return x.grep(x.timers, function(e) {
            return t === e.elem
        }).length
    }, x.offset = {
        setOffset: function(t, e, i) {
            var n, o, s, r, a, l, c = x.css(t, "position"),
                u = x(t),
                d = {};
            "static" === c && (t.style.position = "relative"), a = u.offset(), s = x.css(t, "top"), l = x.css(t, "left"), ("absolute" === c || "fixed" === c) && -1 < (s + l).indexOf("auto") ? (r = (n = u.position()).top, o = n.left) : (r = parseFloat(s) || 0, o = parseFloat(l) || 0), f(e) && (e = e.call(t, i, x.extend({}, a))), null != e.top && (d.top = e.top - a.top + r), null != e.left && (d.left = e.left - a.left + o), "using" in e ? e.using.call(t, d) : u.css(d)
        }
    }, x.fn.extend({
        offset: function(t) {
            if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                x.offset.setOffset(this, t, e)
            });
            var e, i, n = this[0];
            return n ? n.getClientRects().length ? (e = n.getBoundingClientRect(), i = n.ownerDocument.defaultView, {
                top: e.top + i.pageYOffset,
                left: e.left + i.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var t, e, i, n = this[0],
                    o = {
                        top: 0,
                        left: 0
                    };
                if ("fixed" === x.css(n, "position")) e = n.getBoundingClientRect();
                else {
                    for (e = this.offset(), i = n.ownerDocument, t = n.offsetParent || i.documentElement; t && (t === i.body || t === i.documentElement) && "static" === x.css(t, "position");) t = t.parentNode;
                    t && t !== n && 1 === t.nodeType && ((o = x(t).offset()).top += x.css(t, "borderTopWidth", !0), o.left += x.css(t, "borderLeftWidth", !0))
                }
                return {
                    top: e.top - o.top - x.css(n, "marginTop", !0),
                    left: e.left - o.left - x.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && "static" === x.css(t, "position");) t = t.offsetParent;
                return t || tn
            })
        }
    }), x.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, e) {
        var i = "pageYOffset" === e;
        x.fn[t] = function(n) {
            return M(this, function(t, n, o) {
                var s;
                if (g(t) ? s = t : 9 === t.nodeType && (s = t.defaultView), void 0 === o) return s ? s[e] : t[n];
                s ? s.scrollTo(i ? s.pageXOffset : o, i ? o : s.pageYOffset) : t[n] = o
            }, t, n, arguments.length)
        }
    }), x.each(["top", "left"], function(t, e) {
        x.cssHooks[e] = tq(h.pixelPosition, function(t, i) {
            if (i) return i = tI(t, e), tH.test(i) ? x(t).position()[e] + "px" : i
        })
    }), x.each({
        Height: "height",
        Width: "width"
    }, function(t, e) {
        x.each({
            padding: "inner" + t,
            content: e,
            "": "outer" + t
        }, function(i, n) {
            x.fn[n] = function(o, s) {
                var r = arguments.length && (i || "boolean" != typeof o),
                    a = i || (!0 === o || !0 === s ? "margin" : "border");
                return M(this, function(e, i, o) {
                    var s;
                    return g(e) ? 0 === n.indexOf("outer") ? e["inner" + t] : e.document.documentElement["client" + t] : 9 === e.nodeType ? (s = e.documentElement, Math.max(e.body["scroll" + t], s["scroll" + t], e.body["offset" + t], s["offset" + t], s["client" + t])) : void 0 === o ? x.css(e, i, a) : x.style(e, i, o, a)
                }, e, r ? o : void 0, r)
            }
        })
    }), x.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
        x.fn[e] = function(t) {
            return this.on(e, t)
        }
    }), x.fn.extend({
        bind: function(t, e, i) {
            return this.on(t, null, e, i)
        },
        unbind: function(t, e) {
            return this.off(t, null, e)
        },
        delegate: function(t, e, i, n) {
            return this.on(e, t, i, n)
        },
        undelegate: function(t, e, i) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", i)
        },
        hover: function(t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }), x.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(t, e) {
        x.fn[e] = function(t, i) {
            return 0 < arguments.length ? this.on(e, null, t, i) : this.trigger(e)
        }
    });
    var eH = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    x.proxy = function(t, e) {
        var i, n, s;
        if ("string" == typeof e && (i = t[e], e = t, t = i), f(t)) return n = o.call(arguments, 2), (s = function() {
            return t.apply(e || this, n.concat(o.call(arguments)))
        }).guid = t.guid = t.guid || x.guid++, s
    }, x.holdReady = function(t) {
        t ? x.readyWait++ : x.ready(!0)
    }, x.isArray = Array.isArray, x.parseJSON = JSON.parse, x.nodeName = C, x.isFunction = f, x.isWindow = g, x.camelCase = X, x.type = $, x.now = Date.now, x.isNumeric = function(t) {
        var e = x.type(t);
        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
    }, x.trim = function(t) {
        return null == t ? "" : (t + "").replace(eH, "")
    }, "function" == typeof define && define.amd && define("jquery", [], function() {
        return x
    });
    var ez = t.jQuery,
        eP = t.$;
    return x.noConflict = function(e) {
        return t.$ === x && (t.$ = eP), e && t.jQuery === x && (t.jQuery = ez), x
    }, void 0 === e && (t.jQuery = t.$ = x), x
}),
function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    "use strict";
    var e, i = window.Slick || {};
    (i = (e = 0, function i(n, o) {
        var s, r = this;
        r.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: t(n),
            appendDots: t(n),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function(e, i) {
                return t('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1)
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: .35,
            fade: !1,
            focusOnSelect: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3
        }, r.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1
        }, t.extend(r, r.initials), r.activeBreakpoint = null, r.animType = null, r.animProp = null, r.breakpoints = [], r.breakpointSettings = [], r.cssTransitions = !1, r.focussed = !1, r.interrupted = !1, r.hidden = "hidden", r.paused = !0, r.positionProp = null, r.respondTo = null, r.rowCount = 1, r.shouldClick = !0, r.$slider = t(n), r.$slidesCache = null, r.transformType = null, r.transitionType = null, r.visibilityChange = "visibilitychange", r.windowWidth = 0, r.windowTimer = null, s = t(n).data("slick") || {}, r.options = t.extend({}, r.defaults, o, s), r.currentSlide = r.options.initialSlide, r.originalSettings = r.options, void 0 !== document.mozHidden ? (r.hidden = "mozHidden", r.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (r.hidden = "webkitHidden", r.visibilityChange = "webkitvisibilitychange"), r.autoPlay = t.proxy(r.autoPlay, r), r.autoPlayClear = t.proxy(r.autoPlayClear, r), r.autoPlayIterator = t.proxy(r.autoPlayIterator, r), r.changeSlide = t.proxy(r.changeSlide, r), r.clickHandler = t.proxy(r.clickHandler, r), r.selectHandler = t.proxy(r.selectHandler, r), r.setPosition = t.proxy(r.setPosition, r), r.swipeHandler = t.proxy(r.swipeHandler, r), r.dragHandler = t.proxy(r.dragHandler, r), r.keyHandler = t.proxy(r.keyHandler, r), r.instanceUid = e++, r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, r.registerBreakpoints(), r.init(!0)
    })).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, i.prototype.addSlide = i.prototype.slickAdd = function(e, i, n) {
        var o = this;
        if ("boolean" == typeof i) n = i, i = null;
        else if (0 > i || i >= o.slideCount) return !1;
        o.unload(), "number" == typeof i ? 0 === i && 0 === o.$slides.length ? t(e).appendTo(o.$slideTrack) : n ? t(e).insertBefore(o.$slides.eq(i)) : t(e).insertAfter(o.$slides.eq(i)) : !0 === n ? t(e).prependTo(o.$slideTrack) : t(e).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function(e, i) {
            t(i).attr("data-slick-index", e)
        }), o.$slidesCache = o.$slides, o.reinit()
    }, i.prototype.animateHeight = function() {
        if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
            var t = this.$slides.eq(this.currentSlide).outerHeight(!0);
            this.$list.animate({
                height: t
            }, this.options.speed)
        }
    }, i.prototype.animateSlide = function(e, i) {
        var n = {},
            o = this;
        o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (e = -e), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
            left: e
        }, o.options.speed, o.options.easing, i) : o.$slideTrack.animate({
            top: e
        }, o.options.speed, o.options.easing, i) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), t({
            animStart: o.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: o.options.speed,
            easing: o.options.easing,
            step: function(t) {
                t = Math.ceil(t), !1 === o.options.vertical ? (n[o.animType] = "translate(" + t + "px, 0px)", o.$slideTrack.css(n)) : (n[o.animType] = "translate(0px," + t + "px)", o.$slideTrack.css(n))
            },
            complete: function() {
                i && i.call()
            }
        })) : (o.applyTransition(), e = Math.ceil(e), !1 === o.options.vertical ? n[o.animType] = "translate3d(" + e + "px, 0px, 0px)" : n[o.animType] = "translate3d(0px," + e + "px, 0px)", o.$slideTrack.css(n), i && setTimeout(function() {
            o.disableTransition(), i.call()
        }, o.options.speed))
    }, i.prototype.getNavTarget = function() {
        var e = this.options.asNavFor;
        return e && null !== e && (e = t(e).not(this.$slider)), e
    }, i.prototype.asNavFor = function(e) {
        var i = this.getNavTarget();
        null !== i && "object" == typeof i && i.each(function() {
            var i = t(this).slick("getSlick");
            i.unslicked || i.slideHandler(e, !0)
        })
    }, i.prototype.applyTransition = function(t) {
        var e = this,
            i = {};
        !1 === e.options.fade ? i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
    }, i.prototype.autoPlay = function() {
        var t = this;
        t.autoPlayClear(), t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
    }, i.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    }, i.prototype.autoPlayIterator = function() {
        var t = this,
            e = t.currentSlide + t.options.slidesToScroll;
        t.paused || t.interrupted || t.focussed || (!1 === t.options.infinite && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll, t.currentSlide - 1 == 0 && (t.direction = 1))), t.slideHandler(e))
    }, i.prototype.buildArrows = function() {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, i.prototype.buildDots = function() {
        var e, i, n = this;
        if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
            for (n.$slider.addClass("slick-dotted"), i = t("<ul />").addClass(n.options.dotsClass), e = 0; e <= n.getDotCount(); e += 1) i.append(t("<li />").append(n.options.customPaging.call(this, n, e)));
            n.$dots = i.appendTo(n.options.appendDots), n.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
        }
    }, i.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, i) {
            t(i).attr("data-slick-index", e).data("originalStyling", t(i).attr("style") || "")
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? t('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), (!0 === e.options.centerMode || !0 === e.options.swipeToSlide) && (e.options.slidesToScroll = 1), t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
    }, i.prototype.buildRows = function() {
        var t, e, i, n, o, s, r;
        if (n = document.createDocumentFragment(), s = this.$slider.children(), this.options.rows > 1) {
            for (r = this.options.slidesPerRow * this.options.rows, o = Math.ceil(s.length / r), t = 0; o > t; t++) {
                var a = document.createElement("div");
                for (e = 0; e < this.options.rows; e++) {
                    var l = document.createElement("div");
                    for (i = 0; i < this.options.slidesPerRow; i++) {
                        var c = t * r + (e * this.options.slidesPerRow + i);
                        s.get(c) && l.appendChild(s.get(c))
                    }
                    a.appendChild(l)
                }
                n.appendChild(a)
            }
            this.$slider.empty().append(n), this.$slider.children().children().children().css({
                width: 100 / this.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, i.prototype.checkResponsive = function(e, i) {
        var n, o, s, r = this,
            a = !1,
            l = r.$slider.width(),
            c = window.innerWidth || t(window).width();
        if ("window" === r.respondTo ? s = c : "slider" === r.respondTo ? s = l : "min" === r.respondTo && (s = Math.min(c, l)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            for (n in o = null, r.breakpoints) r.breakpoints.hasOwnProperty(n) && (!1 === r.originalSettings.mobileFirst ? s < r.breakpoints[n] && (o = r.breakpoints[n]) : s > r.breakpoints[n] && (o = r.breakpoints[n]));
            null !== o ? null !== r.activeBreakpoint ? (o !== r.activeBreakpoint || i) && (r.activeBreakpoint = o, "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[o]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = o) : (r.activeBreakpoint = o, "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[o]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = o) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), a = o), e || !1 === a || r.$slider.trigger("breakpoint", [r, a])
        }
    }, i.prototype.changeSlide = function(e, i) {
        var n, o, s, r = t(e.currentTarget);
        switch (r.is("a") && e.preventDefault(), r.is("li") || (r = r.closest("li")), n = (s = this.slideCount % this.options.slidesToScroll != 0) ? 0 : (this.slideCount - this.currentSlide) % this.options.slidesToScroll, e.data.message) {
            case "previous":
                o = 0 === n ? this.options.slidesToScroll : this.options.slidesToShow - n, this.slideCount > this.options.slidesToShow && this.slideHandler(this.currentSlide - o, !1, i);
                break;
            case "next":
                o = 0 === n ? this.options.slidesToScroll : n, this.slideCount > this.options.slidesToShow && this.slideHandler(this.currentSlide + o, !1, i);
                break;
            case "index":
                var a = 0 === e.data.index ? 0 : e.data.index || r.index() * this.options.slidesToScroll;
                this.slideHandler(this.checkNavigable(a), !1, i), r.children().trigger("focus");
                break;
            default:
                return
        }
    }, i.prototype.checkNavigable = function(t) {
        var e, i;
        if (e = this.getNavigableIndexes(), i = 0, t > e[e.length - 1]) t = e[e.length - 1];
        else
            for (var n in e) {
                if (t < e[n]) {
                    t = i;
                    break
                }
                i = e[n]
            }
        return t
    }, i.prototype.cleanUpEvents = function() {
        this.options.dots && null !== this.$dots && t("li", this.$dots).off("click.slick", this.changeSlide).off("mouseenter.slick", t.proxy(this.interrupt, this, !0)).off("mouseleave.slick", t.proxy(this.interrupt, this, !1)), this.$slider.off("focus.slick blur.slick"), !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow && this.$prevArrow.off("click.slick", this.changeSlide), this.$nextArrow && this.$nextArrow.off("click.slick", this.changeSlide)), this.$list.off("touchstart.slick mousedown.slick", this.swipeHandler), this.$list.off("touchmove.slick mousemove.slick", this.swipeHandler), this.$list.off("touchend.slick mouseup.slick", this.swipeHandler), this.$list.off("touchcancel.slick mouseleave.slick", this.swipeHandler), this.$list.off("click.slick", this.clickHandler), t(document).off(this.visibilityChange, this.visibility), this.cleanUpSlideEvents(), !0 === this.options.accessibility && this.$list.off("keydown.slick", this.keyHandler), !0 === this.options.focusOnSelect && t(this.$slideTrack).children().off("click.slick", this.selectHandler), t(window).off("orientationchange.slick.slick-" + this.instanceUid, this.orientationChange), t(window).off("resize.slick.slick-" + this.instanceUid, this.resize), t("[draggable!=true]", this.$slideTrack).off("dragstart", this.preventDefault), t(window).off("load.slick.slick-" + this.instanceUid, this.setPosition), t(document).off("ready.slick.slick-" + this.instanceUid, this.setPosition)
    }, i.prototype.cleanUpSlideEvents = function() {
        this.$list.off("mouseenter.slick", t.proxy(this.interrupt, this, !0)), this.$list.off("mouseleave.slick", t.proxy(this.interrupt, this, !1))
    }, i.prototype.cleanUpRows = function() {
        var t;
        this.options.rows > 1 && ((t = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(t))
    }, i.prototype.clickHandler = function(t) {
        !1 === this.shouldClick && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault())
    }, i.prototype.destroy = function(e) {
        var i = this;
        i.autoPlayClear(), i.touchObject = {}, i.cleanUpEvents(), t(".slick-cloned", i.$slider).detach(), i.$dots && i.$dots.remove(), i.$prevArrow && i.$prevArrow.length && (i.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()), i.$nextArrow && i.$nextArrow.length && (i.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()), i.$slides && (i.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            t(this).attr("style", t(this).data("originalStyling"))
        }), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.detach(), i.$list.detach(), i.$slider.append(i.$slides)), i.cleanUpRows(), i.$slider.removeClass("slick-slider"), i.$slider.removeClass("slick-initialized"), i.$slider.removeClass("slick-dotted"), i.unslicked = !0, e || i.$slider.trigger("destroy", [i])
    }, i.prototype.disableTransition = function(t) {
        var e = this,
            i = {};
        i[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
    }, i.prototype.fadeSlide = function(t, e) {
        var i = this;
        !1 === i.cssTransitions ? (i.$slides.eq(t).css({
            zIndex: i.options.zIndex
        }), i.$slides.eq(t).animate({
            opacity: 1
        }, i.options.speed, i.options.easing, e)) : (i.applyTransition(t), i.$slides.eq(t).css({
            opacity: 1,
            zIndex: i.options.zIndex
        }), e && setTimeout(function() {
            i.disableTransition(t), e.call()
        }, i.options.speed))
    }, i.prototype.fadeSlideOut = function(t) {
        !1 === this.cssTransitions ? this.$slides.eq(t).animate({
            opacity: 0,
            zIndex: this.options.zIndex - 2
        }, this.options.speed, this.options.easing) : (this.applyTransition(t), this.$slides.eq(t).css({
            opacity: 0,
            zIndex: this.options.zIndex - 2
        }))
    }, i.prototype.filterSlides = i.prototype.slickFilter = function(t) {
        var e = this;
        null !== t && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(t).appendTo(e.$slideTrack), e.reinit())
    }, i.prototype.focusHandler = function() {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(i) {
            i.stopImmediatePropagation();
            var n = t(this);
            setTimeout(function() {
                e.options.pauseOnFocus && (e.focussed = n.is(":focus"), e.autoPlay())
            }, 0)
        })
    }, i.prototype.getCurrent = i.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }, i.prototype.getDotCount = function() {
        var t = 0,
            e = 0,
            i = 0;
        if (!0 === this.options.infinite)
            for (; t < this.slideCount;) ++i, t = e + this.options.slidesToScroll, e += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        else if (!0 === this.options.centerMode) i = this.slideCount;
        else if (this.options.asNavFor)
            for (; t < this.slideCount;) ++i, t = e + this.options.slidesToScroll, e += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        else i = 1 + Math.ceil((this.slideCount - this.options.slidesToShow) / this.options.slidesToScroll);
        return i - 1
    }, i.prototype.getLeft = function(t) {
        var e, i, n, o = this,
            s = 0;
        return o.slideOffset = 0, i = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = -(o.slideWidth * o.options.slidesToShow * 1), s = -(i * o.options.slidesToShow * 1)), o.slideCount % o.options.slidesToScroll != 0 && t + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (t > o.slideCount ? (o.slideOffset = -((o.options.slidesToShow - (t - o.slideCount)) * o.slideWidth * 1), s = -((o.options.slidesToShow - (t - o.slideCount)) * i * 1)) : (o.slideOffset = -(o.slideCount % o.options.slidesToScroll * o.slideWidth * 1), s = -(o.slideCount % o.options.slidesToScroll * i * 1)))) : t + o.options.slidesToShow > o.slideCount && (o.slideOffset = (t + o.options.slidesToShow - o.slideCount) * o.slideWidth, s = (t + o.options.slidesToShow - o.slideCount) * i), o.slideCount <= o.options.slidesToShow && (o.slideOffset = 0, s = 0), !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), e = !1 === o.options.vertical ? -(t * o.slideWidth * 1) + o.slideOffset : -(t * i * 1) + s, !0 === o.options.variableWidth && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow), e = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0, !0 === o.options.centerMode && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow + 1), e = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0, e += (o.$list.width() - n.outerWidth()) / 2)), e
    }, i.prototype.getOption = i.prototype.slickGetOption = function(t) {
        return this.options[t]
    }, i.prototype.getNavigableIndexes = function() {
        var t, e = 0,
            i = 0,
            n = [];
        for (!1 === this.options.infinite ? t = this.slideCount : (e = -1 * this.options.slidesToScroll, i = -1 * this.options.slidesToScroll, t = 2 * this.slideCount); t > e;) n.push(e), e = i + this.options.slidesToScroll, i += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        return n
    }, i.prototype.getSlick = function() {
        return this
    }, i.prototype.getSlideCount = function() {
        var e, i, n, o = this;
        return n = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(e, s) {
            return s.offsetLeft - n + t(s).outerWidth() / 2 > -1 * o.swipeLeft ? (i = s, !1) : void 0
        }), e = Math.abs(t(i).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }, i.prototype.goTo = i.prototype.slickGoTo = function(t, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(t)
            }
        }, e)
    }, i.prototype.init = function(e) {
        var i = this;
        t(i.$slider).hasClass("slick-initialized") || (t(i.$slider).addClass("slick-initialized"), i.buildRows(), i.buildOut(), i.setProps(), i.startLoad(), i.loadSlider(), i.initializeEvents(), i.updateArrows(), i.updateDots(), i.checkResponsive(!0), i.focusHandler()), e && i.$slider.trigger("init", [i]), !0 === i.options.accessibility && i.initADA(), i.options.autoplay && (i.paused = !1, i.autoPlay())
    }, i.prototype.initADA = function() {
        var e = this;
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), e.$slideTrack.attr("role", "listbox"), e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(i) {
            t(this).attr({
                role: "option",
                "aria-describedby": "slick-slide" + e.instanceUid + i
            })
        }), null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(i) {
            t(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + e.instanceUid + i,
                id: "slick-slide" + e.instanceUid + i
            })
        }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), e.activateADA()
    }, i.prototype.initArrowEvents = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, this.changeSlide), this.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, this.changeSlide))
    }, i.prototype.initDotEvents = function() {
        !0 === this.options.dots && this.slideCount > this.options.slidesToShow && t("li", this.$dots).on("click.slick", {
            message: "index"
        }, this.changeSlide), !0 === this.options.dots && !0 === this.options.pauseOnDotsHover && t("li", this.$dots).on("mouseenter.slick", t.proxy(this.interrupt, this, !0)).on("mouseleave.slick", t.proxy(this.interrupt, this, !1))
    }, i.prototype.initSlideEvents = function() {
        this.options.pauseOnHover && (this.$list.on("mouseenter.slick", t.proxy(this.interrupt, this, !0)), this.$list.on("mouseleave.slick", t.proxy(this.interrupt, this, !1)))
    }, i.prototype.initializeEvents = function() {
        this.initArrowEvents(), this.initDotEvents(), this.initSlideEvents(), this.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, this.swipeHandler), this.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, this.swipeHandler), this.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, this.swipeHandler), this.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, this.swipeHandler), this.$list.on("click.slick", this.clickHandler), t(document).on(this.visibilityChange, t.proxy(this.visibility, this)), !0 === this.options.accessibility && this.$list.on("keydown.slick", this.keyHandler), !0 === this.options.focusOnSelect && t(this.$slideTrack).children().on("click.slick", this.selectHandler), t(window).on("orientationchange.slick.slick-" + this.instanceUid, t.proxy(this.orientationChange, this)), t(window).on("resize.slick.slick-" + this.instanceUid, t.proxy(this.resize, this)), t("[draggable!=true]", this.$slideTrack).on("dragstart", this.preventDefault), t(window).on("load.slick.slick-" + this.instanceUid, this.setPosition), t(document).on("ready.slick.slick-" + this.instanceUid, this.setPosition)
    }, i.prototype.initUI = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.show(), this.$nextArrow.show()), !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.show()
    }, i.prototype.keyHandler = function(t) {
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && !0 === this.options.accessibility ? this.changeSlide({
            data: {
                message: !0 === this.options.rtl ? "next" : "previous"
            }
        }) : 39 === t.keyCode && !0 === this.options.accessibility && this.changeSlide({
            data: {
                message: !0 === this.options.rtl ? "previous" : "next"
            }
        }))
    }, i.prototype.lazyLoad = function() {
        function e(e) {
            t("img[data-lazy]", e).each(function() {
                var e = t(this),
                    i = t(this).attr("data-lazy"),
                    n = document.createElement("img");
                n.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        e.attr("src", i).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy").removeClass("slick-loading")
                        }), r.$slider.trigger("lazyLoaded", [r, e, i])
                    })
                }, n.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, e, i])
                }, n.src = i
            })
        }
        var i, n, o, s, r = this;
        !0 === r.options.centerMode ? !0 === r.options.infinite ? s = (o = r.currentSlide + (r.options.slidesToShow / 2 + 1)) + r.options.slidesToShow + 2 : (o = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), s = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = Math.ceil((o = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide) + r.options.slidesToShow), !0 === r.options.fade && (o > 0 && o--, s <= r.slideCount && s++)), e(i = r.$slider.find(".slick-slide").slice(o, s)), r.slideCount <= r.options.slidesToShow ? e(n = r.$slider.find(".slick-slide")) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? e(n = r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow)) : 0 === r.currentSlide && e(n = r.$slider.find(".slick-cloned").slice(-1 * r.options.slidesToShow))
    }, i.prototype.loadSlider = function() {
        this.setPosition(), this.$slideTrack.css({
            opacity: 1
        }), this.$slider.removeClass("slick-loading"), this.initUI(), "progressive" === this.options.lazyLoad && this.progressiveLazyLoad()
    }, i.prototype.next = i.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }, i.prototype.orientationChange = function() {
        this.checkResponsive(), this.setPosition()
    }, i.prototype.pause = i.prototype.slickPause = function() {
        var t = this;
        t.autoPlayClear(), t.paused = !0
    }, i.prototype.play = i.prototype.slickPlay = function() {
        var t = this;
        t.autoPlay(), t.options.autoplay = !0, t.paused = !1, t.focussed = !1, t.interrupted = !1
    }, i.prototype.postSlide = function(t) {
        var e = this;
        e.unslicked || (e.$slider.trigger("afterChange", [e, t]), e.animating = !1, e.setPosition(), e.swipeLeft = null, e.options.autoplay && e.autoPlay(), !0 === e.options.accessibility && e.initADA())
    }, i.prototype.prev = i.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, i.prototype.preventDefault = function(t) {
        t.preventDefault()
    }, i.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var i, n, o, s = this,
            r = t("img[data-lazy]", s.$slider);
        r.length ? (n = (i = r.first()).attr("data-lazy"), (o = document.createElement("img")).onload = function() {
            i.attr("src", n).removeAttr("data-lazy").removeClass("slick-loading"), !0 === s.options.adaptiveHeight && s.setPosition(), s.$slider.trigger("lazyLoaded", [s, i, n]), s.progressiveLazyLoad()
        }, o.onerror = function() {
            3 > e ? setTimeout(function() {
                s.progressiveLazyLoad(e + 1)
            }, 500) : (i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, i, n]), s.progressiveLazyLoad())
        }, o.src = n) : s.$slider.trigger("allImagesLoaded", [s])
    }, i.prototype.refresh = function(e) {
        var i, n, o = this;
        n = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > n && (o.currentSlide = n), o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), i = o.currentSlide, o.destroy(!0), t.extend(o, o.initials, {
            currentSlide: i
        }), o.init(), e || o.changeSlide({
            data: {
                message: "index",
                index: i
            }
        }, !1)
    }, i.prototype.registerBreakpoints = function() {
        var e, i, n, o = this,
            s = o.options.responsive || null;
        if ("array" === t.type(s) && s.length) {
            for (e in o.respondTo = o.options.respondTo || "window", s)
                if (n = o.breakpoints.length - 1, i = s[e].breakpoint, s.hasOwnProperty(e)) {
                    for (; n >= 0;) o.breakpoints[n] && o.breakpoints[n] === i && o.breakpoints.splice(n, 1), n--;
                    o.breakpoints.push(i), o.breakpointSettings[i] = s[e].settings
                }
            o.breakpoints.sort(function(t, e) {
                return o.options.mobileFirst ? t - e : e - t
            })
        }
    }, i.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
    }, i.prototype.resize = function() {
        var e = this;
        t(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
            e.windowWidth = t(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, i.prototype.removeSlide = i.prototype.slickRemove = function(t, e, i) {
        var n = this;
        return t = "boolean" == typeof t ? !0 === (e = t) ? 0 : n.slideCount - 1 : !0 === e ? --t : t, !(n.slideCount < 1) && !(0 > t) && !(t > n.slideCount - 1) && (n.unload(), !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(t).remove(), n.$slides = n.$slideTrack.children(this.options.slide), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.append(n.$slides), n.$slidesCache = n.$slides, void n.reinit())
    }, i.prototype.setCSS = function(t) {
        var e, i, n = this,
            o = {};
        !0 === n.options.rtl && (t = -t), e = "left" == n.positionProp ? Math.ceil(t) + "px" : "0px", i = "top" == n.positionProp ? Math.ceil(t) + "px" : "0px", o[n.positionProp] = t, !1 === n.transformsEnabled ? n.$slideTrack.css(o) : (o = {}, !1 === n.cssTransitions ? (o[n.animType] = "translate(" + e + ", " + i + ")", n.$slideTrack.css(o)) : (o[n.animType] = "translate3d(" + e + ", " + i + ", 0px)", n.$slideTrack.css(o)))
    }, i.prototype.setDimensions = function() {
        var t = this;
        !1 === t.options.vertical ? !0 === t.options.centerMode && t.$list.css({
            padding: "0px " + t.options.centerPadding
        }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow), !0 === t.options.centerMode && t.$list.css({
            padding: t.options.centerPadding + " 0px"
        })), t.listWidth = t.$list.width(), t.listHeight = t.$list.height(), !1 === t.options.vertical && !1 === t.options.variableWidth ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : !0 === t.options.variableWidth ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        !1 === t.options.variableWidth && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
    }, i.prototype.setFade = function() {
        var e, i = this;
        i.$slides.each(function(n, o) {
            e = -(i.slideWidth * n * 1), !0 === i.options.rtl ? t(o).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            }) : t(o).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            })
        }), i.$slides.eq(i.currentSlide).css({
            zIndex: i.options.zIndex - 1,
            opacity: 1
        })
    }, i.prototype.setHeight = function() {
        if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
            var t = this.$slides.eq(this.currentSlide).outerHeight(!0);
            this.$list.css("height", t)
        }
    }, i.prototype.setOption = i.prototype.slickSetOption = function() {
        var e, i, n, o, s, r = this,
            a = !1;
        if ("object" === t.type(arguments[0]) ? (n = arguments[0], a = arguments[1], s = "multiple") : "string" === t.type(arguments[0]) && (n = arguments[0], o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === t.type(arguments[1]) ? s = "responsive" : void 0 !== arguments[1] && (s = "single")), "single" === s) r.options[n] = o;
        else if ("multiple" === s) t.each(n, function(t, e) {
            r.options[t] = e
        });
        else if ("responsive" === s)
            for (i in o)
                if ("array" !== t.type(r.options.responsive)) r.options.responsive = [o[i]];
                else {
                    for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === o[i].breakpoint && r.options.responsive.splice(e, 1), e--;
                    r.options.responsive.push(o[i])
                }
        a && (r.unload(), r.reinit())
    }, i.prototype.setPosition = function() {
        this.setDimensions(), this.setHeight(), !1 === this.options.fade ? this.setCSS(this.getLeft(this.currentSlide)) : this.setFade(), this.$slider.trigger("setPosition", [this])
    }, i.prototype.setProps = function() {
        var t = this,
            e = document.body.style;
        t.positionProp = !0 === t.options.vertical ? "top" : "left", "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"), (void 0 !== e.WebkitTransition || void 0 !== e.MozTransition || void 0 !== e.msTransition) && !0 === t.options.useCSS && (t.cssTransitions = !0), t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex), void 0 !== e.OTransform && (t.animType = "OTransform", t.transformType = "-o-transform", t.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.MozTransform && (t.animType = "MozTransform", t.transformType = "-moz-transform", t.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)), void 0 !== e.webkitTransform && (t.animType = "webkitTransform", t.transformType = "-webkit-transform", t.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.msTransform && (t.animType = "msTransform", t.transformType = "-ms-transform", t.transitionType = "msTransition", void 0 === e.msTransform && (t.animType = !1)), void 0 !== e.transform && !1 !== t.animType && (t.animType = "transform", t.transformType = "transform", t.transitionType = "transition"), t.transformsEnabled = t.options.useTransform && null !== t.animType && !1 !== t.animType
    }, i.prototype.setSlideClasses = function(t) {
        var e, i, n, o;
        i = this.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), this.$slides.eq(t).addClass("slick-current"), !0 === this.options.centerMode ? (e = Math.floor(this.options.slidesToShow / 2), !0 === this.options.infinite && (t >= e && t <= this.slideCount - 1 - e ? this.$slides.slice(t - e, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (n = this.options.slidesToShow + t, i.slice(n - e + 1, n + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === t ? i.eq(i.length - 1 - this.options.slidesToShow).addClass("slick-center") : t === this.slideCount - 1 && i.eq(this.options.slidesToShow).addClass("slick-center")), this.$slides.eq(t).addClass("slick-center")) : t >= 0 && t <= this.slideCount - this.options.slidesToShow ? this.$slides.slice(t, t + this.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= this.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (o = this.slideCount % this.options.slidesToShow, n = !0 === this.options.infinite ? this.options.slidesToShow + t : t, this.options.slidesToShow == this.options.slidesToScroll && this.slideCount - t < this.options.slidesToShow ? i.slice(n - (this.options.slidesToShow - o), n + o).addClass("slick-active").attr("aria-hidden", "false") : i.slice(n, n + this.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" === this.options.lazyLoad && this.lazyLoad()
    }, i.prototype.setupInfinite = function() {
        var e, i, n, o = this;
        if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (i = null, o.slideCount > o.options.slidesToShow)) {
            for (n = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, e = o.slideCount; e > o.slideCount - n; e -= 1) i = e - 1, t(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
            for (e = 0; n > e; e += 1) i = e, t(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
            o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                t(this).attr("id", "")
            })
        }
    }, i.prototype.interrupt = function(t) {
        var e = this;
        t || e.autoPlay(), e.interrupted = t
    }, i.prototype.selectHandler = function(e) {
        var i = parseInt((t(e.target).is(".slick-slide") ? t(e.target) : t(e.target).parents(".slick-slide")).attr("data-slick-index"));
        return i || (i = 0), this.slideCount <= this.options.slidesToShow ? (this.setSlideClasses(i), void this.asNavFor(i)) : void this.slideHandler(i)
    }, i.prototype.slideHandler = function(t, e, i) {
        var n, o, s, r, a, l = null,
            c = this;
        return e = e || !1, !0 === c.animating && !0 === c.options.waitForAnimate || !0 === c.options.fade && c.currentSlide === t || c.slideCount <= c.options.slidesToShow ? void 0 : (!1 === e && c.asNavFor(t), n = t, l = c.getLeft(n), r = c.getLeft(c.currentSlide), c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft, !1 === c.options.infinite && !1 === c.options.centerMode && (0 > t || t > c.getDotCount() * c.options.slidesToScroll) ? void(!1 === c.options.fade && (n = c.currentSlide, !0 !== i ? c.animateSlide(r, function() {
            c.postSlide(n)
        }) : c.postSlide(n))) : !1 === c.options.infinite && !0 === c.options.centerMode && (0 > t || t > c.slideCount - c.options.slidesToScroll) ? void(!1 === c.options.fade && (n = c.currentSlide, !0 !== i ? c.animateSlide(r, function() {
            c.postSlide(n)
        }) : c.postSlide(n))) : (c.options.autoplay && clearInterval(c.autoPlayTimer), o = 0 > n ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + n : n >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : n - c.slideCount : n, c.animating = !0, c.$slider.trigger("beforeChange", [c, c.currentSlide, o]), s = c.currentSlide, c.currentSlide = o, c.setSlideClasses(c.currentSlide), c.options.asNavFor && (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide), c.updateDots(), c.updateArrows(), !0 === c.options.fade ? (!0 !== i ? (c.fadeSlideOut(s), c.fadeSlide(o, function() {
            c.postSlide(o)
        })) : c.postSlide(o), void c.animateHeight()) : void(!0 !== i ? c.animateSlide(l, function() {
            c.postSlide(o)
        }) : c.postSlide(o))))
    }, i.prototype.startLoad = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.hide(), this.$nextArrow.hide()), !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.hide(), this.$slider.addClass("slick-loading")
    }, i.prototype.swipeDirection = function() {
        var t, e, i, n;
        return t = this.touchObject.startX - this.touchObject.curX, 0 > (n = Math.round(180 * (i = Math.atan2(e = this.touchObject.startY - this.touchObject.curY, t)) / Math.PI)) && (n = 360 - Math.abs(n)), 45 >= n && n >= 0 ? !1 === this.options.rtl ? "left" : "right" : 360 >= n && n >= 315 ? !1 === this.options.rtl ? "left" : "right" : n >= 135 && 225 >= n ? !1 === this.options.rtl ? "right" : "left" : !0 === this.options.verticalSwiping ? n >= 35 && 135 >= n ? "down" : "up" : "vertical"
    }, i.prototype.swipeEnd = function(t) {
        var e, i, n = this;
        if (n.dragging = !1, n.interrupted = !1, n.shouldClick = !(n.touchObject.swipeLength > 10), void 0 === n.touchObject.curX) return !1;
        if (!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [n, n.swipeDirection()]), n.touchObject.swipeLength >= n.touchObject.minSwipe) {
            switch (i = n.swipeDirection()) {
                case "left":
                case "down":
                    e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount(), n.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount(), n.currentDirection = 1
            }
            "vertical" != i && (n.slideHandler(e), n.touchObject = {}, n.$slider.trigger("swipe", [n, i]))
        } else n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide), n.touchObject = {})
    }, i.prototype.swipeHandler = function(t) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== t.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), t.data.action) {
            case "start":
                e.swipeStart(t);
                break;
            case "move":
                e.swipeMove(t);
                break;
            case "end":
                e.swipeEnd(t)
        }
    }, i.prototype.swipeMove = function(t) {
        var e, i, n, o, s, r = this;
        return s = void 0 !== t.originalEvent ? t.originalEvent.touches : null, !!r.dragging && (!s || 1 === s.length) && (e = r.getLeft(r.currentSlide), r.touchObject.curX = void 0 !== s ? s[0].pageX : t.clientX, r.touchObject.curY = void 0 !== s ? s[0].pageY : t.clientY, r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))), !0 === r.options.verticalSwiping && (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))), "vertical" !== (i = r.swipeDirection()) ? (void 0 !== t.originalEvent && r.touchObject.swipeLength > 4 && t.preventDefault(), o = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1), !0 === r.options.verticalSwiping && (o = r.touchObject.curY > r.touchObject.startY ? 1 : -1), n = r.touchObject.swipeLength, r.touchObject.edgeHit = !1, !1 === r.options.infinite && (0 === r.currentSlide && "right" === i || r.currentSlide >= r.getDotCount() && "left" === i) && (n = r.touchObject.swipeLength * r.options.edgeFriction, r.touchObject.edgeHit = !0), !1 === r.options.vertical ? r.swipeLeft = e + n * o : r.swipeLeft = e + n * (r.$list.height() / r.listWidth) * o, !0 === r.options.verticalSwiping && (r.swipeLeft = e + n * o), !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? (r.swipeLeft = null, !1) : void r.setCSS(r.swipeLeft))) : void 0)
    }, i.prototype.swipeStart = function(t) {
        var e, i = this;
        return i.interrupted = !0, 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow ? (i.touchObject = {}, !1) : (void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]), i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX, i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY, void(i.dragging = !0))
    }, i.prototype.unfilterSlides = i.prototype.slickUnfilter = function() {
        null !== this.$slidesCache && (this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.appendTo(this.$slideTrack), this.reinit())
    }, i.prototype.unload = function() {
        t(".slick-cloned", this.$slider).remove(), this.$dots && this.$dots.remove(), this.$prevArrow && this.htmlExpr.test(this.options.prevArrow) && this.$prevArrow.remove(), this.$nextArrow && this.htmlExpr.test(this.options.nextArrow) && this.$nextArrow.remove(), this.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, i.prototype.unslick = function(t) {
        this.$slider.trigger("unslick", [this, t]), this.destroy()
    }, i.prototype.updateArrows = function() {
        var t;
        t = Math.floor(this.options.slidesToShow / 2), !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && !this.options.infinite && (this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), this.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === this.currentSlide ? (this.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), this.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : this.currentSlide >= this.slideCount - this.options.slidesToShow && !1 === this.options.centerMode ? (this.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : this.currentSlide >= this.slideCount - 1 && !0 === this.options.centerMode && (this.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, i.prototype.updateDots = function() {
        null !== this.$dots && (this.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), this.$dots.find("li").eq(Math.floor(this.currentSlide / this.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
    }, i.prototype.visibility = function() {
        var t = this;
        t.options.autoplay && (document[t.hidden] ? t.interrupted = !0 : t.interrupted = !1)
    }, t.fn.slick = function() {
        var t, e, n = this,
            o = arguments[0],
            s = Array.prototype.slice.call(arguments, 1),
            r = n.length;
        for (t = 0; r > t; t++)
            if ("object" == typeof o || void 0 === o ? n[t].slick = new i(n[t], o) : e = n[t].slick[o].apply(n[t].slick, s), void 0 !== e) return e;
        return n
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
}(window, function(t, e) {
    "use strict";

    function i(i, s, a) {
        (a = a || e || t.jQuery) && (s.prototype.option || (s.prototype.option = function(t) {
            a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t))
        }), a.fn[i] = function(t) {
            if ("string" == typeof t) {
                var e, n, l, c, u, d = o.call(arguments, 1);
                return e = this, n = t, l = d, u = "$()." + i + '("' + n + '")', e.each(function(t, e) {
                    var o = a.data(e, i);
                    if (!o) return void r(i + " not initialized. Cannot call methods, i.e. " + u);
                    var s = o[n];
                    if (!s || "_" == n.charAt(0)) return void r(u + " is not a valid method");
                    var d = s.apply(o, l);
                    c = void 0 === c ? d : c
                }), void 0 !== c ? c : e
            }
            return function t(e, n) {
                e.each(function(t, e) {
                    var o = a.data(e, i);
                    o ? (o.option(n), o._init()) : (o = new s(e, n), a.data(e, i, o))
                })
            }(this, t), this
        }, n(a))
    }

    function n(t) {
        !t || t && t.bridget || (t.bridget = i)
    }
    var o = Array.prototype.slice,
        s = t.console,
        r = void 0 === s ? function() {} : function(t) {
            s.error(t)
        };
    return n(e || t.jQuery), i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {},
                n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e), this
        }
    }, e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {};
            return (i[t] = i[t] || {})[e] = !0, this
        }
    }, e.off = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this
        }
    }, e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0), e = e || [];
            for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                var s = i[o];
                n && n[s] && (this.off(t, s), delete n[s]), s.apply(this, e)
            }
            return this
        }
    }, e.allOff = function() {
        delete this._events, delete this._onceEvents
    }, t
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function() {
    "use strict";

    function t(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }

    function e(t) {
        var e = getComputedStyle(t);
        return e || o("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e
    }

    function i(o) {
        if (function o() {
                if (!a) {
                    a = !0;
                    var s = document.createElement("div");
                    s.style.width = "200px", s.style.padding = "1px 2px 3px 4px", s.style.borderStyle = "solid", s.style.borderWidth = "1px 2px 3px 4px", s.style.boxSizing = "border-box";
                    var r = document.body || document.documentElement;
                    r.appendChild(s), n = 200 == Math.round(t(e(s).width)), i.isBoxSizeOuter = n, r.removeChild(s)
                }
            }(), "string" == typeof o && (o = document.querySelector(o)), o && "object" == typeof o && o.nodeType) {
            var l = e(o);
            if ("none" == l.display) return function t() {
                for (var e = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0
                    }, i = 0; r > i; i++) e[s[i]] = 0;
                return e
            }();
            var c = {};
            c.width = o.offsetWidth, c.height = o.offsetHeight;
            for (var u = c.isBorderBox = "border-box" == l.boxSizing, d = 0; r > d; d++) {
                var p = s[d],
                    h = parseFloat(l[p]);
                c[p] = isNaN(h) ? 0 : h
            }
            var f = c.paddingLeft + c.paddingRight,
                g = c.paddingTop + c.paddingBottom,
                v = c.marginLeft + c.marginRight,
                m = c.marginTop + c.marginBottom,
                y = c.borderLeftWidth + c.borderRightWidth,
                $ = c.borderTopWidth + c.borderBottomWidth,
                b = u && n,
                x = t(l.width);
            !1 !== x && (c.width = x + (b ? 0 : f + y));
            var T = t(l.height);
            return !1 !== T && (c.height = T + (b ? 0 : g + $)), c.innerWidth = c.width - (f + y), c.innerHeight = c.height - (g + $), c.outerWidth = c.width + v, c.outerHeight = c.height + m, c
        }
    }
    var n, o = "undefined" == typeof console ? function t() {} : function(t) {
            console.error(t)
        },
        s = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
        r = s.length,
        a = !1;
    return i
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function() {
    "use strict";
    var t = function() {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n = e[i] + "MatchesSelector";
            if (t[n]) return n
        }
    }();
    return function(e, i) {
        return e[t](i)
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector)
}(window, function(t, e) {
    var i = {};
    i.extend = function(t, e) {
        for (var i in e) t[i] = e[i];
        return t
    }, i.modulo = function(t, e) {
        return (t % e + e) % e
    };
    var n = Array.prototype.slice;
    i.makeArray = function(t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? n.call(t) : [t]
    }, i.removeFrom = function(t, e) {
        var i = t.indexOf(e); - 1 != i && t.splice(i, 1)
    }, i.getParent = function(t, i) {
        for (; t.parentNode && t != document.body;)
            if (e(t = t.parentNode, i)) return t
    }, i.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }, i.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, i.filterFindElements = function(t, n) {
        t = i.makeArray(t);
        var o = [];
        return t.forEach(function(t) {
            if (t instanceof HTMLElement) {
                if (!n) return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), s = 0; s < i.length; s++) o.push(i[s])
            }
        }), o
    }, i.debounceMethod = function(t, e, i) {
        i = i || 100;
        var n = t.prototype[e],
            o = e + "Timeout";
        t.prototype[e] = function() {
            clearTimeout(this[o]);
            var t = arguments,
                e = this;
            this[o] = setTimeout(function() {
                n.apply(e, t), delete e[o]
            }, i)
        }
    }, i.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }, i.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(t, e, i) {
            return e + "-" + i
        }).toLowerCase()
    };
    var o = t.console;
    return i.htmlInit = function(e, n) {
        i.docReady(function() {
            var s = i.toDashed(n),
                r = "data-" + s,
                a = document.querySelectorAll("[" + r + "]"),
                l = document.querySelectorAll(".js-" + s),
                c = i.makeArray(a).concat(i.makeArray(l)),
                u = r + "-options",
                d = t.jQuery;
            c.forEach(function(t) {
                var i, s = t.getAttribute(r) || t.getAttribute(u);
                try {
                    i = s && JSON.parse(s)
                } catch (a) {
                    return void(o && o.error("Error parsing " + r + " on " + t.className + ": " + a))
                }
                var l = new e(t, i);
                d && d.data(t, n, l)
            })
        })
    }, i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize))
}(window, function(t, e) {
    "use strict";

    function i(t, e) {
        t && (this.element = t, this.layout = e, this.position = {
            x: 0,
            y: 0
        }, this._create())
    }
    var n, o = document.documentElement.style,
        s = "string" == typeof o.transition ? "transition" : "WebkitTransition",
        r = "string" == typeof o.transform ? "transform" : "WebkitTransform",
        a = {
            WebkitTransition: "webkitTransitionEnd",
            transition: "transitionend"
        }[s],
        l = {
            transform: r,
            transition: s,
            transitionDuration: s + "Duration",
            transitionProperty: s + "Property",
            transitionDelay: s + "Delay"
        },
        c = i.prototype = Object.create(t.prototype);
    c.constructor = i, c._create = function() {
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        }, this.css({
            position: "absolute"
        })
    }, c.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, c.getSize = function() {
        this.size = e(this.element)
    }, c.css = function(t) {
        var e = this.element.style;
        for (var i in t) e[l[i] || i] = t[i]
    }, c.getPosition = function() {
        var t = getComputedStyle(this.element),
            e = this.layout._getOption("originLeft"),
            i = this.layout._getOption("originTop"),
            n = t[e ? "left" : "right"],
            o = t[i ? "top" : "bottom"],
            s = parseFloat(n),
            r = parseFloat(o),
            a = this.layout.size; - 1 != n.indexOf("%") && (s = s / 100 * a.width), -1 != o.indexOf("%") && (r = r / 100 * a.height), s = isNaN(s) ? 0 : s, r = isNaN(r) ? 0 : r, s -= e ? a.paddingLeft : a.paddingRight, r -= i ? a.paddingTop : a.paddingBottom, this.position.x = s, this.position.y = r
    }, c.layoutPosition = function() {
        var t = this.layout.size,
            e = {},
            i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop"),
            o = i ? "left" : "right",
            s = i ? "right" : "left",
            r = this.position.x + t[i ? "paddingLeft" : "paddingRight"];
        e[o] = this.getXValue(r), e[s] = "";
        var a = n ? "top" : "bottom",
            l = n ? "bottom" : "top",
            c = this.position.y + t[n ? "paddingTop" : "paddingBottom"];
        e[a] = this.getYValue(c), e[l] = "", this.css(e), this.emitEvent("layout", [this])
    }, c.getXValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
    }, c.getYValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
    }, c._transitionTo = function(t, e) {
        this.getPosition();
        var i = this.position.x,
            n = this.position.y,
            o = t == this.position.x && e == this.position.y;
        if (this.setPosition(t, e), o && !this.isTransitioning) return void this.layoutPosition();
        var s = {};
        s.transform = this.getTranslate(t - i, e - n), this.transition({
            to: s,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: !0
        })
    }, c.getTranslate = function(t, e) {
        var i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop");
        return "translate3d(" + (t = i ? t : -t) + "px, " + (e = n ? e : -e) + "px, 0)"
    }, c.goTo = function(t, e) {
        this.setPosition(t, e), this.layoutPosition()
    }, c.moveTo = c._transitionTo, c.setPosition = function(t, e) {
        this.position.x = parseFloat(t), this.position.y = parseFloat(e)
    }, c._nonTransition = function(t) {
        for (var e in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) t.onTransitionEnd[e].call(this)
    }, c.transition = function(t) {
        if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
        var e = this._transn;
        for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
        for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
        if (t.from) {
            this.css(t.from);
            var n = this.element.offsetHeight;
            n = null
        }
        this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
    };
    var u = "opacity," + (n = r).replace(/([A-Z])/g, function(t) {
        return "-" + t.toLowerCase()
    });
    c.enableTransition = function() {
        if (!this.isTransitioning) {
            var t = this.layout.options.transitionDuration;
            t = "number" == typeof t ? t + "ms" : t, this.css({
                transitionProperty: u,
                transitionDuration: t,
                transitionDelay: this.staggerDelay || 0
            }), this.element.addEventListener(a, this, !1)
        }
    }, c.onwebkitTransitionEnd = function(t) {
        this.ontransitionend(t)
    }, c.onotransitionend = function(t) {
        this.ontransitionend(t)
    };
    var d = {
        "-webkit-transform": "transform"
    };
    c.ontransitionend = function(t) {
        if (t.target === this.element) {
            var e = this._transn,
                i = d[t.propertyName] || t.propertyName;
            delete e.ingProperties[i],
                function t(e) {
                    for (var i in e) return !1;
                    return i = null, !0
                }(e.ingProperties) && this.disableTransition(), i in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[i]), i in e.onEnd && (e.onEnd[i].call(this), delete e.onEnd[i]), this.emitEvent("transitionEnd", [this])
        }
    }, c.disableTransition = function() {
        this.removeTransitionStyles(), this.element.removeEventListener(a, this, !1), this.isTransitioning = !1
    }, c._removeStyles = function(t) {
        var e = {};
        for (var i in t) e[i] = "";
        this.css(e)
    };
    var p = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
    };
    return c.removeTransitionStyles = function() {
        this.css(p)
    }, c.stagger = function(t) {
        t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms"
    }, c.removeElem = function() {
        this.element.parentNode.removeChild(this.element), this.css({
            display: ""
        }), this.emitEvent("remove", [this])
    }, c.remove = function() {
        return s && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
            this.removeElem()
        }), void this.hide()) : void this.removeElem()
    }, c.reveal = function() {
        delete this.isHidden, this.css({
            display: ""
        });
        var t = this.layout.options,
            e = {};
        e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, c.onRevealTransitionEnd = function() {
        this.isHidden || this.emitEvent("reveal")
    }, c.getHideRevealTransitionEndProperty = function(t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var i in e) return i
    }, c.hide = function() {
        this.isHidden = !0, this.css({
            display: ""
        });
        var t = this.layout.options,
            e = {};
        e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, c.onHideTransitionEnd = function() {
        this.isHidden && (this.css({
            display: "none"
        }), this.emitEvent("hide"))
    }, c.destroy = function() {
        this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: ""
        })
    }, i
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(i, n, o, s) {
        return e(t, i, n, o, s)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item)
}(window, function(t, e, i, n, o) {
    "use strict";

    function s(t, e) {
        var i = n.getQueryElement(t);
        if (!i) return void(a && a.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
        this.element = i, l && (this.$element = l(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e);
        var o = ++u;
        this.element.outlayerGUID = o, d[o] = this, this._create(), this._getOption("initLayout") && this.layout()
    }

    function r(t) {
        function e() {
            t.apply(this, arguments)
        }
        return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e
    }
    var a = t.console,
        l = t.jQuery,
        c = function() {},
        u = 0,
        d = {};
    s.namespace = "outlayer", s.Item = o, s.defaults = {
        containerStyle: {
            position: "relative"
        },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)"
        },
        visibleStyle: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
    var p = s.prototype;
    n.extend(p, e.prototype), p.option = function(t) {
        n.extend(this.options, t)
    }, p._getOption = function(t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
    }, s.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    }, p._create = function() {
        this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize()
    }, p.reloadItems = function() {
        this.items = this._itemize(this.element.children)
    }, p._itemize = function(t) {
        for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
            var s = e[o],
                r = new i(s, this);
            n.push(r)
        }
        return n
    }, p._filterFindItemElements = function(t) {
        return n.filterFindElements(t, this.options.itemSelector)
    }, p.getItemElements = function() {
        return this.items.map(function(t) {
            return t.element
        })
    }, p.layout = function() {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"),
            e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), this._isLayoutInited = !0
    }, p._init = p.layout, p._resetLayout = function() {
        this.getSize()
    }, p.getSize = function() {
        this.size = i(this.element)
    }, p._getMeasurement = function(t, e) {
        var n, o = this.options[t];
        o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o), this[t] = n ? i(n)[e] : o) : this[t] = 0
    }, p.layoutItems = function(t, e) {
        t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
    }, p._getItemsForLayout = function(t) {
        return t.filter(function(t) {
            return !t.isIgnored
        })
    }, p._layoutItems = function(t, e) {
        if (this._emitCompleteOnItems("layout", t), t && t.length) {
            var i = [];
            t.forEach(function(t) {
                var n = this._getItemLayoutPosition(t);
                n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n)
            }, this), this._processLayoutQueue(i)
        }
    }, p._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        }
    }, p._processLayoutQueue = function(t) {
        this.updateStagger(), t.forEach(function(t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e)
        }, this)
    }, p.updateStagger = function() {
        var t = this.options.stagger;
        return null == t ? void(this.stagger = 0) : (this.stagger = function t(e) {
            if ("number" == typeof e) return e;
            var i = e.match(/(^\d*\.?\d*)(\w*)/),
                n = i && i[1],
                o = i && i[2];
            return n.length ? (n = parseFloat(n)) * (h[o] || 1) : 0
        }(t), this.stagger)
    }, p._positionItem = function(t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i))
    }, p._postLayout = function() {
        this.resizeContainer()
    }, p.resizeContainer = function() {
        if (this._getOption("resizeContainer")) {
            var t = this._getContainerSize();
            t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1))
        }
    }, p._getContainerSize = c, p._setContainerMeasure = function(t, e) {
        if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px"
        }
    }, p._emitCompleteOnItems = function(t, e) {
        function i() {
            o.dispatchEvent(t + "Complete", null, [e])
        }

        function n() {
            ++r == s && i()
        }
        var o = this,
            s = e.length;
        if (!e || !s) return void i();
        var r = 0;
        e.forEach(function(e) {
            e.once(t, n)
        })
    }, p.dispatchEvent = function(t, e, i) {
        var n = e ? [e].concat(i) : i;
        if (this.emitEvent(t, n), l) {
            if (this.$element = this.$element || l(this.element), e) {
                var o = l.Event(e);
                o.type = t, this.$element.trigger(o, i)
            } else this.$element.trigger(t, i)
        }
    }, p.ignore = function(t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0)
    }, p.unignore = function(t) {
        var e = this.getItem(t);
        e && delete e.isIgnored
    }, p.stamp = function(t) {
        (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this))
    }, p.unstamp = function(t) {
        (t = this._find(t)) && t.forEach(function(t) {
            n.removeFrom(this.stamps, t), this.unignore(t)
        }, this)
    }, p._find = function(t) {
        return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t)) : void 0
    }, p._manageStamps = function() {
        this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
    }, p._getBoundingRect = function() {
        var t = this.element.getBoundingClientRect(),
            e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        }
    }, p._manageStamp = c, p._getElementOffset = function(t) {
        var e = t.getBoundingClientRect(),
            n = this._boundingRect,
            o = i(t);
        return {
            left: e.left - n.left - o.marginLeft,
            top: e.top - n.top - o.marginTop,
            right: n.right - e.right - o.marginRight,
            bottom: n.bottom - e.bottom - o.marginBottom
        }
    }, p.handleEvent = n.handleEvent, p.bindResize = function() {
        t.addEventListener("resize", this), this.isResizeBound = !0
    }, p.unbindResize = function() {
        t.removeEventListener("resize", this), this.isResizeBound = !1
    }, p.onresize = function() {
        this.resize()
    }, n.debounceMethod(s, "onresize", 100), p.resize = function() {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }, p.needsResizeLayout = function() {
        var t = i(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth
    }, p.addItems = function(t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e
    }, p.appended = function(t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e))
    }, p.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            var i = this.items.slice(0);
            this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i)
        }
    }, p.reveal = function(t) {
        if (this._emitCompleteOnItems("reveal", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e), t.reveal()
            })
        }
    }, p.hide = function(t) {
        if (this._emitCompleteOnItems("hide", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e), t.hide()
            })
        }
    }, p.revealItemElements = function(t) {
        var e = this.getItems(t);
        this.reveal(e)
    }, p.hideItemElements = function(t) {
        var e = this.getItems(t);
        this.hide(e)
    }, p.getItem = function(t) {
        for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t) return i
        }
    }, p.getItems = function(t) {
        t = n.makeArray(t);
        var e = [];
        return t.forEach(function(t) {
            var i = this.getItem(t);
            i && e.push(i)
        }, this), e
    }, p.remove = function(t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function(t) {
            t.remove(), n.removeFrom(this.items, t)
        }, this)
    }, p.destroy = function() {
        var t = this.element.style;
        t.height = "", t.position = "", t.width = "", this.items.forEach(function(t) {
            t.destroy()
        }), this.unbindResize(), delete d[this.element.outlayerGUID], delete this.element.outlayerGUID, l && l.removeData(this.element, this.constructor.namespace)
    }, s.data = function(t) {
        var e = (t = n.getQueryElement(t)) && t.outlayerGUID;
        return e && d[e]
    }, s.create = function(t, e) {
        var i = r(s);
        return i.defaults = n.extend({}, s.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, s.compatOptions), i.namespace = t, i.data = s.data, i.Item = r(o), n.htmlInit(i, t), l && l.bridget && l.bridget(t, i), i
    };
    var h = {
        ms: 1,
        s: 1e3
    };
    return s.Item = o, s
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
}(window, function(t, e) {
    var i = t.create("masonry");
    i.compatOptions.fitWidth = "isFitWidth";
    var n = i.prototype;
    return n._resetLayout = function() {
        this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        this.maxY = 0, this.horizontalColIndex = 0
    }, n.measureColumns = function() {
        if (this.getContainerWidth(), !this.columnWidth) {
            var t = this.items[0],
                i = t && t.element;
            this.columnWidth = i && e(i).outerWidth || this.containerWidth
        }
        var n = this.columnWidth += this.gutter,
            o = this.containerWidth + this.gutter,
            s = o / n,
            r = n - o % n;
        s = Math[r && 1 > r ? "round" : "floor"](s), this.cols = Math.max(s, 1)
    }, n.getContainerWidth = function() {
        var t = e(this._getOption("fitWidth") ? this.element.parentNode : this.element);
        this.containerWidth = t && t.innerWidth
    }, n._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth,
            i = Math[e && 1 > e ? "round" : "ceil"](t.size.outerWidth / this.columnWidth);
        i = Math.min(i, this.cols);
        for (var n = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", o = this[n](i, t), s = {
                x: this.columnWidth * o.col,
                y: o.y
            }, r = o.y + t.size.outerHeight, a = i + o.col, l = o.col; a > l; l++) this.colYs[l] = r;
        return s
    }, n._getTopColPosition = function(t) {
        var e = this._getTopColGroup(t),
            i = Math.min.apply(Math, e);
        return {
            col: e.indexOf(i),
            y: i
        }
    }, n._getTopColGroup = function(t) {
        if (2 > t) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) e[n] = this._getColGroupY(n, t);
        return e
    }, n._getColGroupY = function(t, e) {
        if (2 > e) return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i)
    }, n._getHorizontalColPosition = function(t, e) {
        var i = this.horizontalColIndex % this.cols;
        i = t > 1 && i + t > this.cols ? 0 : i;
        var n = e.size.outerWidth && e.size.outerHeight;
        return this.horizontalColIndex = n ? i + t : this.horizontalColIndex, {
            col: i,
            y: this._getColGroupY(i, t)
        }
    }, n._manageStamp = function(t) {
        var i = e(t),
            n = this._getElementOffset(t),
            o = this._getOption("originLeft") ? n.left : n.right,
            s = o + i.outerWidth,
            r = Math.floor(o / this.columnWidth);
        r = Math.max(0, r);
        var a = Math.floor(s / this.columnWidth);
        a -= s % this.columnWidth ? 0 : 1, a = Math.min(this.cols - 1, a);
        for (var l = this._getOption("originTop"), c = (l ? n.top : n.bottom) + i.outerHeight, u = r; a >= u; u++) this.colYs[u] = Math.max(c, this.colYs[u])
    }, n._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {
            height: this.maxY
        };
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t
    }, n._getContainerFitWidth = function() {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) t++;
        return (this.cols - t) * this.columnWidth - this.gutter
    }, n.needsResizeLayout = function() {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth
    }, i
});